import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { InjectionToken, Component, Optional, Inject, Input, NgModule, Injectable, Directive, ElementRef, Pipe, LOCALE_ID, ɵɵdefineInjectable, ɵɵinject, NgZone, EventEmitter, forwardRef, Output, ViewContainerRef, TemplateRef, Self, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { template, remove, map as map$1, find, sortBy, filter, isObject, assign, isArray, isString, cloneDeep, union, pick, isEqual, keyBy, findIndex } from 'lodash-es';
import { trigger, transition, style, animate } from '@angular/animations';
import { ReplaySubject, timer, of, Subject, combineLatest, throwError, Observable, from } from 'rxjs';
import { takeUntil, map, first, debounceTime, distinctUntilChanged, switchMap, tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule, FormBuilder } from '@angular/forms';
import { NgbModal, NgbDateParserFormatter, NgbActiveModal, NgbModalModule, NgbTooltipModule, NgbModule, NgbTypeaheadModule, NgbPaginationModule, NgbCollapseModule, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import format from 'date-fns/format';
import { DSRestCollection } from '@solidev/ngdataservice';
import { __awaiter } from 'tslib';
import { parse, format as format$1 } from 'date-fns';
import { DomSanitizer } from '@angular/platform-browser';
import { moveItemInArray, transferArrayItem, DragDropModule } from '@angular/cdk/drag-drop';

/**
 * BSAC_ISSUE_CONFIG injection token.
 *
 * If used, provides default values for BsacIssueComponent.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from '@solidev/ngdataservice';
import * as ɵngcc7 from '@angular/platform-browser';
import * as ɵngcc8 from '@angular/cdk/drag-drop';

function BsacIssueComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 1);
    ɵngcc0.ɵɵelement(1, "i", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate3("href", "", ctx_r0.server, "/", ctx_r0.project, "/", ctx_r0.issue, "", ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("#", ctx_r0.issue, "");
} }
function BsacIssueComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 1);
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate3("href", "", ctx_r1.server, "/", ctx_r1.project, "/issues??scope=all&utf8=\u2713&state=opened&search=", ctx_r1.view, "", ɵngcc0.ɵɵsanitizeUrl);
} }
function BsacVersionComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2("v", ctx_r0.version, "-", ctx_r0.build, "");
} }
function BsacVersionComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("v", ctx_r1.version, "");
} }
function BsacBreadcrumbComponent_ng_container_2_li_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const p_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", p_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(p_r1.title);
} }
function BsacBreadcrumbComponent_ng_container_2_li_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const p_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(p_r1.title);
} }
function BsacBreadcrumbComponent_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 5);
    ɵngcc0.ɵɵelementStart(1, "a", 6);
    ɵngcc0.ɵɵtemplate(2, BsacBreadcrumbComponent_ng_container_2_li_1_ng_container_2_Template, 3, 2, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(3, BsacBreadcrumbComponent_ng_container_2_li_1_ng_container_3_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", p_r1.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.icons && p_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.icons && p_r1.icon));
} }
function BsacBreadcrumbComponent_ng_container_2_li_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const p_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", p_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(p_r1.title);
} }
function BsacBreadcrumbComponent_ng_container_2_li_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const p_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(p_r1.title);
} }
function BsacBreadcrumbComponent_ng_container_2_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 9);
    ɵngcc0.ɵɵtemplate(1, BsacBreadcrumbComponent_ng_container_2_li_2_ng_container_1_Template, 3, 2, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(2, BsacBreadcrumbComponent_ng_container_2_li_2_ng_container_2_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const p_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.icons && p_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r3.icons && p_r1.icon));
} }
function BsacBreadcrumbComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacBreadcrumbComponent_ng_container_2_li_1_Template, 4, 3, "li", 3);
    ɵngcc0.ɵɵtemplate(2, BsacBreadcrumbComponent_ng_container_2_li_2_Template, 3, 2, "li", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const p_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !p_r1.current);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", p_r1.current);
} }
function BsacMessagesZoneComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(message_r1.trace);
} }
function BsacMessagesZoneComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function BsacMessagesZoneComponent_div_1_Template_div_click_0_listener() { const message_r1 = ctx.$implicit; return message_r1.showTrace = !message_r1.showTrace; });
    ɵngcc0.ɵɵelementStart(1, "button", 3);
    ɵngcc0.ɵɵlistener("click", function BsacMessagesZoneComponent_div_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const message_r1 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.messages.ack(message_r1); });
    ɵngcc0.ɵɵelementStart(2, "span", 4);
    ɵngcc0.ɵɵtext(3, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "strong");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵtemplate(7, BsacMessagesZoneComponent_div_1_div_7_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassMap(message_r1.style);
    ɵngcc0.ɵɵproperty("@dispStatus", message_r1.status);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(message_r1.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0 ", message_r1.message, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", message_r1.showTrace);
} }
function BsacDatetimeInputComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r2.curdate, ctx_r2.dateFormat));
} }
function BsacDatetimeInputComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "????");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BsacDatetimeInputComponent_ng_container_0_ng_template_5_ngb_timepicker_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function BsacDatetimeInputComponent_ng_container_0_ng_template_5_ngb_timepicker_3_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.ttime = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.ttime)("seconds", false);
} }
function BsacDatetimeInputComponent_ng_container_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "ngb-datepicker", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function BsacDatetimeInputComponent_ng_container_0_ng_template_5_Template_ngb_datepicker_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.ddate = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, BsacDatetimeInputComponent_ng_container_0_ng_template_5_ngb_timepicker_3_Template, 1, 2, "ngb-timepicker", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelementStart(5, "button", 9);
    ɵngcc0.ɵɵlistener("click", function BsacDatetimeInputComponent_ng_container_0_ng_template_5_Template_button_click_5_listener() { const c_r6 = ctx.close; return c_r6("save"); });
    ɵngcc0.ɵɵelement(6, "i", 10);
    ɵngcc0.ɵɵtext(7, "Enregistrer");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 11);
    ɵngcc0.ɵɵlistener("click", function BsacDatetimeInputComponent_ng_container_0_ng_template_5_Template_button_click_8_listener() { const d_r7 = ctx.dismiss; return d_r7("cancel"); });
    ɵngcc0.ɵɵelement(9, "i", 12);
    ɵngcc0.ɵɵtext(10, "Annuler");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.ddate)("startDate", ctx_r5.ddate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.dateOnly);
} }
function BsacDatetimeInputComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 1);
    ɵngcc0.ɵɵlistener("click", function BsacDatetimeInputComponent_ng_container_0_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); const _r4 = ɵngcc0.ɵɵreference(6); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.openModal(_r4); });
    ɵngcc0.ɵɵelement(2, "i", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDatetimeInputComponent_ng_container_0_ng_container_3_Template, 3, 4, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(4, BsacDatetimeInputComponent_ng_container_0_ng_container_4_Template, 2, 0, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, BsacDatetimeInputComponent_ng_container_0_ng_template_5_Template, 11, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.curdate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.curdate);
} }
function BsacDatetimeInputComponent_ng_container_1_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 22);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacDatetimeInputComponent_ng_container_1_input_4_Template_input_keyup_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.enter.emit(); })("keyup.escape", function BsacDatetimeInputComponent_ng_container_1_input_4_Template_input_keyup_escape_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.escape.emit(); });
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDatetimeInputComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "form", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "input", 16);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacDatetimeInputComponent_ng_container_1_Template_input_keyup_enter_3_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.enter.emit(); })("keyup.escape", function BsacDatetimeInputComponent_ng_container_1_Template_input_keyup_escape_3_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.escape.emit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BsacDatetimeInputComponent_ng_container_1_input_4_Template, 1, 0, "input", 17);
    ɵngcc0.ɵɵelementStart(5, "div", 18);
    ɵngcc0.ɵɵelementStart(6, "button", 19);
    ɵngcc0.ɵɵlistener("click", function BsacDatetimeInputComponent_ng_container_1_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.enter.emit(); });
    ɵngcc0.ɵɵelement(7, "i", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 19);
    ɵngcc0.ɵɵlistener("click", function BsacDatetimeInputComponent_ng_container_1_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.escape.emit(); });
    ɵngcc0.ɵɵelement(9, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.nativeForm);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.dateOnly);
} }
function BsacDdFieldComponent_bsac_i18n_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bsac-i18n", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ref", ctx_r0.i18n)("type", ctx_r0.type);
} }
function BsacDdFieldComponent_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "custom"]);
} }
function BsacDdFieldComponent_ng_content_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1, ["*ngIf", "!custom"]);
} }
function BsacDdFieldComponent_dd_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.changeMode(true); });
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.changeMode(true); });
    ɵngcc0.ɵɵelementContainerStart(1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.model[ctx_r9.field] || "???");
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_2_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.changeMode(true); });
    ɵngcc0.ɵɵelementContainerStart(1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.model[ctx_r10.field] || "???");
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "???");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r25.model[ctx_r25.field]);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.changeMode(true); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_3_span_1_Template, 2, 0, "span", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_3_span_2_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.model[ctx_r11.field] === null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.model[ctx_r11.field] !== null);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "???");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r30.model[ctx_r30.field] / ctx_r30.factor);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r31.model[ctx_r31.field]);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_2_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_2_ng_container_2_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.factor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r29.factor);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(3); return ctx_r32.changeMode(true); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_1_Template, 2, 0, "span", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_4_span_2_Template, 3, 2, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.model[ctx_r12.field] === null || ctx_r12.model[ctx_r12.field] === undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r12.model[ctx_r12.field] === null || ctx_r12.model[ctx_r12.field] === undefined));
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r34 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r34.model[ctx_r34.field], ctx_r34.dateFormat));
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "????");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_5_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(3); return ctx_r36.changeMode(true); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_5_ng_container_1_Template, 3, 4, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_5_ng_container_2_Template, 2, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.model[ctx_r13.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r13.model[ctx_r13.field]);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r38.model[ctx_r38.field], ctx_r38.dateFormat));
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "????");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_6_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r41); const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.changeMode(true); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_6_ng_container_1_Template, 3, 4, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_6_ng_container_2_Template, 2, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.model[ctx_r14.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r14.model[ctx_r14.field]);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_7_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ctx_r42.changeMode(true); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r15.getDesc(ctx_r15.model[ctx_r15.field])));
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_8_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "i", 10);
    ɵngcc0.ɵɵtext(2, "Yes");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_8_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵtext(2, "No");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_8_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r47); const ctx_r46 = ɵngcc0.ɵɵnextContext(3); return ctx_r46.changeMode(true); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_8_span_1_Template, 3, 0, "span", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_8_span_2_Template, 3, 0, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.model[ctx_r16.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r16.model[ctx_r16.field]);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_9_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r48.tpl(ctx_r48.model[ctx_r48.field + "_details"]));
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_9_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r49.model[ctx_r49.field] || ctx_r49.relatedEmpty);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r51 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_9_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r51); const ctx_r50 = ɵngcc0.ɵɵnextContext(3); return ctx_r50.changeMode(true); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_9_span_1_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_9_span_2_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r17.tpl && ctx_r17.model[ctx_r17.field + "_details"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r17.tpl || !ctx_r17.model[ctx_r17.field + "_details"]);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "bsac-m2m-field", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r18.model)("field", ctx_r18.field)("edit", ctx_r18.edit)("desctpl", ctx_r18.desctpl)("descfield", ctx_r18.descfield)("related", ctx_r18.related)("relatedFilter", ctx_r18.relatedFilter)("readonly", !ctx_r18.editable)("m2mLink", ctx_r18.relatedLink);
} }
function BsacDdFieldComponent_dd_5_ng_container_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_5_ng_container_2_div_11_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r53); const ctx_r52 = ɵngcc0.ɵɵnextContext(3); return ctx_r52.changeMode(true); });
    ɵngcc0.ɵɵelementStart(1, "pre");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r19.json || "????");
} }
function BsacDdFieldComponent_dd_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_ng_container_2_div_1_Template, 3, 1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_div_2_Template, 3, 1, "div", 8);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_5_ng_container_2_div_3_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_5_ng_container_2_div_4_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_5_ng_container_2_div_5_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(6, BsacDdFieldComponent_dd_5_ng_container_2_div_6_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(7, BsacDdFieldComponent_dd_5_ng_container_2_div_7_Template, 3, 3, "div", 6);
    ɵngcc0.ɵɵtemplate(8, BsacDdFieldComponent_dd_5_ng_container_2_div_8_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(9, BsacDdFieldComponent_dd_5_ng_container_2_div_9_Template, 3, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(10, BsacDdFieldComponent_dd_5_ng_container_2_div_10_Template, 2, 9, "div", 2);
    ɵngcc0.ɵɵtemplate(11, BsacDdFieldComponent_dd_5_ng_container_2_div_11_Template, 3, 1, "div", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "textarea");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "number");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "decimal");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "date");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "datetime");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "boolean");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "foreignkey");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "manytomany");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.type == "json");
} }
function BsacDdFieldComponent_dd_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dd", 5);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_5_div_1_Template, 2, 0, "div", 6);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_5_ng_container_2_Template, 12, 11, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.custom);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.custom);
} }
function BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_1_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_2_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_3_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_4_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_6_ng_container_2_div_2_div_5_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r65.editForm.get("edit").errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r65.editForm.get("edit").errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r65.editForm.get("edit").errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r65.editForm.get("edit").errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r65.editForm.get("edit").errors.choices);
} }
function BsacDdFieldComponent_dd_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r72 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 17);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacDdFieldComponent_dd_6_ng_container_2_Template_input_keyup_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r71 = ɵngcc0.ɵɵnextContext(2); return ctx_r71.save(); })("keyup.escape", function BsacDdFieldComponent_dd_6_ng_container_2_Template_input_keyup_escape_1_listener() { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r73 = ɵngcc0.ɵɵnextContext(2); return (ctx_r73.edit[ctx_r73.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_2_div_2_Template, 6, 5, "div", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r54 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r54.editForm.get("edit").invalid);
} }
function BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_1_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_2_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_3_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_4_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_6_ng_container_3_div_2_div_5_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r74.editForm.get("edit").errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r74.editForm.get("edit").errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r74.editForm.get("edit").errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r74.editForm.get("edit").errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r74.editForm.get("edit").errors.choices);
} }
function BsacDdFieldComponent_dd_6_ng_container_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r82 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_6_ng_container_3_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r82); const ctx_r81 = ɵngcc0.ɵɵnextContext(3); return ctx_r81.save(); });
    ɵngcc0.ɵɵelement(1, "i", 23);
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r84 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "textarea", 20);
    ɵngcc0.ɵɵlistener("keydown.control.enter", function BsacDdFieldComponent_dd_6_ng_container_3_Template_textarea_keydown_control_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r84); const ctx_r83 = ɵngcc0.ɵɵnextContext(2); return ctx_r83.save(); })("keyup.escape", function BsacDdFieldComponent_dd_6_ng_container_3_Template_textarea_keyup_escape_1_listener() { ɵngcc0.ɵɵrestoreView(_r84); const ctx_r85 = ɵngcc0.ɵɵnextContext(2); return (ctx_r85.edit[ctx_r85.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_3_div_2_Template, 6, 5, "div", 18);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_3_button_3_Template, 2, 0, "button", 21);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r55 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r55.editForm.get("edit").invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r55.btn);
} }
function BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop petit");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop grand");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_1_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_2_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_3_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_4_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_6_ng_container_4_div_2_div_5_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r86 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r86.editForm.get("edit").errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r86.editForm.get("edit").errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r86.editForm.get("edit").errors.min);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r86.editForm.get("edit").errors.max);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r86.editForm.get("edit").errors.choices);
} }
function BsacDdFieldComponent_dd_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r93 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 24);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacDdFieldComponent_dd_6_ng_container_4_Template_input_keyup_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r93); const ctx_r92 = ɵngcc0.ɵɵnextContext(2); return ctx_r92.save(); })("keyup.escape", function BsacDdFieldComponent_dd_6_ng_container_4_Template_input_keyup_escape_1_listener() { ɵngcc0.ɵɵrestoreView(_r93); const ctx_r94 = ɵngcc0.ɵɵnextContext(2); return (ctx_r94.edit[ctx_r94.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_4_div_2_Template, 6, 5, "div", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r56 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r56.editForm.get("edit").invalid);
} }
function BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop petit");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop grand");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_1_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_2_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_3_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_4_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_6_ng_container_5_div_2_div_5_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r95 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r95.editForm.get("edit").errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r95.editForm.get("edit").errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r95.editForm.get("edit").errors.min);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r95.editForm.get("edit").errors.max);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r95.editForm.get("edit").errors.choices);
} }
function BsacDdFieldComponent_dd_6_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r102 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "bsac-decimal-input", 25);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacDdFieldComponent_dd_6_ng_container_5_Template_bsac_decimal_input_keyup_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r101 = ɵngcc0.ɵɵnextContext(2); return ctx_r101.save(); })("keyup.escape", function BsacDdFieldComponent_dd_6_ng_container_5_Template_bsac_decimal_input_keyup_escape_1_listener() { ɵngcc0.ɵɵrestoreView(_r102); const ctx_r103 = ɵngcc0.ɵɵnextContext(2); return (ctx_r103.edit[ctx_r103.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_5_div_2_Template, 6, 5, "div", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r57 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("factor", ctx_r57.factor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r57.editForm.get("edit").invalid);
} }
function BsacDdFieldComponent_dd_6_bsac_datetime_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r105 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bsac-datetime-input", 26);
    ɵngcc0.ɵɵlistener("enter", function BsacDdFieldComponent_dd_6_bsac_datetime_input_6_Template_bsac_datetime_input_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r105); const ctx_r104 = ɵngcc0.ɵɵnextContext(2); return ctx_r104.save(); })("escape", function BsacDdFieldComponent_dd_6_bsac_datetime_input_6_Template_bsac_datetime_input_escape_0_listener() { ɵngcc0.ɵɵrestoreView(_r105); const ctx_r106 = ɵngcc0.ɵɵnextContext(2); return (ctx_r106.edit[ctx_r106.field] = false); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("native", ctx_r58.native)("dateOnly", true)("defaultTime", ctx_r58.defaultTime)("dateFormat", ctx_r58.dateFormat)("dateFormatter", ctx_r58.dateFormatter)("timeFormatter", ctx_r58.timeFormatter);
} }
function BsacDdFieldComponent_dd_6_bsac_datetime_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r108 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "bsac-datetime-input", 27);
    ɵngcc0.ɵɵlistener("enter", function BsacDdFieldComponent_dd_6_bsac_datetime_input_7_Template_bsac_datetime_input_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r108); const ctx_r107 = ɵngcc0.ɵɵnextContext(2); return ctx_r107.save(); })("escape", function BsacDdFieldComponent_dd_6_bsac_datetime_input_7_Template_bsac_datetime_input_escape_0_listener() { ɵngcc0.ɵɵrestoreView(_r108); const ctx_r109 = ɵngcc0.ɵɵnextContext(2); return (ctx_r109.edit[ctx_r109.field] = false); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("native", ctx_r59.native)("dateFormat", ctx_r59.dateFormat)("dateFormatter", ctx_r59.dateFormatter)("timeFormatter", ctx_r59.timeFormatter);
} }
function BsacDdFieldComponent_dd_6_select_8_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 30);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const o_r111 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", o_r111.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(o_r111.desc);
} }
function BsacDdFieldComponent_dd_6_select_8_Template(rf, ctx) { if (rf & 1) {
    const _r113 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 28);
    ɵngcc0.ɵɵlistener("change", function BsacDdFieldComponent_dd_6_select_8_Template_select_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r113); const ctx_r112 = ɵngcc0.ɵɵnextContext(2); return ctx_r112.save($event.target.value); })("keyup.escape", function BsacDdFieldComponent_dd_6_select_8_Template_select_keyup_escape_0_listener() { ɵngcc0.ɵɵrestoreView(_r113); const ctx_r114 = ɵngcc0.ɵɵnextContext(2); return (ctx_r114.edit[ctx_r114.field] = false); });
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_6_select_8_option_1_Template, 2, 2, "option", 29);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r60.getChoices()));
} }
function BsacDdFieldComponent_dd_6_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r116 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 31);
    ɵngcc0.ɵɵelementStart(2, "input", 32);
    ɵngcc0.ɵɵlistener("change", function BsacDdFieldComponent_dd_6_div_9_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r116); const ctx_r115 = ɵngcc0.ɵɵnextContext(2); ctx_r115.save(); return (ctx_r115.edit[ctx_r115.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 33);
    ɵngcc0.ɵɵelementStart(4, "span", 34);
    ɵngcc0.ɵɵtext(5, "Yes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "label", 31);
    ɵngcc0.ɵɵelementStart(7, "input", 32);
    ɵngcc0.ɵɵlistener("change", function BsacDdFieldComponent_dd_6_div_9_Template_input_change_7_listener() { ɵngcc0.ɵɵrestoreView(_r116); const ctx_r117 = ɵngcc0.ɵɵnextContext(2); ctx_r117.save(); return (ctx_r117.edit[ctx_r117.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "span", 33);
    ɵngcc0.ɵɵelementStart(9, "span", 34);
    ɵngcc0.ɵɵtext(10, "No");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("value", false);
} }
function BsacDdFieldComponent_dd_6_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r119 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "bsac-select-related", 35);
    ɵngcc0.ɵɵlistener("selected", function BsacDdFieldComponent_dd_6_div_10_Template_bsac_select_related_selected_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r119); const ctx_r118 = ɵngcc0.ɵɵnextContext(2); return ctx_r118.onFkSelect($event); })("clear", function BsacDdFieldComponent_dd_6_div_10_Template_bsac_select_related_clear_1_listener() { ɵngcc0.ɵɵrestoreView(_r119); const ctx_r120 = ɵngcc0.ɵɵnextContext(2); return ctx_r120.onFkClear(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("queryset", ctx_r62.related.queryset)("context", ctx_r62.relatedParams)("desctpl", ctx_r62.desctpl)("descfield", ctx_r62.descfield)("label", ctx_r62.relatedLabel)("filter", ctx_r62.relatedFilter)("reset", ctx_r62.relatedReset)("searchparam", ctx_r62.relatedSearchparam);
} }
function BsacDdFieldComponent_dd_6_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r122 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "bsac-m2m-field", 36);
    ɵngcc0.ɵɵlistener("m2mChanged", function BsacDdFieldComponent_dd_6_div_11_Template_bsac_m2m_field_m2mChanged_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r122); const ctx_r121 = ɵngcc0.ɵɵnextContext(2); return ctx_r121.onM2mChanged($event); });
    ɵngcc0.ɵɵelementStart(2, "span", 37);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r63.model)("field", ctx_r63.field)("edit", ctx_r63.edit)("desctpl", ctx_r63.desctpl)("descfield", ctx_r63.descfield)("relatedParams", ctx_r63.relatedParams)("related", ctx_r63.related)("relatedFilter", ctx_r63.relatedFilter)("m2mLink", ctx_r63.relatedLink);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r63.relatedLabel);
} }
function BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_12_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_1_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_2_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_3_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_4_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_6_ng_container_12_div_2_div_5_Template, 2, 0, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r123 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r123.editForm.get("edit").errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r123.editForm.get("edit").errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r123.editForm.get("edit").errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r123.editForm.get("edit").errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r123.editForm.get("edit").errors.choices);
} }
function BsacDdFieldComponent_dd_6_ng_container_12_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r131 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_dd_6_ng_container_12_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r131); const ctx_r130 = ɵngcc0.ɵɵnextContext(3); return ctx_r130.save(); });
    ɵngcc0.ɵɵelement(1, "i", 23);
    ɵngcc0.ɵɵelementEnd();
} }
function BsacDdFieldComponent_dd_6_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r133 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "textarea", 20);
    ɵngcc0.ɵɵlistener("keydown.control.enter", function BsacDdFieldComponent_dd_6_ng_container_12_Template_textarea_keydown_control_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r133); const ctx_r132 = ɵngcc0.ɵɵnextContext(2); return ctx_r132.save(); })("keyup.escape", function BsacDdFieldComponent_dd_6_ng_container_12_Template_textarea_keyup_escape_1_listener() { ɵngcc0.ɵɵrestoreView(_r133); const ctx_r134 = ɵngcc0.ɵɵnextContext(2); return (ctx_r134.edit[ctx_r134.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_12_div_2_Template, 6, 5, "div", 18);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_12_button_3_Template, 2, 0, "button", 21);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r64 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r64.editForm.get("edit").invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r64.btn);
} }
function BsacDdFieldComponent_dd_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dd");
    ɵngcc0.ɵɵelementStart(1, "form", 13);
    ɵngcc0.ɵɵtemplate(2, BsacDdFieldComponent_dd_6_ng_container_2_Template, 3, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_dd_6_ng_container_3_Template, 4, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_dd_6_ng_container_4_Template, 3, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_6_ng_container_5_Template, 3, 2, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(6, BsacDdFieldComponent_dd_6_bsac_datetime_input_6_Template, 1, 6, "bsac-datetime-input", 14);
    ɵngcc0.ɵɵtemplate(7, BsacDdFieldComponent_dd_6_bsac_datetime_input_7_Template, 1, 4, "bsac-datetime-input", 15);
    ɵngcc0.ɵɵtemplate(8, BsacDdFieldComponent_dd_6_select_8_Template, 3, 3, "select", 16);
    ɵngcc0.ɵɵtemplate(9, BsacDdFieldComponent_dd_6_div_9_Template, 11, 2, "div", 2);
    ɵngcc0.ɵɵtemplate(10, BsacDdFieldComponent_dd_6_div_10_Template, 2, 8, "div", 2);
    ɵngcc0.ɵɵtemplate(11, BsacDdFieldComponent_dd_6_div_11_Template, 4, 10, "div", 2);
    ɵngcc0.ɵɵtemplate(12, BsacDdFieldComponent_dd_6_ng_container_12_Template, 4, 2, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r4.editForm);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "textarea");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "number");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "decimal");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "date");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "datetime");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "boolean");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "foreignkey");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "manytomany");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.type == "json");
} }
const _c0 = [[["", 8, "desc"]], "*", [["", 8, "value"]]];
const _c1 = [".desc", "*", ".value"];
function BsacFieldControlComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 4);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_5_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_5_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_5_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_5_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_5_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_5_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_5_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_5_div_4_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_5_div_4_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_5_div_4_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.form.get(ctx_r14.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.form.get(ctx_r14.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.form.get(ctx_r14.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.form.get(ctx_r14.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.form.get(ctx_r14.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "input", 6);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_5_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_5_div_4_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r2.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r2.field)("formControlName", ctx_r2.field)("placeholder", ctx_r2.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.form.get(ctx_r2.field).invalid);
} }
function BsacFieldControlComponent_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_6_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_6_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop petit");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_6_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop grand");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_6_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_6_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_6_div_4_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.form.get(ctx_r21.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.form.get(ctx_r21.field).errors.min);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.form.get(ctx_r21.field).errors.max);
} }
function BsacFieldControlComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "bsac-decimal-input", 11);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_6_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_6_div_4_Template, 4, 3, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r3.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r3.field)("placeholder", ctx_r3.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.form.get(ctx_r3.field).invalid);
} }
function BsacFieldControlComponent_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_7_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_7_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_7_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_7_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_7_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_7_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_7_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_7_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_7_div_4_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_7_div_4_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_7_div_4_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.form.get(ctx_r26.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.form.get(ctx_r26.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.form.get(ctx_r26.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.form.get(ctx_r26.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.form.get(ctx_r26.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "input", 6);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_7_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_7_div_4_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r4.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r4.field)("formControlName", ctx_r4.field)("placeholder", ctx_r4.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.form.get(ctx_r4.field).invalid);
} }
function BsacFieldControlComponent_ng_container_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_8_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_8_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_8_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_8_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_8_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_8_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_8_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_8_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_8_div_4_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_8_div_4_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_8_div_4_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r33.form.get(ctx_r33.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r33.form.get(ctx_r33.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r33.form.get(ctx_r33.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r33.form.get(ctx_r33.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r33.form.get(ctx_r33.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "textarea", 12);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_8_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_8_div_4_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r5.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r5.field)("formControlName", ctx_r5.field)("placeholder", ctx_r5.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.form.get(ctx_r5.field).invalid);
} }
function BsacFieldControlComponent_ng_container_9_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const o_r42 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", o_r42[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(o_r42[1]);
} }
function BsacFieldControlComponent_ng_container_9_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_9_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_9_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_9_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_9_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_9_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_9_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_9_div_5_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_9_div_5_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_9_div_5_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_9_div_5_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_9_div_5_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r41.form.get(ctx_r41.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r41.form.get(ctx_r41.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r41.form.get(ctx_r41.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r41.form.get(ctx_r41.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r41.form.get(ctx_r41.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "select", 13);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_9_option_3_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_9_ng_container_4_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_9_div_5_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r6.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r6.field)("formControlName", ctx_r6.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.choices);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.form.get(ctx_r6.field).invalid);
} }
function BsacFieldControlComponent_ng_container_10_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_10_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_10_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_10_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_10_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_10_div_10_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_10_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_10_div_10_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_10_div_10_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_10_div_10_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_10_div_10_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_10_div_10_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r49.form.get(ctx_r49.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r49.form.get(ctx_r49.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r49.form.get(ctx_r49.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r49.form.get(ctx_r49.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r49.form.get(ctx_r49.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 16);
    ɵngcc0.ɵɵelementStart(3, "label", 17);
    ɵngcc0.ɵɵelement(4, "input", 18);
    ɵngcc0.ɵɵtext(5, "Oui");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "label", 17);
    ɵngcc0.ɵɵelement(7, "input", 18);
    ɵngcc0.ɵɵtext(8, "Non");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, BsacFieldControlComponent_ng_container_10_ng_container_9_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(10, BsacFieldControlComponent_ng_container_10_div_10_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r7.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r7.field);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("value", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.form.get(ctx_r7.field).invalid);
} }
function BsacFieldControlComponent_ng_container_11_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_11_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_11_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_11_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_11_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_11_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r56.form.get(ctx_r56.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r56.form.get(ctx_r56.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "bsac-datetime-input", 19);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_11_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_11_div_4_Template, 3, 2, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r8.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("native", ctx_r8.native)("formControlName", ctx_r8.field)("dateFormatter", ctx_r8.dateFormatter)("timeFormatter", ctx_r8.timeFormatter)("defaultTime", ctx_r8.defaultTime);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.form.get(ctx_r8.field).invalid);
} }
function BsacFieldControlComponent_ng_container_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 20);
    ɵngcc0.ɵɵelement(3, "input", 21, 22);
    ɵngcc0.ɵɵelementStart(5, "div", 23);
    ɵngcc0.ɵɵelementStart(6, "button", 24);
    ɵngcc0.ɵɵlistener("click", function BsacFieldControlComponent_ng_container_12_ng_container_1_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r65); const _r63 = ɵngcc0.ɵɵreference(4); return _r63.toggle(); });
    ɵngcc0.ɵɵelement(7, "i", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r59 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r59.cform);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", "date");
} }
function BsacFieldControlComponent_ng_container_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "bsac-datetime-input", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r60 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r60.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("native", true)("formControlName", ctx_r60.field)("dateFormatter", ctx_r60.dateFormatter)("timeFormatter", ctx_r60.timeFormatter)("defaultTime", ctx_r60.defaultTime)("dateOnly", true);
} }
function BsacFieldControlComponent_ng_container_12_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_12_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_12_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_12_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_12_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_12_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r62.form.get(ctx_r62.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r62.form.get(ctx_r62.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_12_ng_container_1_Template, 8, 2, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_12_ng_container_2_Template, 3, 7, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_12_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_12_div_4_Template, 3, 2, "div", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r9.native);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.native);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.form.get(ctx_r9.field).invalid);
} }
function BsacFieldControlComponent_ng_container_13_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_13_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r72 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "input", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function BsacFieldControlComponent_ng_container_13_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r71 = ɵngcc0.ɵɵnextContext(2); return ctx_r71.thvalue = $event; })("selectItem", function BsacFieldControlComponent_ng_container_13_div_1_Template_input_selectItem_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r73 = ɵngcc0.ɵɵnextContext(2); return ctx_r73.typeAheadItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_13_div_1_ng_container_2_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbTypeahead", ctx_r68.search)("editable", false)("ngModel", ctx_r68.thvalue)("inputFormatter", ctx_r68.display)("resultFormatter", ctx_r68.display)("placeholder", ctx_r68.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function BsacFieldControlComponent_ng_container_13_div_2_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const o_r77 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", o_r77[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(o_r77[1]);
} }
function BsacFieldControlComponent_ng_container_13_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacFieldControlComponent_ng_container_13_div_2_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_13_div_2_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_13_div_2_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_13_div_2_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_13_div_2_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_13_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_13_div_2_div_4_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_13_div_2_div_4_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_13_div_2_div_4_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_13_div_2_div_4_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_13_div_2_div_4_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r76.form.get(ctx_r76.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r76.form.get(ctx_r76.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r76.form.get(ctx_r76.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r76.form.get(ctx_r76.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r76.form.get(ctx_r76.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_13_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "select", 13);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_13_div_2_option_2_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_13_div_2_ng_container_3_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_13_div_2_div_4_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r69.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r69.field)("formControlName", ctx_r69.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r69.choices);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r69.form.get(ctx_r69.field).invalid);
} }
function BsacFieldControlComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_13_div_1_Template, 3, 7, "div", 27);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_13_div_2_Template, 5, 6, "div", 28);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.relatedMode === "autocomplete");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.relatedMode === "select");
} }
function BsacFieldControlComponent_ng_container_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r87 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "i", 33);
    ɵngcc0.ɵɵlistener("click", function BsacFieldControlComponent_ng_container_14_div_1_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r87); const m_r85 = ctx.$implicit; const ctx_r86 = ɵngcc0.ɵɵnextContext(2); return ctx_r86.m2mRemove(m_r85); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r85 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(m_r85.name);
} }
function BsacFieldControlComponent_ng_container_14_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r89 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "input", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function BsacFieldControlComponent_ng_container_14_div_4_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r89); const ctx_r88 = ɵngcc0.ɵɵnextContext(2); return ctx_r88.thvalue = $event; })("selectItem", function BsacFieldControlComponent_ng_container_14_div_4_Template_input_selectItem_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r89); const ctx_r90 = ɵngcc0.ɵɵnextContext(2); return ctx_r90.m2mTypeAheadItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r84 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbTypeahead", ctx_r84.search)("editable", false)("ngModel", ctx_r84.thvalue)("inputFormatter", ctx_r84.display)("resultFormatter", ctx_r84.display)("placeholder", ctx_r84.placeholder);
} }
function BsacFieldControlComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r92 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_14_div_1_Template, 3, 1, "div", 31);
    ɵngcc0.ɵɵelementStart(2, "i", 32);
    ɵngcc0.ɵɵlistener("click", function BsacFieldControlComponent_ng_container_14_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r92); const ctx_r91 = ɵngcc0.ɵɵnextContext(); return ctx_r91.madd = !ctx_r91.madd; });
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_14_div_4_Template, 2, 6, "div", 27);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.mrelated);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.madd);
} }
function BsacFieldControlComponent_ng_container_15_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Ce champ est requis");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_15_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Syntaxe invalide");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_15_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop court");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_15_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Trop long");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_15_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, "Vous devez entrer une valeur autoris\u00E9e");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacFieldControlComponent_ng_container_15_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, BsacFieldControlComponent_ng_container_15_div_3_div_1_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(2, BsacFieldControlComponent_ng_container_15_div_3_div_2_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_15_div_3_div_3_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(4, BsacFieldControlComponent_ng_container_15_div_3_div_4_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_15_div_3_div_5_Template, 2, 0, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r93.form.get(ctx_r93.field).errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r93.form.get(ctx_r93.field).errors.pattern);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r93.form.get(ctx_r93.field).errors.minlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r93.form.get(ctx_r93.field).errors.maxlength);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r93.form.get(ctx_r93.field).errors.choices);
} }
function BsacFieldControlComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "input", 6);
    ɵngcc0.ɵɵtemplate(3, BsacFieldControlComponent_ng_container_15_div_3_Template, 6, 5, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r12.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", ctx_r12.field)("formControlName", ctx_r12.field)("placeholder", ctx_r12.placeholder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.form.get(ctx_r12.field).invalid);
} }
const _c2 = [[["", 8, "label"]], [["", 8, "help"]], [["", 8, "m2madd"]]];
const _c3 = [".label", ".help", ".m2madd"];
function BsacFlagsFieldComponent_dd_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(flag_r3);
} }
function BsacFlagsFieldComponent_dd_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dd", 0);
    ɵngcc0.ɵɵlistener("click", function BsacFlagsFieldComponent_dd_2_Template_dd_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return (ctx_r4.edit[ctx_r4.field] = true); });
    ɵngcc0.ɵɵtemplate(1, BsacFlagsFieldComponent_dd_2_span_1_Template, 2, 1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.curflags);
} }
function BsacFlagsFieldComponent_dd_3_ng_container_2_option_3_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r10 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("(", flag_r10.count, ")");
} }
function BsacFlagsFieldComponent_dd_3_ng_container_2_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, BsacFlagsFieldComponent_dd_3_ng_container_2_option_3_span_2_Template, 2, 1, "span", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", flag_r10.flag);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", flag_r10.flag, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", flag_r10.count);
} }
function BsacFlagsFieldComponent_dd_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "select", 10);
    ɵngcc0.ɵɵtemplate(3, BsacFlagsFieldComponent_dd_3_ng_container_2_option_3_Template, 3, 3, "option", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "input", 12);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacFlagsFieldComponent_dd_3_ng_container_2_Template_input_keyup_enter_5_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.addFreeFlag(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r6.fs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.flaglist);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r6.ft);
} }
function BsacFlagsFieldComponent_dd_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "input", 15);
    ɵngcc0.ɵɵlistener("keyup.enter", function BsacFlagsFieldComponent_dd_3_ng_container_3_Template_input_keyup_enter_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.addFreeFlag(); })("keyup.escape", function BsacFlagsFieldComponent_dd_3_ng_container_3_Template_input_keyup_escape_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return (ctx_r17.edit[ctx_r17.field] = false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r7.ft);
} }
function BsacFlagsFieldComponent_dd_3_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 16);
    ɵngcc0.ɵɵlistener("click", function BsacFlagsFieldComponent_dd_3_span_6_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const flag_r18 = ctx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.removeFlag(flag_r18); });
    ɵngcc0.ɵɵelement(1, "i", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r18 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(flag_r18);
} }
function BsacFlagsFieldComponent_dd_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dd");
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtemplate(2, BsacFlagsFieldComponent_dd_3_ng_container_2_Template, 6, 3, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(3, BsacFlagsFieldComponent_dd_3_ng_container_3_Template, 3, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtemplate(6, BsacFlagsFieldComponent_dd_3_span_6_Template, 3, 1, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.free);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.free);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.curflags);
} }
const _c4 = ["*"];
function BsacM2mFieldComponent_ng_container_0_ng_content_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "custom"]);
} }
function BsacM2mFieldComponent_ng_container_0_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1, ["*ngIf", "!custom"]);
} }
function BsacM2mFieldComponent_ng_container_0_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} }
function BsacM2mFieldComponent_ng_container_0_dd_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r9 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.tpl(e_r9.m2mModel));
} }
function BsacM2mFieldComponent_ng_container_0_dd_5_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r10 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.tpl(e_r10.m2mModel));
} }
function BsacM2mFieldComponent_ng_container_0_dd_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dd", 1);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_0_dd_5_Template_dd_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return (ctx_r11.edit[ctx_r11.field] = !ctx_r11.edit[ctx_r11.field]); });
    ɵngcc0.ɵɵtemplate(1, BsacM2mFieldComponent_ng_container_0_dd_5_span_1_Template, 2, 1, "span", 5);
    ɵngcc0.ɵɵtemplate(2, BsacM2mFieldComponent_ng_container_0_dd_5_span_2_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.enabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.disabled);
} }
function BsacM2mFieldComponent_ng_container_0_dd_6_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_0_dd_6_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const e_r15 = ctx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.m2mRemove(e_r15.m2mModel); });
    ɵngcc0.ɵɵelement(1, "i", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r15 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r13.tpl(e_r15));
} }
function BsacM2mFieldComponent_ng_container_0_dd_6_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_0_dd_6_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const e_r18 = ctx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.m2mAdd(e_r18.m2mModel); });
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r18 = ctx.$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.tpl(e_r18));
} }
function BsacM2mFieldComponent_ng_container_0_dd_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dd");
    ɵngcc0.ɵɵtemplate(1, BsacM2mFieldComponent_ng_container_0_dd_6_span_1_Template, 3, 1, "span", 9);
    ɵngcc0.ɵɵtemplate(2, BsacM2mFieldComponent_ng_container_0_dd_6_span_2_Template, 3, 1, "span", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.enabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.disabled);
} }
function BsacM2mFieldComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dt", 1);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_0_Template_dt_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return (ctx_r21.edit[ctx_r21.field] = !ctx_r21.edit[ctx_r21.field]); });
    ɵngcc0.ɵɵtemplate(2, BsacM2mFieldComponent_ng_container_0_ng_content_2_Template, 1, 0, "ng-content", 0);
    ɵngcc0.ɵɵtemplate(3, BsacM2mFieldComponent_ng_container_0_ng_content_3_Template, 1, 0, "ng-content", 0);
    ɵngcc0.ɵɵtemplate(4, BsacM2mFieldComponent_ng_container_0_i_4_Template, 1, 0, "i", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, BsacM2mFieldComponent_ng_container_0_dd_5_Template, 3, 2, "dd", 3);
    ɵngcc0.ɵɵtemplate(6, BsacM2mFieldComponent_ng_container_0_dd_6_Template, 3, 2, "dd", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.custom);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.custom);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.edit[ctx_r0.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.readonly || !ctx_r0.edit[ctx_r0.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.readonly && ctx_r0.edit[ctx_r0.field]);
} }
function BsacM2mFieldComponent_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_1_div_1_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return (ctx_r27.edit[ctx_r27.field] = !ctx_r27.edit[ctx_r27.field]); });
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} }
function BsacM2mFieldComponent_ng_container_1_div_1_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 16);
    ɵngcc0.ɵɵelement(2, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const m_r29 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r30 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r30.m2mLink(m_r29.m2mModel));
} }
function BsacM2mFieldComponent_ng_container_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", 1);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_1_div_1_div_2_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(3); return (ctx_r32.edit[ctx_r32.field] = !ctx_r32.readonly && !ctx_r32.edit[ctx_r32.field]); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, BsacM2mFieldComponent_ng_container_1_div_1_div_2_ng_container_3_Template, 3, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r29 = ctx.$implicit;
    const ctx_r26 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r26.tpl(m_r29.m2mModel));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.m2mLink);
} }
function BsacM2mFieldComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, BsacM2mFieldComponent_ng_container_1_div_1_div_1_Template, 2, 0, "div", 3);
    ɵngcc0.ɵɵtemplate(2, BsacM2mFieldComponent_ng_container_1_div_1_div_2_Template, 4, 2, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r23.enabled.length == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r23.enabled);
} }
function BsacM2mFieldComponent_ng_container_1_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "i", 20);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_1_div_2_div_1_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r38); const m_r36 = ctx.$implicit; const ctx_r37 = ɵngcc0.ɵɵnextContext(3); return ctx_r37.m2mRemove(m_r36.m2mModel); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r36 = ctx.$implicit;
    const ctx_r34 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r34.tpl(m_r36.m2mModel));
} }
function BsacM2mFieldComponent_ng_container_1_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "input", 22, 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function BsacM2mFieldComponent_ng_container_1_div_2_div_5_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r41); const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.thvalue = $event; })("selectItem", function BsacM2mFieldComponent_ng_container_1_div_2_div_5_Template_input_selectItem_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r41); const _r39 = ɵngcc0.ɵɵreference(2); const ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ctx_r42.m2mAdd($event.item, $event, _r39); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbTypeahead", ctx_r35.typeAheadSearch)("editable", false)("ngModel", ctx_r35.thvalue)("inputFormatter", ctx_r35.tpl)("resultFormatter", ctx_r35.tpl)("placeholder", ctx_r35.placeholder);
} }
function BsacM2mFieldComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, BsacM2mFieldComponent_ng_container_1_div_2_div_1_Template, 3, 1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵlistener("click", function BsacM2mFieldComponent_ng_container_1_div_2_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r44); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ctx_r43.madd = !ctx_r43.madd; });
    ɵngcc0.ɵɵelement(3, "i", 18);
    ɵngcc0.ɵɵprojection(4, 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, BsacM2mFieldComponent_ng_container_1_div_2_div_5_Template, 3, 6, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r24.enabled);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r24.madd);
} }
function BsacM2mFieldComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacM2mFieldComponent_ng_container_1_div_1_Template, 3, 2, "div", 0);
    ɵngcc0.ɵɵtemplate(2, BsacM2mFieldComponent_ng_container_1_div_2_Template, 6, 2, "div", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.readonly || !ctx_r1.edit[ctx_r1.field]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.readonly && ctx_r1.edit[ctx_r1.field]);
} }
const _c5 = [[["", 8, "desc"]], "*", [["", 8, "m2mempty"]], [["", 8, "m2madd"]]];
const _c6 = [".desc", "*", ".m2mempty", ".m2madd"];
function BsacI18nEditorComponent_form_8_input_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 15);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("readonly", true);
} }
function BsacI18nEditorComponent_form_8_textarea_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "textarea", 16);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("readonly", true);
} }
function BsacI18nEditorComponent_form_8_input_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 17);
} }
function BsacI18nEditorComponent_form_8_textarea_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "textarea", 18);
} }
function BsacI18nEditorComponent_form_8_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "button", 20);
    ɵngcc0.ɵɵlistener("click", function BsacI18nEditorComponent_form_8_div_17_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const s_r6 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.save(s_r6); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r6 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("btn-success", ctx_r5.translation.status == s_r6 && ctx_r5.validStatuses.indexOf(s_r6) !== -1)("btn-warning", ctx_r5.translation.status == s_r6 && ctx_r5.warningStatuses.indexOf(s_r6) !== -1)("btn-danger", ctx_r5.translation.status == s_r6 && ctx_r5.invalidStatuses.indexOf(s_r6) !== -1)("btn-outline-success", ctx_r5.translation.status != s_r6 && ctx_r5.validStatuses.indexOf(s_r6) !== -1)("btn-outline-warning", ctx_r5.translation.status != s_r6 && ctx_r5.warningStatuses.indexOf(s_r6) !== -1)("btn-outline-danger", ctx_r5.translation.status != s_r6 && ctx_r5.invalidStatuses.indexOf(s_r6) !== -1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(s_r6);
} }
function BsacI18nEditorComponent_form_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "form", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Texte original");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, BsacI18nEditorComponent_form_8_input_4_Template, 1, 1, "input", 8);
    ɵngcc0.ɵɵtemplate(5, BsacI18nEditorComponent_form_8_textarea_5_Template, 1, 1, "textarea", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Traduction");
    ɵngcc0.ɵɵelement(9, "i", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, BsacI18nEditorComponent_form_8_input_10_Template, 1, 0, "input", 10);
    ɵngcc0.ɵɵtemplate(11, BsacI18nEditorComponent_form_8_textarea_11_Template, 1, 0, "textarea", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 7);
    ɵngcc0.ɵɵelementStart(13, "label");
    ɵngcc0.ɵɵtext(14, "Commentaires");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(15, "textarea", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 13);
    ɵngcc0.ɵɵtemplate(17, BsacI18nEditorComponent_form_8_div_17_Template, 3, 13, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.trForm);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type != "textarea");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type == "textarea");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", "flag-icon flag-icon-squared flag-icon-" + ctx_r0.lang);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type != "textarea");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.type == "textarea");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.translationStatuses);
} }
function BsacI18nComponent_ng_template_0_Template(rf, ctx) { }
function BsacI18nComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("click", function BsacI18nComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const l_r4 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(1); return ctx_r5.open(_r0, l_r4); });
    ɵngcc0.ɵɵelement(1, "i", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const l_r4 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.getStatusClass(ctx_r2.translations[l_r4] == null ? null : ctx_r2.translations[l_r4].status))("ngbTooltip", ctx_r2.translations[l_r4] == null ? null : ctx_r2.translations[l_r4].text);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", "flag-icon flag-icon-squared flag-icon-" + l_r4);
} }
function BsacModelListSelectFilterComponent_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ch_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", ch_r1.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ch_r1.desc);
} }
function BsacModelListValueFilterComponent_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1, "=");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListValueFilterComponent_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1, ">=");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListValueFilterComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 13);
    ɵngcc0.ɵɵtext(1, ">");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListValueFilterComponent_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1, "<");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListValueFilterComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1, "<=");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListValueFilterComponent_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1, "Not null");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListFlagsFilterComponent_ng_container_6_option_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const flag_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("- ", flag_r2.count, "");
} }
function BsacModelListFlagsFilterComponent_ng_container_6_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, BsacModelListFlagsFilterComponent_ng_container_6_option_1_ng_container_2_Template, 2, 1, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("value", flag_r2.flag);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", flag_r2.flag, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", flag_r2.count);
} }
function BsacModelListFlagsFilterComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacModelListFlagsFilterComponent_ng_container_6_option_1_Template, 3, 3, "option", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const flag_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.flagPresent(flag_r2));
} }
function BsacModelListFlagsFilterComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵlistener("click", function BsacModelListFlagsFilterComponent_span_9_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const flag_r7 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.removeFlag(flag_r7); });
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const flag_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(flag_r7);
} }
function BsacModelListGeodistanceFilterComponent_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", d_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", d_r2, " km");
} }
function BsacModelListGeodistanceFilterComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "bsac-geo-static-gmap", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lat", ctx_r1.geolocation.geometry.coordinates[1])("lng", ctx_r1.geolocation.geometry.coordinates[0]);
} }
function BsacModelListMultiselectFilterComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ch_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", ch_r2.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ch_r2.desc);
} }
function BsacModelListMultiselectFilterComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "i", 9);
    ɵngcc0.ɵɵlistener("click", function BsacModelListMultiselectFilterComponent_div_10_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const s_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.removeSelection(s_r3); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.curdesc[s_r3]);
} }
function BsacModelListMultiautocompleteFilterComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "i", 6);
    ɵngcc0.ɵɵlistener("click", function BsacModelListMultiautocompleteFilterComponent_div_7_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const s_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.removeSelection(s_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.curdesc[s_r1]);
} }
function BsacGeoStaticGmapComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("height", ctx_r0.height)("background-image", ctx_r0.src);
} }
function BsacModelListSorterComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSorterComponent_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.cancel(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.getOrder());
} }
function BsacModelListSorterComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSorterComponent_span_2_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.cancel(); });
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 18);
    ɵngcc0.ɵɵtext(1, "10 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1, "20 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 20);
    ɵngcc0.ɵɵtext(1, "50 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1, "100 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 22);
    ɵngcc0.ɵɵtext(1, "200 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1, "500 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 24);
    ɵngcc0.ɵɵtext(1, "1000 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1, "2000 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 26);
    ɵngcc0.ɵɵtext(1, "5000 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_option_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 27);
    ɵngcc0.ɵɵtext(1, "10000 / page");
    ɵngcc0.ɵɵelementEnd();
} }
function BsacModelListPaginatorComponent_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵelementStart(2, "ngb-pagination", 30);
    ɵngcc0.ɵɵlistener("pageChange", function BsacModelListPaginatorComponent_div_0_div_13_Template_ngb_pagination_pageChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onPageChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("pageSize", ctx_r11.pagesize)("collectionSize", ctx_r11.curcount)("page", ctx_r11.curpage)("maxSize", 5)("rotate", true);
} }
function BsacModelListPaginatorComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "input", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControl", ctx_r12.directAccess);
} }
function BsacModelListPaginatorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "select", 3);
    ɵngcc0.ɵɵtemplate(3, BsacModelListPaginatorComponent_div_0_option_3_Template, 2, 0, "option", 4);
    ɵngcc0.ɵɵtemplate(4, BsacModelListPaginatorComponent_div_0_option_4_Template, 2, 0, "option", 5);
    ɵngcc0.ɵɵtemplate(5, BsacModelListPaginatorComponent_div_0_option_5_Template, 2, 0, "option", 6);
    ɵngcc0.ɵɵtemplate(6, BsacModelListPaginatorComponent_div_0_option_6_Template, 2, 0, "option", 7);
    ɵngcc0.ɵɵtemplate(7, BsacModelListPaginatorComponent_div_0_option_7_Template, 2, 0, "option", 8);
    ɵngcc0.ɵɵtemplate(8, BsacModelListPaginatorComponent_div_0_option_8_Template, 2, 0, "option", 9);
    ɵngcc0.ɵɵtemplate(9, BsacModelListPaginatorComponent_div_0_option_9_Template, 2, 0, "option", 10);
    ɵngcc0.ɵɵtemplate(10, BsacModelListPaginatorComponent_div_0_option_10_Template, 2, 0, "option", 11);
    ɵngcc0.ɵɵtemplate(11, BsacModelListPaginatorComponent_div_0_option_11_Template, 2, 0, "option", 12);
    ɵngcc0.ɵɵtemplate(12, BsacModelListPaginatorComponent_div_0_option_12_Template, 2, 0, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, BsacModelListPaginatorComponent_div_0_div_13_Template, 3, 5, "div", 14);
    ɵngcc0.ɵɵelementStart(14, "div", 15);
    ɵngcc0.ɵɵelementStart(15, "p", 16);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPaginatorComponent_div_0_Template_p_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.showDirectAccess = !ctx_r15.showDirectAccess; });
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, BsacModelListPaginatorComponent_div_0_div_17_Template, 2, 1, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControl", ctx_r0.perpageControl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 20);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 50);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 100);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 200);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 500);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 1000);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 2000);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 5000);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.maxpages >= 10000);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.list);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.curcount, " r\u00E9sultats");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showDirectAccess);
} }
function ModelListFieldsSelectComponent_ng_template_0_ul_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(f_r8.verbose_name);
} }
function ModelListFieldsSelectComponent_ng_template_0_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(f_r9.verbose_name);
} }
const _c7 = function (a0) { return [a0]; };
function ModelListFieldsSelectComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "h4", 3);
    ɵngcc0.ɵɵtext(2, "S\u00E9lection des colonnes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function ModelListFieldsSelectComponent_ng_template_0_Template_button_click_3_listener() { const modal_r3 = ctx.$implicit; return modal_r3.dismiss("x"); });
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "p", 7);
    ɵngcc0.ɵɵtext(8, "Glissez, d\u00E9placez et/ou r\u00E9ordonnez les colonnes que vous voulez afficher");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "form", 8);
    ɵngcc0.ɵɵelementStart(10, "div", 9);
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelement(12, "input", 11);
    ɵngcc0.ɵɵelementStart(13, "div", 12);
    ɵngcc0.ɵɵelementStart(14, "ul", 13, 14);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function ModelListFieldsSelectComponent_ng_template_0_Template_ul_cdkDropListDropped_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.drop($event); });
    ɵngcc0.ɵɵtemplate(16, ModelListFieldsSelectComponent_ng_template_0_ul_16_Template, 2, 1, "ul", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 10);
    ɵngcc0.ɵɵelement(18, "input", 16);
    ɵngcc0.ɵɵelementStart(19, "ul", 17, 18);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function ModelListFieldsSelectComponent_ng_template_0_Template_ul_cdkDropListDropped_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.drop($event); });
    ɵngcc0.ɵɵtemplate(21, ModelListFieldsSelectComponent_ng_template_0_div_21_Template, 2, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 19);
    ɵngcc0.ɵɵelementStart(23, "button", 20);
    ɵngcc0.ɵɵlistener("click", function ModelListFieldsSelectComponent_ng_template_0_Template_button_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.save(); });
    ɵngcc0.ɵɵtext(24, "Enregistrer");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "button", 21);
    ɵngcc0.ɵɵlistener("click", function ModelListFieldsSelectComponent_ng_template_0_Template_button_click_25_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.cancel(); });
    ɵngcc0.ɵɵtext(26, "Annuler");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(15);
    const _r6 = ɵngcc0.ɵɵreference(20);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.search);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("cdkDropListData", ctx_r1.disabled)("cdkDropListConnectedTo", ɵngcc0.ɵɵpureFunction1(7, _c7, _r6));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.fdisabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("cdkDropListData", ctx_r1.enabled)("cdkDropListConnectedTo", ɵngcc0.ɵɵpureFunction1(9, _c7, _r4));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.fenabled);
} }
function ModelListFieldsSelectComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementStart(3, "button", 24);
    ɵngcc0.ɵɵlistener("click", function ModelListFieldsSelectComponent_div_2_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(1); return ctx_r16.open(_r0); });
    ɵngcc0.ɵɵtext(4, "S\u00E9lectionner une colonne");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c8 = ["data"];
function BsacModelListFiltersetSelectComponent_div_0_ng_container_7_optgroup_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "option", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const f_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", f_r6.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(f_r6.description);
} }
function BsacModelListFiltersetSelectComponent_div_0_ng_container_7_optgroup_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "optgroup", 7);
    ɵngcc0.ɵɵtemplate(1, BsacModelListFiltersetSelectComponent_div_0_ng_container_7_optgroup_1_ng_container_1_Template, 3, 2, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const g_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("label", g_r3.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", g_r3.fields);
} }
function BsacModelListFiltersetSelectComponent_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BsacModelListFiltersetSelectComponent_div_0_ng_container_7_optgroup_1_Template, 2, 2, "optgroup", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const g_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", g_r3.fields.length > 0);
} }
function BsacModelListFiltersetSelectComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Ajouter un filtre");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 2, 3);
    ɵngcc0.ɵɵlistener("change", function BsacModelListFiltersetSelectComponent_div_0_Template_select_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const _r1 = ɵngcc0.ɵɵreference(4); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.addFilter($event, _r1.value); });
    ɵngcc0.ɵɵelementStart(5, "option", 4);
    ɵngcc0.ɵɵtext(6, "S\u00E9lectionnez un filtre");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, BsacModelListFiltersetSelectComponent_div_0_ng_container_7_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.fg);
} }
function BsacModelListPersistenceSaveComponent_ng_template_0_li_12_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 13);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceSaveComponent_ng_template_0_li_12_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const s_r5 = ctx.$implicit; const c_r2 = ɵngcc0.ɵɵnextContext().close; const ctx_r6 = ɵngcc0.ɵɵnextContext(); ctx_r6.fileName = s_r5.key; return c_r2("select"); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(s_r5.key);
} }
function BsacModelListPersistenceSaveComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "h4", 3);
    ɵngcc0.ɵɵtext(2, "Enregistrer un jeu de filtres");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceSaveComponent_ng_template_0_Template_button_click_3_listener() { const d_r3 = ctx.dismiss; return d_r3("cross"); });
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function BsacModelListPersistenceSaveComponent_ng_template_0_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.fileName = $event; })("keyup.enter", function BsacModelListPersistenceSaveComponent_ng_template_0_Template_input_keyup_enter_7_listener() { const c_r2 = ctx.close; return c_r2("enter"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "hr");
    ɵngcc0.ɵɵelementStart(9, "p", 8);
    ɵngcc0.ɵɵtext(10, "Overwrite existing ?");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "ul", 9);
    ɵngcc0.ɵɵtemplate(12, BsacModelListPersistenceSaveComponent_ng_template_0_li_12_Template, 2, 1, "li", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 11);
    ɵngcc0.ɵɵelementStart(14, "button", 12);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceSaveComponent_ng_template_0_Template_button_click_14_listener() { const c_r2 = ctx.close; return c_r2("close"); });
    ɵngcc0.ɵɵtext(15, "Enregistrer");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.fileName);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.saved);
} }
function BsacModelListPersistenceLoadComponent_ng_template_0_li_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 13);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceLoadComponent_ng_template_0_li_10_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const s_r5 = ctx.$implicit; const c_r2 = ɵngcc0.ɵɵnextContext().close; const ctx_r6 = ɵngcc0.ɵɵnextContext(); ctx_r6.fileName = s_r5.key; return c_r2("select"); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(s_r5.key);
} }
function BsacModelListPersistenceLoadComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "h4", 3);
    ɵngcc0.ɵɵtext(2, "Charger un jeu de filtres");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceLoadComponent_ng_template_0_Template_button_click_3_listener() { const d_r3 = ctx.dismiss; return d_r3("cross"); });
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "p", 7);
    ɵngcc0.ɵɵtext(8, "Jeux de filtres \u00E0 charger");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "ul", 8);
    ɵngcc0.ɵɵtemplate(10, BsacModelListPersistenceLoadComponent_ng_template_0_li_10_Template, 2, 1, "li", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelementStart(12, "button", 11);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceLoadComponent_ng_template_0_Template_button_click_12_listener() { const c_r2 = ctx.close; return c_r2("close"); });
    ɵngcc0.ɵɵtext(13, "Charger");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "button", 12);
    ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceLoadComponent_ng_template_0_Template_button_click_14_listener() { const d_r3 = ctx.dismiss; return d_r3("cancel"); });
    ɵngcc0.ɵɵtext(15, "Annuler");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.saved);
} }
function BsacModelListDisplayComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function BsacModelListDisplayComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
function BsacModelListDisplayComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2);
} }
function BsacModelListDisplayComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 3);
} }
function BsacModelListDisplayComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 4);
} }
function BsacModelListDisplayComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 5);
} }
function BsacModelListDisplayComponent_div_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_12_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_12_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_12_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_12_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_12_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, BsacModelListDisplayComponent_div_12_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(3, BsacModelListDisplayComponent_div_12_ng_container_3_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 13);
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵtemplate(7, BsacModelListDisplayComponent_div_12_ng_container_7_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 15);
    ɵngcc0.ɵɵtemplate(9, BsacModelListDisplayComponent_div_12_ng_container_9_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 16);
    ɵngcc0.ɵɵtemplate(11, BsacModelListDisplayComponent_div_12_ng_container_11_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 16);
    ɵngcc0.ɵɵtemplate(13, BsacModelListDisplayComponent_div_12_ng_container_13_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r6 = ɵngcc0.ɵɵreference(7);
    const _r8 = ɵngcc0.ɵɵreference(9);
    const _r10 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10);
} }
function BsacModelListDisplayComponent_div_13_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_13_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_13_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_13_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_13_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_13_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵtemplate(2, BsacModelListDisplayComponent_div_13_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelementStart(4, "div", 18);
    ɵngcc0.ɵɵelementStart(5, "div", 19);
    ɵngcc0.ɵɵtemplate(6, BsacModelListDisplayComponent_div_13_ng_container_6_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 19);
    ɵngcc0.ɵɵtemplate(8, BsacModelListDisplayComponent_div_13_ng_container_8_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 19);
    ɵngcc0.ɵɵtemplate(10, BsacModelListDisplayComponent_div_13_ng_container_10_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 16);
    ɵngcc0.ɵɵtemplate(12, BsacModelListDisplayComponent_div_13_ng_container_12_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 16);
    ɵngcc0.ɵɵtemplate(14, BsacModelListDisplayComponent_div_13_ng_container_14_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r6 = ɵngcc0.ɵɵreference(7);
    const _r8 = ɵngcc0.ɵɵreference(9);
    const _r10 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10);
} }
function BsacModelListDisplayComponent_div_14_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_14_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_14_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_14_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_14_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_14_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵtemplate(2, BsacModelListDisplayComponent_div_14_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 22);
    ɵngcc0.ɵɵelementStart(4, "button", 23);
    ɵngcc0.ɵɵlistener("click", function BsacModelListDisplayComponent_div_14_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.collapse1 = !ctx_r34.collapse1; });
    ɵngcc0.ɵɵelement(5, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 25);
    ɵngcc0.ɵɵelementStart(7, "div", 18);
    ɵngcc0.ɵɵelementStart(8, "div", 19);
    ɵngcc0.ɵɵtemplate(9, BsacModelListDisplayComponent_div_14_ng_container_9_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 19);
    ɵngcc0.ɵɵtemplate(11, BsacModelListDisplayComponent_div_14_ng_container_11_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 19);
    ɵngcc0.ɵɵtemplate(13, BsacModelListDisplayComponent_div_14_ng_container_13_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 16);
    ɵngcc0.ɵɵtemplate(15, BsacModelListDisplayComponent_div_14_ng_container_15_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 16);
    ɵngcc0.ɵɵtemplate(17, BsacModelListDisplayComponent_div_14_ng_container_17_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r6 = ɵngcc0.ɵɵreference(7);
    const _r8 = ɵngcc0.ɵɵreference(9);
    const _r10 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngbCollapse", ctx_r14.collapse1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10);
} }
function BsacModelListDisplayComponent_div_15_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_15_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_15_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_15_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_15_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_15_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BsacModelListDisplayComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r43 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "div", 27);
    ɵngcc0.ɵɵlistener("click", function BsacModelListDisplayComponent_div_15_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r43); const ctx_r42 = ɵngcc0.ɵɵnextContext(); return ctx_r42.collapse1 = !ctx_r42.collapse1; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 25);
    ɵngcc0.ɵɵtemplate(3, BsacModelListDisplayComponent_div_15_ng_container_3_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 25);
    ɵngcc0.ɵɵelementStart(5, "div", 18);
    ɵngcc0.ɵɵelementStart(6, "div", 19);
    ɵngcc0.ɵɵtemplate(7, BsacModelListDisplayComponent_div_15_ng_container_7_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 19);
    ɵngcc0.ɵɵtemplate(9, BsacModelListDisplayComponent_div_15_ng_container_9_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 19);
    ɵngcc0.ɵɵtemplate(11, BsacModelListDisplayComponent_div_15_ng_container_11_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 16);
    ɵngcc0.ɵɵtemplate(13, BsacModelListDisplayComponent_div_15_ng_container_13_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 16);
    ɵngcc0.ɵɵtemplate(15, BsacModelListDisplayComponent_div_15_ng_container_15_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    const _r2 = ɵngcc0.ɵɵreference(3);
    const _r4 = ɵngcc0.ɵɵreference(5);
    const _r6 = ɵngcc0.ɵɵreference(7);
    const _r8 = ɵngcc0.ɵɵreference(9);
    const _r10 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngbCollapse", ctx_r15.collapse1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbCollapse", ctx_r15.collapse1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10);
} }
const _c9 = [[["", 8, "list-current-filters"]], [["", 8, "list-select-filters"]], [["", 8, "list-select-columns"]], [["", 8, "list-persistence"]], [["", 8, "list-results"]], [["", 8, "list-pagination"]]];
const _c10 = [".list-current-filters", ".list-select-filters", ".list-select-columns", ".list-persistence", ".list-results", ".list-pagination"];
function BsacModelListSettingsEditorComponent_tr_25_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} }
function BsacModelListSettingsEditorComponent_tr_25_i_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} }
function BsacModelListSettingsEditorComponent_tr_25_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "code");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_25_Template_td_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r3 = ctx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.defaultField(i_r3); });
    ɵngcc0.ɵɵtemplate(7, BsacModelListSettingsEditorComponent_tr_25_i_7_Template, 1, 0, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_25_Template_td_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r3 = ctx.index; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.allowedField(i_r3); });
    ɵngcc0.ɵɵtemplate(9, BsacModelListSettingsEditorComponent_tr_25_i_9_Template, 1, 0, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "td");
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_25_Template_td_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r3 = ctx.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.upField(i_r3); });
    ɵngcc0.ɵɵelement(13, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_25_Template_td_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r7); const i_r3 = ctx.index; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.downField(i_r3); });
    ɵngcc0.ɵɵelement(15, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r2 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("table-success", f_r2.default)("table-primary", !f_r2.default && f_r2.allowed);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(f_r2.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(f_r2.description);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", f_r2.default);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", f_r2.allowed);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(f_r2.order);
} }
function BsacModelListSettingsEditorComponent_tr_47_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} }
function BsacModelListSettingsEditorComponent_tr_47_i_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 11);
} }
function BsacModelListSettingsEditorComponent_tr_47_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "code");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_47_Template_td_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r16); const i_r12 = ctx.index; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.defaultFilter(i_r12); });
    ɵngcc0.ɵɵtemplate(7, BsacModelListSettingsEditorComponent_tr_47_i_7_Template, 1, 0, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_47_Template_td_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r16); const i_r12 = ctx.index; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.allowedFilter(i_r12); });
    ɵngcc0.ɵɵtemplate(9, BsacModelListSettingsEditorComponent_tr_47_i_9_Template, 1, 0, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "td");
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_47_Template_td_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r16); const i_r12 = ctx.index; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.upFilter(i_r12); });
    ɵngcc0.ɵɵelement(13, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "td", 7);
    ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_tr_47_Template_td_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r16); const i_r12 = ctx.index; const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.downFilter(i_r12); });
    ɵngcc0.ɵɵelement(15, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r11 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("table-success", f_r11.default)("table-primary", !f_r11.default && f_r11.allowed);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(f_r11.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(f_r11.description);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", f_r11.default);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", f_r11.allowed);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(f_r11.order);
} }
function BsacLiveZoneComponent_div_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "i", 4);
    ɵngcc0.ɵɵlistener("click", function BsacLiveZoneComponent_div_0_div_1_div_1_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r7); const md_r2 = ɵngcc0.ɵɵnextContext().$implicit; return md_r2.close(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelement(4, "ngb-progressbar", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const md_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(md_r2.message.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", md_r2.message.data.done)("max", md_r2.message.data.total);
} }
function BsacLiveZoneComponent_div_0_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "i", 4);
    ɵngcc0.ɵɵlistener("click", function BsacLiveZoneComponent_div_0_div_1_div_2_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const md_r2 = ɵngcc0.ɵɵnextContext().$implicit; return md_r2.close(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "json");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const md_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(md_r2.message.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 2, md_r2.message.data));
} }
function BsacLiveZoneComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, BsacLiveZoneComponent_div_0_div_1_div_1_Template, 5, 3, "div", 3);
    ɵngcc0.ɵɵtemplate(2, BsacLiveZoneComponent_div_0_div_1_div_2_Template, 6, 4, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const md_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", md_r2.message.type == "progress");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", md_r2.message.type != "progress");
} }
function BsacLiveZoneComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, BsacLiveZoneComponent_div_0_div_1_Template, 3, 2, "div", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.todisplay);
} }
const BSAC_ISSUE_CONFIG = new InjectionToken("bsac.dev.issue.config");

/**
 * Display a link to issue tracker.
 *
 * To build the link, BSAC_ISSUE_CONFIG is used, providing if set :
 * - server : protocol & domain part or url, without trailing slash
 * - project : path to project & issues
 *
 * Issue url is built using server + project + issue.
 *
 * BSAC_ISSUE_CONFIG should give `{server: "", project: ""}`
 *
 * If given, project & server inputs takes precedence over BSAC_ISSUE_CONFIG values.
 *
 * - TODO: use url template to build issue url
 * - TODO: add service to get issue data (status, title, ..)
 */
class BsacIssueComponent {
    constructor(config) {
        this.config = config;
        if (!this.config) {
            this.config = {
                server: "https://gitlab.com",
                project: "solidev/bsadmincomponents"
            };
        }
    }
    ngOnInit() {
        if (!this.project) {
            this.project = this.config.project;
        }
        if (!this.server) {
            this.server = this.config.server;
        }
    }
}
BsacIssueComponent.ɵfac = function BsacIssueComponent_Factory(t) { return new (t || BsacIssueComponent)(ɵngcc0.ɵɵdirectiveInject(BSAC_ISSUE_CONFIG, 8)); };
BsacIssueComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacIssueComponent, selectors: [["bsac-issue"]], inputs: { project: "project", server: "server", issue: "issue", view: "view" }, decls: 2, vars: 2, consts: [["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], [1, "fa", "fa-bug", "mr-1"], [1, "fa", "fa-bug"]], template: function BsacIssueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacIssueComponent_a_0_Template, 3, 4, "a", 0);
        ɵngcc0.ɵɵtemplate(1, BsacIssueComponent_a_1_Template, 2, 3, "a", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.issue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.view);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
BsacIssueComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_ISSUE_CONFIG,] }] }
];
BsacIssueComponent.propDecorators = {
    issue: [{ type: Input }],
    view: [{ type: Input }],
    project: [{ type: Input }],
    server: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacIssueComponent, [{
        type: Component,
        args: [{
                selector: "bsac-issue",
                template: "<a href=\"{{server}}/{{project}}/{{issue}}\" target=\"_blank\" *ngIf=\"issue\"><i class=\"fa fa-bug mr-1\"></i>#{{issue}}</a><a href=\"{{server}}/{{project}}/issues??scope=all&amp;utf8=\u2713&amp;state=opened&amp;search={{view}}\" target=\"_blank\" *ngIf=\"view\"><i class=\"fa fa-bug\"></i></a>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_ISSUE_CONFIG]
            }] }]; }, { project: [{
            type: Input
        }], server: [{
            type: Input
        }], issue: [{
            type: Input
        }], view: [{
            type: Input
        }] }); })();

/**
 * Display version number, in vVERSION-BUILD form, or vVERSION if no build provided.
 *
 * Inputs :
 * - version : version tag
 * - build : build tag
 */
class BsacVersionComponent {
    constructor() {
        this.version = "";
        this.build = "";
    }
}
BsacVersionComponent.ɵfac = function BsacVersionComponent_Factory(t) { return new (t || BsacVersionComponent)(); };
BsacVersionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacVersionComponent, selectors: [["bsac-version"]], inputs: { version: "version", build: "build" }, decls: 2, vars: 2, consts: [["class", "bsacVersion", 4, "ngIf"], [1, "bsacVersion"]], template: function BsacVersionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacVersionComponent_span_0_Template, 2, 2, "span", 0);
        ɵngcc0.ɵɵtemplate(1, BsacVersionComponent_span_1_Template, 2, 1, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.build);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.build);
    } }, directives: [ɵngcc1.NgIf], styles: [""] });
BsacVersionComponent.propDecorators = {
    version: [{ type: Input }],
    build: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacVersionComponent, [{
        type: Component,
        args: [{
                selector: "bsac-version",
                template: "<span class=\"bsacVersion\" *ngIf=\"build\">v{{ version }}-{{ build }}</span><span class=\"bsacVersion\" *ngIf=\"!build\">v{{ version }}</span>",
                styles: [""]
            }]
    }], function () { return []; }, { version: [{
            type: Input
        }], build: [{
            type: Input
        }] }); })();

/**
 * Dev utilities, for version, issue & todolist display.
 *
 * - [bsac-issue](/components/BsacIssueComponent.html) : displays a link to issue
 * - [bsac-version](/components/BsacVersionComponent.html) : displays a version string
 */
class BsacDevModule {
}
BsacDevModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacDevModule });
BsacDevModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacDevModule_Factory(t) { return new (t || BsacDevModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacDevModule, { declarations: function () { return [BsacIssueComponent, BsacVersionComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacIssueComponent, BsacVersionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacDevModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [BsacIssueComponent, BsacVersionComponent],
                exports: [BsacIssueComponent, BsacVersionComponent]
            }]
    }], null, null); })();

/**
 * Native service for calling nativeElement methods.
 * To be overriden on server implementation.
 */
class BsacNativeInvokeService {
    focus(el) {
        el.nativeElement.focus();
    }
}
BsacNativeInvokeService.ɵfac = function BsacNativeInvokeService_Factory(t) { return new (t || BsacNativeInvokeService)(); };
BsacNativeInvokeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacNativeInvokeService, factory: BsacNativeInvokeService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacNativeInvokeService, [{
        type: Injectable
    }], null, null); })();
/**
 * Autofocus directive : focuses this element on creation.
 *
 * Selector : bsacAutoFocus
 */
class BsacAutoFocusDirective {
    constructor(native, elementRef) {
        this.native = native;
        this.elementRef = elementRef;
    }
    ngOnInit() {
        this.native.focus(this.elementRef);
    }
}
BsacAutoFocusDirective.ɵfac = function BsacAutoFocusDirective_Factory(t) { return new (t || BsacAutoFocusDirective)(ɵngcc0.ɵɵdirectiveInject(BsacNativeInvokeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BsacAutoFocusDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BsacAutoFocusDirective, selectors: [["", "bsacAutoFocus", ""]] });
BsacAutoFocusDirective.ctorParameters = () => [
    { type: BsacNativeInvokeService },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacAutoFocusDirective, [{
        type: Directive,
        args: [{
                selector: "[bsacAutoFocus]"
            }]
    }], function () { return [{ type: BsacNativeInvokeService }, { type: ɵngcc0.ElementRef }]; }, null); })();

/**
 * Use data from route config to create a breadcrumb for current route.
 *
 * Route config data is :
 * - title : route fragment title or lodash template to build title
 *   (provided arguments for template processing : route (current segment route snapshot)
 *   and data (input argument)
 * - icon: icon classes. Example fa fa-home for home & font awesome
 *
 * TODO: home icon & home title are not configurable
 */
class BsacBreadcrumbComponent {
    constructor(_route) {
        this._route = _route;
        /**
         * Do we display icons ?
         */
        this.icons = true;
        this.tree = [];
    }
    ngOnInit() {
        this.getRouteTree();
    }
    ngOnChanges() {
        this.getRouteTree();
    }
    getRouteTree() {
        const tree = [];
        const url = [];
        for (const p of this._route.snapshot.pathFromRoot) {
            const rtd = { icon: "", title: "", path: "", current: false };
            if (p.data.icon) {
                rtd.icon = p.data.icon;
            }
            // Retrieve path data from route config
            if (p.routeConfig && p.routeConfig.data) {
                // There is a route config
                if (p.routeConfig.data.title) {
                    if (p.routeConfig.data.title.search("<%=") !== -1) {
                        const tpl = template(p.routeConfig.data.title);
                        try {
                            rtd.title = tpl({ route: p, data: this.data });
                        }
                        catch (e) {
                            console.warn("Unable to process bsac-breadcrumb title", e);
                            rtd.title = p.data.title;
                        }
                    }
                    else {
                        rtd.title = p.routeConfig.data.title;
                    }
                }
            }
            else {
                // No route config
                if (p.parent !== null) {
                    console.warn("Missing route config for", p);
                }
                rtd.title = p.url.join(" ");
                rtd.icon = "";
            }
            // Url management, add all paths if existing
            if (p.url.length > 0) {
                url.push(p.url.join("/"));
                rtd.path = url.join("/");
                // fix missing first slash
                if (rtd.path.length > 0 && rtd.path[0] !== "/") {
                    rtd.path = "/" + rtd.path;
                }
            }
            // Don't add root route / unconfigured routes / skipped routes
            if (!((p.routeConfig && p.routeConfig.data && p.routeConfig.data.skip) || p.parent === null || !p.routeConfig)) {
                tree.push(rtd);
            }
        }
        if (tree.length > 0) {
            tree[tree.length - 1].current = true;
        }
        this.tree = tree;
    }
}
BsacBreadcrumbComponent.ɵfac = function BsacBreadcrumbComponent_Factory(t) { return new (t || BsacBreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute)); };
BsacBreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacBreadcrumbComponent, selectors: [["bsac-breadcrumb"]], inputs: { icons: "icons", data: "data" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["aria-label", "breadcrumb"], [1, "breadcrumb"], [4, "ngFor", "ngForOf"], ["class", "breadcrumb-item", 4, "ngIf"], ["class", "breadcrumb-item active", "aria-current", "page", 4, "ngIf"], [1, "breadcrumb-item"], [1, "breadcrumb-item", 3, "routerLink"], [4, "ngIf"], [1, "mr-2", 3, "ngClass"], ["aria-current", "page", 1, "breadcrumb-item", "active"]], template: function BsacBreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ol", 1);
        ɵngcc0.ɵɵtemplate(2, BsacBreadcrumbComponent_ng_container_2_Template, 3, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tree);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.RouterLinkWithHref, ɵngcc1.NgClass], styles: [""] });
BsacBreadcrumbComponent.ctorParameters = () => [
    { type: ActivatedRoute }
];
BsacBreadcrumbComponent.propDecorators = {
    data: [{ type: Input }],
    icons: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacBreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: "bsac-breadcrumb",
                template: "<nav aria-label=\"breadcrumb\"><ol class=\"breadcrumb\"><ng-container *ngFor=\"let p of tree\"><li class=\"breadcrumb-item\" *ngIf=\"!p.current\"><a class=\"breadcrumb-item\" [routerLink]=\"p.path\"><ng-container *ngIf=\"icons &amp;&amp; p.icon\"><i class=\"mr-2\" [ngClass]=\"p.icon\"></i>{{p.title}}</ng-container><ng-container *ngIf=\"!(icons &amp;&amp; p.icon)\">{{p.title}}</ng-container></a></li><li class=\"breadcrumb-item active\" aria-current=\"page\" *ngIf=\"p.current\"><ng-container *ngIf=\"icons &amp;&amp; p.icon\"><i class=\"mr-2\" [ngClass]=\"p.icon\"></i>{{p.title}}</ng-container><ng-container *ngIf=\"!(icons &amp;&amp; p.icon)\">{{p.title}}</ng-container></li></ng-container></ol></nav>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }]; }, { icons: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class BsacUtilsModule {
}
BsacUtilsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacUtilsModule });
BsacUtilsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacUtilsModule_Factory(t) { return new (t || BsacUtilsModule)(); }, providers: [
        BsacNativeInvokeService
    ], imports: [[
            CommonModule,
            RouterModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacUtilsModule, { declarations: function () { return [BsacAutoFocusDirective, BsacBreadcrumbComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [BsacAutoFocusDirective, BsacBreadcrumbComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacUtilsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule
                ],
                providers: [
                    BsacNativeInvokeService
                ],
                declarations: [
                    BsacAutoFocusDirective,
                    BsacBreadcrumbComponent
                ],
                exports: [
                    BsacAutoFocusDirective,
                    BsacBreadcrumbComponent
                ]
            }]
    }], null, null); })();

const bsacApplyMixins = (derivedCtor, baseCtors) => {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
};

/**
 * Trim string up to `count` characters, adding ellipsis if trimmed.
 *
 * Parameters :
 *
 * - count : default 20, trim after `count` characters.
 */
class BsacFormatTrimPipe {
    transform(value, count = 20) {
        if (value.length > count) {
            return value.substring(0, count) + "\u2026";
        }
        else {
            return value;
        }
    }
}
BsacFormatTrimPipe.ɵfac = function BsacFormatTrimPipe_Factory(t) { return new (t || BsacFormatTrimPipe)(); };
BsacFormatTrimPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacFormatTrim", type: BsacFormatTrimPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatTrimPipe, [{
        type: Pipe,
        args: [{
                name: "bsacFormatTrim"
            }]
    }], null, null); })();

/**
 * Displays an floating price with currency, by default rounded at cent : 1233 is displayed as 12.33 €
 * (number format uses default locale settings)
 *
 * Parameters (from [CurrencyPipe](https://angular.io/api/common/CurrencyPipe))
 *
 * - currencyCode: iso code for currency (default = EUR)
 * - display: code | symbol | symbol-narrow (default = symbol)
 * - digitInfo : {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
 * - locale: default = current locale
 *
 * Exemple
 *
 * ```html
 * <p>{{ model.price | bsacFormatIprice:'USD':'symbol':'3.2-2':"en-US" }}</p>
 * ```
 */
class BsacFormatPricePipe {
    constructor(_locale = "fr") {
        this._locale = _locale;
    }
    transform(value, currencyCode = "EUR", display = "symbol", digitInfo = "1.2-2", locale = null) {
        if (locale === null) {
            locale = this._locale;
        }
        const currencyPipe = new CurrencyPipe(locale);
        if (value === null || value === undefined) {
            return currencyPipe.transform(0, currencyCode, display, digitInfo, locale).replace(/0/g, "?");
        }
        else {
            return currencyPipe.transform(value, currencyCode, display, digitInfo, locale);
        }
    }
}
BsacFormatPricePipe.ɵfac = function BsacFormatPricePipe_Factory(t) { return new (t || BsacFormatPricePipe)(ɵngcc0.ɵɵdirectiveInject(LOCALE_ID)); };
BsacFormatPricePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacFormatPrice", type: BsacFormatPricePipe, pure: true });
BsacFormatPricePipe.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatPricePipe, [{
        type: Pipe,
        args: [{
                name: "bsacFormatPrice"
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

/**
 * Displays an integer price (in cents unit : 1233 = 12.33) with currency, by default
 * rounded at cent : 1233 is displayed as 12.33 € (number format uses default locale settings)
 *
 * Parameters (from [CurrencyPipe](https://angular.io/api/common/CurrencyPipe))
 *
 * - currencyCode: iso code for currency (default = EUR)
 * - display: code | symbol | symbol-narrow (default = symbol)
 * - digitInfo : {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
 * - locale: default = current locale
 *
 * Exemple
 *
 * ```html
 * <p>{{ model.price | bsacFormatIprice:'$':'pre':'nospace' }}
 * ```
 */
class BsacFormatIPricePipe {
    constructor(_locale = "fr") {
        this._locale = _locale;
    }
    transform(value, currencyCode = "EUR", display = "symbol", digitInfo = "1.2-2", locale = null) {
        if (locale === null) {
            locale = this._locale;
        }
        const currencyPipe = new CurrencyPipe(locale);
        if (value === null || value === undefined) {
            return currencyPipe.transform(0, currencyCode, display, digitInfo, locale).replace(/0/g, "?");
        }
        else {
            const val = value / 100;
            return currencyPipe.transform(val, currencyCode, display, digitInfo, locale);
        }
    }
}
BsacFormatIPricePipe.ɵfac = function BsacFormatIPricePipe_Factory(t) { return new (t || BsacFormatIPricePipe)(ɵngcc0.ɵɵdirectiveInject(LOCALE_ID)); };
BsacFormatIPricePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacFormatIPrice", type: BsacFormatIPricePipe, pure: true });
BsacFormatIPricePipe.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatIPricePipe, [{
        type: Pipe,
        args: [{
                name: "bsacFormatIPrice"
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

/**
 * Displays a note with 2 decimal precision. If bareme parameter is given, displays `nn.nn/bb`, or `nn` if not given.
 *
 * Parameters (some are from [DecimalPipe](https://angular.io/api/common/DecimalPipe))
 *
 * - bareme : bareme
 * - digitInfo: {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
 * - locale : default = current locale
 */
class BsacFormatNotePipe {
    constructor(_locale = "fr") {
        this._locale = _locale;
    }
    transform(value, bareme = null, digitInfo = "2.2-2", locale = null) {
        if (locale === null) {
            locale = this._locale;
        }
        const decimalPipe = new DecimalPipe(locale);
        let note = "";
        if (value === null || value === undefined) {
            note = decimalPipe.transform(0, digitInfo, locale).replace(/0/g, "?");
        }
        else {
            note = decimalPipe.transform(value, digitInfo, locale);
        }
        if (bareme) {
            return note + "\u202F/\u202F" + bareme.toString();
        }
        return note;
    }
}
BsacFormatNotePipe.ɵfac = function BsacFormatNotePipe_Factory(t) { return new (t || BsacFormatNotePipe)(ɵngcc0.ɵɵdirectiveInject(LOCALE_ID)); };
BsacFormatNotePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacFormatNote", type: BsacFormatNotePipe, pure: true });
BsacFormatNotePipe.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatNotePipe, [{
        type: Pipe,
        args: [{
                name: "bsacFormatNote"
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

/**
 * Display an id as `#id` or `-` if undefined.
 *
 * Example :
 *
 * ```html
 * <p>{{ model.id | bsacFormatId}}</p>
 * ```
 */
class BsacFormatIdPipe {
    transform(value) {
        if (value === -1 || value === undefined || value == null) {
            return "-";
        }
        else {
            return "#" + value.toString();
        }
    }
}
BsacFormatIdPipe.ɵfac = function BsacFormatIdPipe_Factory(t) { return new (t || BsacFormatIdPipe)(); };
BsacFormatIdPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacFormatId", type: BsacFormatIdPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatIdPipe, [{
        type: Pipe,
        args: [{
                name: "bsacFormatId"
            }]
    }], null, null); })();

/**
 * Display description from value, taking description in {name|desc, value} array.
 */
class BsacFormatRefPipe {
    transform(value, ref = []) {
        for (const r of ref) {
            if (value === r.value) {
                return `[${value}] ${r.name || r.desc}`;
            }
        }
        if (value === undefined || value === null) {
            return "???";
        }
        return `${value}`;
    }
}
BsacFormatRefPipe.ɵfac = function BsacFormatRefPipe_Factory(t) { return new (t || BsacFormatRefPipe)(); };
BsacFormatRefPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacFormatRef", type: BsacFormatRefPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatRefPipe, [{
        type: Pipe,
        args: [{
                name: "bsacFormatRef"
            }]
    }], null, null); })();

/**
 * Provides some useful & common pipes for display formatting :
 *
 * - [bsacFormatId](/pipes/BsacFormatIdPipe.html) : display an id as `#id` or `-` if undefined
 * - [bsacFormatIPrice](/pipes/BsacFormatIPricePipe.html) : display an integer price (cents unit) as `xxx.yy €` (currency can be changed)
 * - [bsacFormatNote](/pipes/BsacFormatNotePipe.html) : display a note as `xx/yy`
 * - [bsacFormatPrice](/pipes/BsacFormatPricePipe.html) : display a price (cents rounded) as `xxx.yy €` (currency can be changed)
 * - [bsacFormatRef](/pipes/BsacFormatRefPipe.html) : display a description for a value, from [{desc, value}] references
 * - [bsacFormatTrim](/pipes/BsacFormatTrimPipe.html) : display a trimmed output
 *
 */
class BsacFormatModule {
}
BsacFormatModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacFormatModule });
BsacFormatModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacFormatModule_Factory(t) { return new (t || BsacFormatModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacFormatModule, { declarations: function () { return [BsacFormatTrimPipe, BsacFormatPricePipe, BsacFormatIPricePipe, BsacFormatNotePipe, BsacFormatIdPipe, BsacFormatRefPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacFormatTrimPipe, BsacFormatPricePipe, BsacFormatIPricePipe, BsacFormatNotePipe, BsacFormatIdPipe, BsacFormatRefPipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormatModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BsacFormatTrimPipe,
                    BsacFormatPricePipe,
                    BsacFormatIPricePipe,
                    BsacFormatNotePipe,
                    BsacFormatIdPipe,
                    BsacFormatRefPipe
                ],
                exports: [
                    BsacFormatTrimPipe,
                    BsacFormatPricePipe,
                    BsacFormatIPricePipe,
                    BsacFormatNotePipe,
                    BsacFormatIdPipe,
                    BsacFormatRefPipe
                ]
            }]
    }], null, null); })();

var DEFAULT_TIMEOUTS;
(function (DEFAULT_TIMEOUTS) {
    DEFAULT_TIMEOUTS[DEFAULT_TIMEOUTS["SUCCESS"] = 3000] = "SUCCESS";
    DEFAULT_TIMEOUTS[DEFAULT_TIMEOUTS["INFO"] = 4000] = "INFO";
    DEFAULT_TIMEOUTS[DEFAULT_TIMEOUTS["WARNING"] = 10000] = "WARNING";
    DEFAULT_TIMEOUTS[DEFAULT_TIMEOUTS["DANGER"] = 30000] = "DANGER";
})(DEFAULT_TIMEOUTS || (DEFAULT_TIMEOUTS = {}));
var STATUS;
(function (STATUS) {
    STATUS[STATUS["UNDISP"] = 0] = "UNDISP";
    STATUS[STATUS["DISP"] = 1] = "DISP";
    STATUS[STATUS["ACK"] = 2] = "ACK";
})(STATUS || (STATUS = {}));
const DEFAULT_MESSAGE_TIMEOUT = 5000;
const BSAC_MESSAGE_SOUNDS = new InjectionToken("bsac.message.sounds");
class Message {
    constructor(title, type = 1 /* INFO */, message = "", trace = null, ttl = DEFAULT_MESSAGE_TIMEOUT) {
        this.title = title;
        this.type = type;
        this.message = message;
        this.trace = trace;
        this.ttl = ttl;
        this.status = STATUS[STATUS.UNDISP];
        this.showTrace = false;
    }
    get style() {
        if (this.type === 3 /* DANGER */) {
            return "alert alert-dismissible alert-danger";
        }
        if (this.type === 1 /* INFO */) {
            return "alert alert-dismissible alert-info";
        }
        if (this.type === 2 /* WARNING */) {
            return "alert alert-dismissible alert-warning";
        }
        if (this.type === 0 /* SUCCESS */) {
            return "alert alert-dismissible alert-success";
        }
        return "alert alert-dismissible alert-success";
    }
    ack() {
        this.status = STATUS[STATUS.ACK];
    }
}
class BsacMessageService {
    constructor(ngZone, sounds) {
        this.ngZone = ngZone;
        this.sounds = sounds;
        this._messages$ = new ReplaySubject(1);
        this._messages = [];
        this.init();
    }
    get current() {
        return this._messages$.asObservable();
    }
    init() {
        let changed = false;
        if (!this._timer) {
            this.ngZone.runOutsideAngular(() => {
                this._timer = timer(500, 500);
                this._subscription = this._timer.subscribe(() => {
                    for (const m of this._messages) {
                        m.ttl -= 500;
                        if (m.ttl <= 0) {
                            changed = true;
                        }
                    }
                    if (changed) {
                        this.ngZone.run(() => {
                            remove(this._messages, (m) => m.ttl < 0);
                            this._notify();
                        });
                    }
                });
            });
        }
    }
    close() {
        this._subscription.unsubscribe();
    }
    success(title, message = "", trace = null) {
        this._messages.push(new Message(title, 0 /* SUCCESS */, message, trace, DEFAULT_TIMEOUTS.SUCCESS));
        this._notify();
    }
    info(title, message = "", trace = null) {
        this._messages.push(new Message(title, 1 /* INFO */, message, trace, DEFAULT_TIMEOUTS.INFO));
        this._notify();
    }
    warning(title, message = "", trace = null) {
        this._messages.push(new Message(title, 2 /* WARNING */, message, trace, DEFAULT_TIMEOUTS.WARNING));
        this._notify();
    }
    danger(title, message = "", trace = null) {
        this._messages.push(new Message(title, 3 /* DANGER */, message, trace, DEFAULT_TIMEOUTS.DANGER));
        this._notify();
    }
    error(title, message = "", trace = null) {
        this.danger(title, message, trace);
    }
    debug(title, message = "", trace = null) {
        console.log(title, message, trace);
    }
    ack(message) {
        message.ack();
        this._notify();
    }
    play(type = "notify") {
        if (this.sounds && this.sounds[type]) {
            const audio = new Audio(this.sounds[type]);
            audio.play();
        }
    }
    _notify() {
        const out = [];
        for (const message of this._messages) {
            if ((message.status === STATUS[STATUS.UNDISP]) ||
                (message.status === STATUS[STATUS.DISP])) {
                message.status = STATUS[STATUS.DISP];
                out.push(message);
            }
        }
        this._messages$.next(out);
    }
}
BsacMessageService.ɵfac = function BsacMessageService_Factory(t) { return new (t || BsacMessageService)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(BSAC_MESSAGE_SOUNDS, 8)); };
BsacMessageService.ɵprov = ɵɵdefineInjectable({ factory: function BsacMessageService_Factory() { return new BsacMessageService(ɵɵinject(NgZone), ɵɵinject(BSAC_MESSAGE_SOUNDS, 8)); }, token: BsacMessageService, providedIn: "root" });
BsacMessageService.ctorParameters = () => [
    { type: NgZone },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_MESSAGE_SOUNDS,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacMessageService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_MESSAGE_SOUNDS]
            }] }]; }, null); })();

class BsacMessagesZoneComponent {
    constructor(messages) {
        this.messages = messages;
        this.current = [];
        this._subscriptions$ = new ReplaySubject();
    }
    ngOnInit() {
        this.messages.current.pipe(takeUntil(this._subscriptions$))
            .subscribe((messages) => {
            this.current = messages;
        });
    }
    ngOnDestroy() {
        this._subscriptions$.next();
        this._subscriptions$.complete();
    }
}
BsacMessagesZoneComponent.ɵfac = function BsacMessagesZoneComponent_Factory(t) { return new (t || BsacMessagesZoneComponent)(ɵngcc0.ɵɵdirectiveInject(BsacMessageService)); };
BsacMessagesZoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacMessagesZoneComponent, selectors: [["bsac-messages-zone"]], inputs: { filter: "filter" }, decls: 2, vars: 1, consts: [[1, "messagezone"], ["class", "alert", 3, "class", "click", 4, "ngFor", "ngForOf"], [1, "alert", 3, "click"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], ["class", "pretrace", 4, "ngIf"], [1, "pretrace"]], template: function BsacMessagesZoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BsacMessagesZoneComponent_div_1_Template, 8, 6, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.current);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf], styles: [".messagezone[_ngcontent-%COMP%]{position:fixed;top:30px;right:40px;width:35vw;height:auto;z-index:1050}.messagezone[_ngcontent-%COMP%]   .pretrace[_ngcontent-%COMP%]{white-space:pre-wrap;font-family:monospace;font-size:.7rem}"], data: { animation: [
            trigger("dispStatus", [
                transition("void => *", [
                    style({ opacity: 0 }),
                    animate(550, style({ opacity: 1 }))
                ]),
                transition("* => void", [
                    style({ opacity: "*" }),
                    animate(550, style({ opacity: 0 }))
                ])
            ])
        ] } });
BsacMessagesZoneComponent.ctorParameters = () => [
    { type: BsacMessageService }
];
BsacMessagesZoneComponent.propDecorators = {
    filter: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacMessagesZoneComponent, [{
        type: Component,
        args: [{
                selector: "bsac-messages-zone",
                template: "<div class=\"messagezone\"><div class=\"alert\" *ngFor=\"let message of current\" [@dispStatus]=\"message.status\" [class]=\"message.style\" (click)=\"message.showTrace=!message.showTrace\"><button class=\"close\" type=\"button\" (click)=\"messages.ack(message)\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><strong>{{message.title}}</strong>&nbsp; {{message.message}}<div class=\"pretrace\" *ngIf=\"message.showTrace\">{{message.trace}}</div></div></div>",
                animations: [
                    trigger("dispStatus", [
                        transition("void => *", [
                            style({ opacity: 0 }),
                            animate(550, style({ opacity: 1 }))
                        ]),
                        transition("* => void", [
                            style({ opacity: "*" }),
                            animate(550, style({ opacity: 0 }))
                        ])
                    ])
                ],
                styles: [".messagezone{position:fixed;top:30px;right:40px;width:35vw;height:auto;z-index:1050}.messagezone .pretrace{white-space:pre-wrap;font-family:monospace;font-size:.7rem}"]
            }]
    }], function () { return [{ type: BsacMessageService }]; }, { filter: [{
            type: Input
        }] }); })();

class BsacMessageModule {
}
BsacMessageModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacMessageModule });
BsacMessageModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacMessageModule_Factory(t) { return new (t || BsacMessageModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacMessageModule, { declarations: function () { return [BsacMessagesZoneComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacMessagesZoneComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacMessageModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [BsacMessagesZoneComponent],
                exports: [BsacMessagesZoneComponent]
            }]
    }], null, null); })();

/**
 * Full url of api endpoint for constants.
 */
const BSAC_API_CONSTANTS_URL = new InjectionToken("bsac.apiconstants.url");
/**
 * API constants response transform function.
 *
 * This function takes the result of the request for api constants, and returns an api constants list
 * with interface IApiConstantsResponse : {name: CONSTANT_NAME, constants: [{desc: description, value: value}},..].
 *
 * Defaults to identity.
 *
 */
const BSAC_API_CONSTANTS_TRANSFORM = new InjectionToken("bsac.apiconstants.transform");
/**
 * Headers for constants request.
 * Takes an object of headers.
 *
 * Default : no header.
 *
 */
const BSAC_API_CONSTANTS_HEADERS = new InjectionToken("bsac.apiconstants.headers");
/**
 * Provides acces to API constants
 *
 * 1. fetch constants (for example in resolve route)
 * 2. use them synchronously.
 *
 * API constants are fetched with fetch() from BSAC_API_CONSTANTS_URL using HttpClient, with
 * BSAC_API_CONSTANTS_HEADERS headers. Response from API, if not in IBsacApiConstantsResponse format,
 * can be transformed through BSAC_API_CONSTANTS_TRANSFORM function, to return a IBsacApiConstantsResponse object.
 *
 * Then get and getSync can be used to get values & desc associated with any constant name.
 */
class BsacApiConstantsService {
    constructor(_http, _api_url, _api_headers = null, _api_transform = null) {
        this._http = _http;
        this._api_url = _api_url;
        this._api_headers = _api_headers;
        this._api_transform = _api_transform;
        if (this._api_url === null) {
            this._api_url = "/api/constants";
        }
        if (this._api_headers === null) {
            this._api_headers = {};
        }
        if (this._api_transform === null) {
            this._api_transform = (res) => res;
        }
    }
    /**
     * Fetch (one time only) constants from API.
     *
     * Only the first call to tech results in an API call, subsequent calls
     * just use previous values.
     */
    fetch() {
        if (!this.constants$) {
            this.constants$ = new ReplaySubject(1);
        }
        const headers = this._api_headers;
        const options = { headers };
        this._http.get(this._api_url, options).pipe(map(this._api_transform)).subscribe((results) => {
            this._constants = {};
            for (const c of results) {
                this._constants[c.name] = c.constants;
            }
            this.constants$.next(this._constants);
        });
    }
    /**
     * Get constants values for `name` API constant, asynchronously.
     *
     * Returns an observable for IApiConstants values/descriptions. If values have not
     * been fetched beforehand, launches a fetch.
     *
     * @param name Constant name
     * @returns Observable of IBsacApiConstants values (empty if not found)
     */
    get(name) {
        if (!this.constants$) {
            this.constants$ = new ReplaySubject(1);
            this.fetch();
        }
        return this.constants$
            .pipe(map((cstts) => cstts[name] || []), first());
    }
    /**
     * Get constants values for `name` API constant, synchronously.
     *
     * If API constants values have not already been fetched, launches fetch
     * but don't wait for the results and return an empty array.
     *
     * @param name Constant name
     * @returns IBsacApiConstants values (empty if not found or API constants not yet fetched)
     */
    getSync(name) {
        if (!this.constants$) {
            // Ensure that fetch have been called, but don't wait for result
            this.get(name);
        }
        if (!this._constants) {
            return [];
        }
        return this._constants[name] || [];
    }
}
BsacApiConstantsService.ɵfac = function BsacApiConstantsService_Factory(t) { return new (t || BsacApiConstantsService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(BSAC_API_CONSTANTS_URL, 8), ɵngcc0.ɵɵinject(BSAC_API_CONSTANTS_HEADERS, 8), ɵngcc0.ɵɵinject(BSAC_API_CONSTANTS_TRANSFORM, 8)); };
BsacApiConstantsService.ɵprov = ɵɵdefineInjectable({ factory: function BsacApiConstantsService_Factory() { return new BsacApiConstantsService(ɵɵinject(HttpClient), ɵɵinject(BSAC_API_CONSTANTS_URL, 8), ɵɵinject(BSAC_API_CONSTANTS_HEADERS, 8), ɵɵinject(BSAC_API_CONSTANTS_TRANSFORM, 8)); }, token: BsacApiConstantsService, providedIn: "root" });
BsacApiConstantsService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_API_CONSTANTS_URL,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_API_CONSTANTS_HEADERS,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_API_CONSTANTS_TRANSFORM,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacApiConstantsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_API_CONSTANTS_URL]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_API_CONSTANTS_HEADERS]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_API_CONSTANTS_TRANSFORM]
            }] }]; }, null); })();

/**
 * Displays constant description from value, synchronously.
 *
 * - If constant is known, displays `[value] description`
 * - If constant is not found / not yet fetched, displays raw value + ?,
 *   or ??? for undefined values.
 *
 * ```html
 * <div>{{model.field | bsacApiConstant:CONSTANT_NAME}}</div>
 * ```
 */
class BsacApiConstantPipe {
    constructor(_cstt) {
        this._cstt = _cstt;
    }
    transform(value, ref) {
        for (const r of this._cstt.getSync(ref)) {
            if (value === r.value) {
                return `[${value}] ${r.desc}`;
            }
        }
        if (typeof value !== "undefined" || value != null) {
            try {
                return value.toString() + "?";
            }
            catch (e) {
                return "????";
            }
        }
        else {
            return "???";
        }
    }
}
BsacApiConstantPipe.ɵfac = function BsacApiConstantPipe_Factory(t) { return new (t || BsacApiConstantPipe)(ɵngcc0.ɵɵdirectiveInject(BsacApiConstantsService)); };
BsacApiConstantPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacApiConstant", type: BsacApiConstantPipe, pure: true });
BsacApiConstantPipe.ctorParameters = () => [
    { type: BsacApiConstantsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacApiConstantPipe, [{
        type: Pipe,
        args: [{
                name: "bsacApiConstant"
            }]
    }], function () { return [{ type: BsacApiConstantsService }]; }, null); })();

/**
 * Displays constant description from value, synchronously.
 *
 * - If constant is known, displays `[value] description`
 * - If constant is not found / not yet fetched, displays raw value + ?,
 *   or ??? for undefined values.
 *
 * ```html
 * <div>{{model.field | bsacApiConstant:CONSTANT_NAME}}</div>
 * ```
 */
class BsacApiConstantSinglePipe {
    constructor(_cstt) {
        this._cstt = _cstt;
    }
    transform(value, ref) {
        for (const r of this._cstt.getSync(ref)) {
            if (value === r.value) {
                return `${r.desc}`;
            }
        }
        if (typeof value !== "undefined" || value != null) {
            try {
                return value.toString() + "?";
            }
            catch (e) {
                return "????";
            }
        }
        else {
            return "???";
        }
    }
}
BsacApiConstantSinglePipe.ɵfac = function BsacApiConstantSinglePipe_Factory(t) { return new (t || BsacApiConstantSinglePipe)(ɵngcc0.ɵɵdirectiveInject(BsacApiConstantsService)); };
BsacApiConstantSinglePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "bsacApiConstantSingle", type: BsacApiConstantSinglePipe, pure: true });
BsacApiConstantSinglePipe.ctorParameters = () => [
    { type: BsacApiConstantsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacApiConstantSinglePipe, [{
        type: Pipe,
        args: [{
                name: "bsacApiConstantSingle"
            }]
    }], function () { return [{ type: BsacApiConstantsService }]; }, null); })();

/**
 * Provides constants from API.
 *
 * - [BsacApiConstantsService](/injectables/BsacApiConstantsService.html) fetches, stores and give access to constants.
 * - [BsacApiConstantPipe](/pipes/BsacApiConstantPipe.html) translates (synchronously) a constants value to it's desc
 */
class BsacApiConstantsModule {
}
BsacApiConstantsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacApiConstantsModule });
BsacApiConstantsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacApiConstantsModule_Factory(t) { return new (t || BsacApiConstantsModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacApiConstantsModule, { declarations: function () { return [BsacApiConstantPipe, BsacApiConstantSinglePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacApiConstantPipe, BsacApiConstantSinglePipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacApiConstantsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [BsacApiConstantPipe, BsacApiConstantSinglePipe],
                exports: [BsacApiConstantPipe, BsacApiConstantSinglePipe]
            }]
    }], null, null); })();

const BSAC_DATETIME_NATIVE = new InjectionToken("bsac.datetime.native");

// noinspection JSUnusedGlobalSymbols
/**
 * Datetime input using ng-bootstrap datepicker & timepicker.
 *
 * **warning** : this uses a modal window, so usage inside a modal is dangerous / not possible
 *
 * This is a standard input (e.g. formControlName, ngModel & validation ready)
 *
 * Parameters :
 *
 * - dateFormat: long, short, ... (parameters for angular DatePipe)
 * - ngModel or formControlName
 *
 * Outputs :
 *
 * - keyup : closed with save emitter
 * - escape : escaped (dismiss) emitter
 */
class BsacDatetimeInputComponent {
    constructor(_modal, globalNative = false) {
        this._modal = _modal;
        this.globalNative = globalNative;
        this.dateFormat = "short";
        this.dateFormatter = "YYYY-MM-dd";
        this.timeFormatter = "HH:mm";
        this.dateOnly = false;
        this.defaultTime = "12:00";
        this.escape = new EventEmitter();
        this.enter = new EventEmitter();
    }
    propagateChange(_) {
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
    }
    openModal(content) {
        this._modal.open(content).result.then((result) => {
            if (result === "save") {
                this.save();
            }
        });
    }
    ngOnInit() {
        if (this.native === undefined) {
            this.native = this.globalNative;
        }
        if (this.native) {
            const date = new Date();
            this.nativeForm = new FormGroup({
                nativeDate: new FormControl(format(date, "yyyy-MM-dd")),
                nativeTime: new FormControl(this.dateOnly ? this.defaultTime : format(date, "HH:mm"))
            });
            this.nativeForm.valueChanges.subscribe((_changes) => {
                // console.log .log("Changed", this.nativeForm.value.nativeDate, this.nativeForm.value.nativeTime);
                const curdate = new Date(this.nativeForm.value.nativeDate + " " + this.nativeForm.value.nativeTime);
                this.propagateChange(curdate);
            });
            this.writeNativeValue(new Date());
        }
        else {
            this.writeValue(new Date());
        }
    }
    writeNativeValue(inDate) {
        let date;
        if (inDate !== undefined && inDate !== null) {
            date = new Date(inDate);
        }
        else {
            date = new Date();
        }
        this.nativeForm.setValue({
            nativeDate: format(date, "yyyy-MM-dd"),
            nativeTime: format(date, "HH:mm")
        });
    }
    writeNgValue(obj) {
        if (obj !== undefined && obj !== null) {
            const date = new Date(obj);
            // console.log .log("Staring from date", date);
            this.ddate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
            this.ttime = { hour: date.getHours(), minute: date.getMinutes() };
            this.getDate();
        }
        else {
            const date = new Date();
            // console.log .log("Staring from now");
            this.ddate = { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
            this.ttime = { hour: date.getHours(), minute: date.getMinutes() };
            this.getDate();
        }
        // console.log .log("Write NG Value", this.curdate, this.ddate, this.ttime);
    }
    writeValue(obj) {
        // console.log .log("In date", obj, JSON.stringify(obj));
        if (this.native) {
            this.writeNativeValue(obj);
        }
        else {
            this.writeNgValue(obj);
        }
    }
    save() {
        // console.log .log("Saving with", this.ddate, this.ttime, this.curdate);
        this.getDate();
        this.propagateChange(this.curdate);
        // console.log .log("Propagated", this.curdate);
        this.enter.emit();
    }
    esc() {
        this.escape.emit();
    }
    getDate() {
        this.curdate = new Date(this.ddate.year, this.ddate.month - 1, this.ddate.day, this.ttime.hour, this.ttime.minute);
    }
}
BsacDatetimeInputComponent.ɵfac = function BsacDatetimeInputComponent_Factory(t) { return new (t || BsacDatetimeInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal), ɵngcc0.ɵɵdirectiveInject(BSAC_DATETIME_NATIVE, 8)); };
BsacDatetimeInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacDatetimeInputComponent, selectors: [["bsac-datetime-input"]], inputs: { dateFormat: "dateFormat", dateFormatter: "dateFormatter", timeFormatter: "timeFormatter", dateOnly: "dateOnly", defaultTime: "defaultTime", native: "native" }, outputs: { escape: "escape", enter: "enter" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => BsacDatetimeInputComponent),
                multi: true
            }
        ])], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "pointer", 3, "click"], [1, "fa", "fa-calendar-o", "mr-2"], ["modal", ""], [1, "modal-body"], [1, "picker"], [3, "ngModel", "startDate", "ngModelChange"], [3, "ngModel", "seconds", "ngModelChange", 4, "ngIf"], [1, "modal-footer"], [1, "btn", "btn-primary", 3, "click"], [1, "fa", "fa-save", "mr-2"], [1, "btn", "btn-warning", 3, "click"], [1, "fa", "fa-times", "mr-2"], [3, "ngModel", "seconds", "ngModelChange"], [3, "formGroup"], [1, "input-group"], ["type", "date", "formControlName", "nativeDate", 1, "form-control", "date", 3, "keyup.enter", "keyup.escape"], ["class", "form-control time", "type", "time", "formControlName", "nativeTime", 3, "keyup.enter", "keyup.escape", 4, "ngIf"], [1, "input-group-append"], [1, "btn", "btn-outline-secondary", 3, "click"], [1, "fa", "fa-check", "text-success"], [1, "fa", "fa-times", "text-warning"], ["type", "time", "formControlName", "nativeTime", 1, "form-control", "time", 3, "keyup.enter", "keyup.escape"]], template: function BsacDatetimeInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacDatetimeInputComponent_ng_container_0_Template, 7, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, BsacDatetimeInputComponent_ng_container_1_Template, 10, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.native);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.native);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgbDatepicker, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc4.NgbTimepicker, ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.FormControlName], pipes: [ɵngcc1.DatePipe], styles: [".picker[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center}.picker[_ngcontent-%COMP%]   ngb-timepicker[_ngcontent-%COMP%]{margin-left:10px}.native[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;width:100%}"] });
BsacDatetimeInputComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_DATETIME_NATIVE,] }] }
];
BsacDatetimeInputComponent.propDecorators = {
    native: [{ type: Input }],
    dateFormat: [{ type: Input }],
    dateFormatter: [{ type: Input }],
    timeFormatter: [{ type: Input }],
    dateOnly: [{ type: Input }],
    defaultTime: [{ type: Input }],
    escape: [{ type: Output }],
    enter: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacDatetimeInputComponent, [{
        type: Component,
        args: [{
                selector: "bsac-datetime-input",
                template: "<!DOCTYPE html><ng-container *ngIf=\"!native\"><a class=\"pointer\" (click)=\"openModal(modal)\"><i class=\"fa fa-calendar-o mr-2\"></i><ng-container *ngIf=\"curdate\">{{curdate|date:dateFormat}}</ng-container><ng-container *ngIf=\"!curdate\">????</ng-container></a><ng-template #modal let-c=\"close\" let-d=\"dismiss\"><div class=\"modal-body\"><div class=\"picker\"><ngb-datepicker [(ngModel)]=\"ddate\" [startDate]=\"ddate\"></ngb-datepicker><ngb-timepicker [(ngModel)]=\"ttime\" [seconds]=\"false\" *ngIf=\"!dateOnly\"></ngb-timepicker></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" (click)=\"c('save')\"><i class=\"fa fa-save mr-2\"></i>Enregistrer</button><button class=\"btn btn-warning\" (click)=\"d('cancel')\"><i class=\"fa fa-times mr-2\"></i>Annuler</button></div></ng-template></ng-container><ng-container *ngIf=\"native\"><form [formGroup]=\"nativeForm\"><div class=\"input-group\"><input class=\"form-control date\" type=\"date\" formControlName=\"nativeDate\" (keyup.enter)=\"enter.emit()\" (keyup.escape)=\"escape.emit()\"><input class=\"form-control time\" type=\"time\" formControlName=\"nativeTime\" (keyup.enter)=\"enter.emit()\" (keyup.escape)=\"escape.emit()\" *ngIf=\"!dateOnly\"><div class=\"input-group-append\"><button class=\"btn btn-outline-secondary\" (click)=\"enter.emit()\"><i class=\"fa fa-check text-success\"></i></button><button class=\"btn btn-outline-secondary\" (click)=\"escape.emit()\"><i class=\"fa fa-times text-warning\"></i></button></div></div></form></ng-container>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => BsacDatetimeInputComponent),
                        multi: true
                    }
                ],
                styles: [".picker{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center}.picker ngb-timepicker{margin-left:10px}.native{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgbModal }, { type: Boolean, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_DATETIME_NATIVE]
            }] }]; }, { dateFormat: [{
            type: Input
        }], dateFormatter: [{
            type: Input
        }], timeFormatter: [{
            type: Input
        }], dateOnly: [{
            type: Input
        }], defaultTime: [{
            type: Input
        }], escape: [{
            type: Output
        }], enter: [{
            type: Output
        }], native: [{
            type: Input
        }] }); })();

// FIXME: get type and validators form model field meta description
/**
 * dt / dd field for field display / edit combo.
 *
 * If custom display is true, takes title from .desc, and non-edit mode display
 * from .value ng-content
 *
 * Inputs :
 *
 * - model : IDSModel object
 * - field : model field name
 * - edit : global edition store (default: {})
 * - editable : boolean (field can be edited, default = true)
 * - custom : custom display (default = false)
 * - type : input type (default = text)
 * - choices : choices values for select-like values
 * - validators : array of validators (default : [])
 * - asyncValidators : array of AsyncValidators (default: [])
 */
class BsacDdFieldComponent {
    constructor(cstt, _msg) {
        this.cstt = cstt;
        this._msg = _msg;
        this.edit = {};
        this.editable = true;
        this.custom = false;
        // Types list : text, trtext, trmltext, textarea, number, date, datetime, select, auto
        this.type = "text";
        this.choices = [];
        this.validators = [];
        this.asyncvalidators = [];
        // Validation button
        this.btn = false;
        this.dateFormat = "short";
        this.dateFormatter = "yyyy-MM-dd";
        this.timeFormatter = "HH:mm";
        this.defaultTime = "12:00";
        this.relatedFilter = {};
        this.relatedParams = {};
        this.relatedLabel = "Select item";
        this.relatedSearchparam = "search";
        this.relatedEmpty = "-----";
        this.changed = new EventEmitter();
        this.relatedSelected = new EventEmitter();
        // Default field json
        this.json = "";
    }
    /**
     * Field creation.
     *
     * If field is described from DSModel field decorators, use it's validators and choices.
     * If field type is "auto", also uses field type from decorator.
     */
    ngOnInit() {
        if (this.desctpl) {
            this.tpl = template(this.desctpl);
        }
        else if (this.descfield) {
            this.tpl = template("<%= " + this.descfield + " %>");
        }
        if (this.model && this.field) {
            // Validators preparation
            let validators = this.validators;
            const asyncvalidators = this.asyncvalidators;
            if (this.model._fields && this.model._fields[this.field]) {
                // This is a described field from DSModel
                const field = this.model._fields[this.field];
                validators = validators.concat(field.validators);
                // TODO: add async validation
                // asyncvalidators = asyncvalidators.concat(field.asyncvalidators);
                // Auto type, use field description
                if (this.type === "auto") {
                    const MAP = {
                        charfield: "text",
                        textfield: "textarea",
                        integerfield: "number",
                        decimalfield: "decimal",
                        datefield: "date",
                        datetimefield: "datetime",
                        slugfield: "text",
                        autofield: "readonly",
                        booleanfield: "boolean",
                        foreignkey: "foreignkey",
                        manytomanyfield: "manytomany",
                        defaultfield: "json"
                    };
                    this.type = MAP[field.type] || "text";
                    // TODO: add readonly for autofield
                    if (field.choices && field.choices.length) {
                        this.type = "select";
                        this.choices = map$1(field.choices, (ch) => ({ desc: ch[1], value: ch[0] }));
                    }
                    if (this.type === "decimal") {
                        if (field.factor) {
                            this.factor = field.factor;
                        }
                    }
                    if (["charfield", "textfield", "slugfield"].indexOf(field.type) !== -1) {
                        if (field.i18n) {
                            this.i18n = { model: this.model, field: this.field };
                        }
                    }
                }
            }
            if (this.type === "readonly") {
                this.editable = false;
                this.type = "text";
            }
            if (this.type === "json") {
                this.json = JSON.stringify(this.model[this.field], null, 2);
            }
            // Create control
            this.editForm = new FormGroup({
                edit: new FormControl(this.type === "json" ? this.json : this.model[this.field], validators, asyncvalidators)
            });
        }
        else {
            console.warn("Invalid model / field for dd field", this.model, this.field);
            this.editForm = new FormGroup({ edit: new FormControl("") });
        }
    }
    /**
     * Deactivate edit mode if field is not editable.
     *
     * @param changes changeset
     */
    ngOnChanges(changes) {
        if (!this.editable) {
            this.edit[this.field] = false;
        }
    }
    /**
     * Save field.
     *
     * @param value if ___clear___ set to null, if not given use editForm.value.edit
     * @param continueEdit continue edit after save (default = false)
     * @returns success status (boolean)
     */
    save(value = null, continueEdit = false) {
        if (this.editForm.valid) {
            if (value === null) {
                if (this.type === "json") {
                    this.model[this.field] = JSON.parse(this.editForm.value.edit);
                    this.json = this.editForm.value.edit;
                }
                else {
                    this.model[this.field] = this.editForm.value.edit;
                }
            }
            else if (value === "___clear___") {
                this.model[this.field] = null;
            }
            else {
                this.model[this.field] = value;
            }
            // console.log("Model field value", this.model[this.field]);
            this.model.update([this.field]).subscribe((_result) => {
                this._msg.success("Saved");
                this.changed.emit(this.model[this.field]);
                if (!continueEdit) {
                    this.edit[this.field] = false;
                }
            }, (error) => {
                this._msg.error("Saving failed", "API Return : " + error.toString(), error._body);
            });
        }
        return false;
    }
    /**
     * Change mode to `status`
     *
     * - if status is null, switch between edit modes
     * - if status is true, force to editing mode
     * - if status is false, force to non-editing mode
     *
     * @param status mode status
     */
    changeMode(status = null) {
        if (this.editable) {
            if (status === null) {
                this.edit[this.field] = !this.edit[this.field];
            }
            else {
                this.edit[this.field] = status;
            }
        }
    }
    /**
     * Return description for value, using provided choices from getChoices().
     *
     * If no description found, returns value + ???
     *
     * @param value value to get description for
     * @returns observable for description
     */
    getDesc(value) {
        return this.getChoices().pipe(map((choices) => {
            if (choices && choices.length) {
                for (const c of choices) {
                    if (c.value === value) {
                        return c.desc;
                    }
                }
            }
            return value + " ???";
        }));
    }
    /**
     * Returns an array of choices from `choices` parameter.
     *
     * - if `choices` is a string, tries to get ApiConstant values with this name
     * - if `choices` is an {value, desc} array, returns it.
     *
     * @returns IBsacApiConstants list
     */
    getChoices() {
        if (typeof this.choices === "string" || this.choices instanceof String) {
            return this.cstt.get(this.choices);
        }
        else {
            return of((this.choices || []));
        }
    }
    /**
     * Save selected foreign key value & close edition.
     *
     * @param item foreign key item.
     */
    onFkSelect(item) {
        this.save(item.id);
        this.relatedSelected.emit(item);
    }
    onFkClear() {
        this.save("___clear___");
        this.relatedSelected.emit(null);
    }
    onM2mChanged(change) {
        this.editForm.setValue({ edit: this.model[this.field] });
        this.model[this.field + "_details"] = [];
        for (const r of change.data) {
            this.model[this.field + "_details"].push(r.m2mModel);
        }
        this.save(change.ids, true);
    }
}
BsacDdFieldComponent.ɵfac = function BsacDdFieldComponent_Factory(t) { return new (t || BsacDdFieldComponent)(ɵngcc0.ɵɵdirectiveInject(BsacApiConstantsService), ɵngcc0.ɵɵdirectiveInject(BsacMessageService)); };
BsacDdFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacDdFieldComponent, selectors: [["bsac-dd-field"]], inputs: { edit: "edit", editable: "editable", custom: "custom", type: "type", choices: "choices", validators: "validators", asyncvalidators: "asyncvalidators", btn: "btn", dateFormat: "dateFormat", dateFormatter: "dateFormatter", timeFormatter: "timeFormatter", defaultTime: "defaultTime", relatedFilter: "relatedFilter", relatedParams: "relatedParams", relatedLabel: "relatedLabel", relatedSearchparam: "relatedSearchparam", relatedEmpty: "relatedEmpty", factor: "factor", model: "model", field: "field", desctpl: "desctpl", descfield: "descfield", native: "native", related: "related", relatedQueryset: "relatedQueryset", relatedReset: "relatedReset", relatedLink: "relatedLink" }, outputs: { changed: "changed", relatedSelected: "relatedSelected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 7, vars: 5, consts: [[3, "ref", "type", 4, "ngIf"], [1, "pointer", "pointer", 3, "click"], [4, "ngIf"], ["class", "pointer", 4, "ngIf"], [3, "ref", "type"], [1, "pointer"], [3, "click", 4, "ngIf"], [3, "click"], ["class", "textdisplay", 3, "click", 4, "ngIf"], [1, "textdisplay", 3, "click"], [1, "fa", "fa-check", "mr-1"], [1, "fa", "fa-times", "mr-1"], ["mode", "select", "saveMethod", "none", 3, "model", "field", "edit", "desctpl", "descfield", "related", "relatedFilter", "readonly", "m2mLink"], [3, "formGroup"], ["formControlName", "edit", 3, "native", "dateOnly", "defaultTime", "dateFormat", "dateFormatter", "timeFormatter", "enter", "escape", 4, "ngIf"], ["formControlName", "edit", 3, "native", "dateFormat", "dateFormatter", "timeFormatter", "enter", "escape", 4, "ngIf"], ["class", "form-control", "formControlName", "edit", 3, "change", "keyup.escape", 4, "ngIf"], ["type", "text", "formControlName", "edit", "bsacAutoFocus", "bsacAutoFocus", 1, "form-control", 3, "keyup.enter", "keyup.escape"], ["class", "text-danger form-error", 4, "ngIf"], [1, "text-danger", "form-error"], ["formControlName", "edit", 1, "form-control", 3, "keydown.control.enter", "keyup.escape"], ["class", "btn btn-block btn-sm", 3, "click", 4, "ngIf"], [1, "btn", "btn-block", "btn-sm", 3, "click"], [1, "fa", "fa-save"], ["type", "number", "formControlName", "edit", "bsacAutoFocus", "bsacAutoFocus", 1, "form-control", 3, "keyup.enter", "keyup.escape"], ["formControlName", "edit", "bsacAutoFocus", "bsacAutoFocus", 3, "factor", "keyup.enter", "keyup.escape"], ["formControlName", "edit", 3, "native", "dateOnly", "defaultTime", "dateFormat", "dateFormatter", "timeFormatter", "enter", "escape"], ["formControlName", "edit", 3, "native", "dateFormat", "dateFormatter", "timeFormatter", "enter", "escape"], ["formControlName", "edit", 1, "form-control", 3, "change", "keyup.escape"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "custom-control", "custom-radio"], ["type", "radio", "name", "edit", "formControlName", "edit", 1, "custom-control-input", 3, "value", "change"], [1, "custom-control-indicator"], [1, "custom-control-description"], [3, "queryset", "context", "desctpl", "descfield", "label", "filter", "reset", "searchparam", "selected", "clear"], ["mode", "select", "saveMethod", "none", 3, "model", "field", "edit", "desctpl", "descfield", "relatedParams", "related", "relatedFilter", "m2mLink", "m2mChanged"], [1, "m2madd"]], template: function BsacDdFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "dt");
        ɵngcc0.ɵɵtemplate(1, BsacDdFieldComponent_bsac_i18n_1_Template, 1, 2, "bsac-i18n", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacDdFieldComponent_Template_div_click_2_listener() { return ctx.changeMode(); });
        ɵngcc0.ɵɵtemplate(3, BsacDdFieldComponent_ng_content_3_Template, 1, 0, "ng-content", 2);
        ɵngcc0.ɵɵtemplate(4, BsacDdFieldComponent_ng_content_4_Template, 1, 0, "ng-content", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BsacDdFieldComponent_dd_5_Template, 3, 2, "dd", 3);
        ɵngcc0.ɵɵtemplate(6, BsacDdFieldComponent_dd_6_Template, 13, 12, "dd", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.i18n);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.custom);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.custom);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.edit[ctx.field]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.edit[ctx.field]);
    } }, directives: function () { return [ɵngcc1.NgIf, BsacI18nComponent, BsacM2mFieldComponent, ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, BsacAutoFocusDirective, ɵngcc5.NumberValueAccessor, BsacDecimalInputComponent, BsacDatetimeInputComponent, ɵngcc5.SelectControlValueAccessor, ɵngcc1.NgForOf, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x, ɵngcc5.RadioControlValueAccessor, BsacSelectRelatedComponent]; }, pipes: function () { return [ɵngcc1.DatePipe, ɵngcc1.AsyncPipe]; }, styles: [".ng-invalid[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], input.ng-invalid[_ngcontent-%COMP%]{border-right:5px solid red}.ng-valid[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], input.ng-valid[_ngcontent-%COMP%]{border-right:5px solid green}.textdisplay[_ngcontent-%COMP%]{white-space:pre-wrap;max-height:300px;overflow:auto}.pointer[_ngcontent-%COMP%]{cursor:pointer}"] });
BsacDdFieldComponent.ctorParameters = () => [
    { type: BsacApiConstantsService },
    { type: BsacMessageService }
];
BsacDdFieldComponent.propDecorators = {
    model: [{ type: Input }],
    field: [{ type: Input }],
    edit: [{ type: Input }],
    editable: [{ type: Input }],
    custom: [{ type: Input }],
    type: [{ type: Input }],
    choices: [{ type: Input }],
    validators: [{ type: Input }],
    asyncvalidators: [{ type: Input }],
    btn: [{ type: Input }],
    factor: [{ type: Input }],
    desctpl: [{ type: Input }],
    descfield: [{ type: Input }],
    native: [{ type: Input }],
    dateFormat: [{ type: Input }],
    dateFormatter: [{ type: Input }],
    timeFormatter: [{ type: Input }],
    defaultTime: [{ type: Input }],
    related: [{ type: Input }],
    relatedQueryset: [{ type: Input }],
    relatedFilter: [{ type: Input }],
    relatedParams: [{ type: Input }],
    relatedLabel: [{ type: Input }],
    relatedReset: [{ type: Input }],
    relatedSearchparam: [{ type: Input }],
    relatedLink: [{ type: Input }],
    relatedEmpty: [{ type: Input }],
    changed: [{ type: Output }],
    relatedSelected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacDdFieldComponent, [{
        type: Component,
        args: [{
                selector: "bsac-dd-field",
                template: "<dt><bsac-i18n [ref]=\"i18n\" *ngIf=\"i18n\" [type]=\"type\"></bsac-i18n><div class=\"pointer pointer\" (click)=\"changeMode()\"><ng-content *ngIf=\"custom\" select=\".desc\"></ng-content><ng-content *ngIf=\"!custom\"></ng-content></div></dt><dd class=\"pointer\" *ngIf=\"!edit[field]\"><div *ngIf=\"custom\" (click)=\"changeMode(true)\"><ng-content select=\".value\"></ng-content></div><ng-container *ngIf=\"!custom\"><div *ngIf=\"type=='text'\" (click)=\"changeMode(true)\"><ng-container>{{model[field] || '???'}}</ng-container></div><div class=\"textdisplay\" *ngIf=\"type=='textarea'\" (click)=\"changeMode(true)\"><ng-container>{{model[field] || '???'}}</ng-container></div><div *ngIf=\"type=='number'\" (click)=\"changeMode(true)\"><span *ngIf=\"model[field]===null\">???</span><span *ngIf=\"model[field]!==null\">{{model[field]}}</span></div><div *ngIf=\"type=='decimal'\" (click)=\"changeMode(true)\"><span *ngIf=\"model[field]===null || model[field]===undefined\">???</span><span *ngIf=\"!(model[field]===null || model[field]===undefined)\"><ng-container *ngIf=\"factor\">{{model[field]/factor}}</ng-container><ng-container *ngIf=\"!factor\">{{model[field]}}</ng-container></span></div><div *ngIf=\"type=='date'\" (click)=\"changeMode(true)\"><ng-container *ngIf=\"model[field]\">{{model[field]|date:dateFormat}}</ng-container><ng-container *ngIf=\"!model[field]\">????</ng-container></div><div *ngIf=\"type=='datetime'\" (click)=\"changeMode(true)\"><ng-container *ngIf=\"model[field]\">{{model[field]|date:dateFormat}}</ng-container><ng-container *ngIf=\"!model[field]\">????</ng-container></div><div *ngIf=\"type=='select'\" (click)=\"changeMode(true)\">{{getDesc(model[field])|async}}</div><div *ngIf=\"type=='boolean'\" (click)=\"changeMode(true)\"><span *ngIf=\"model[field]\"><i class=\"fa fa-check mr-1\"></i>Yes</span><span *ngIf=\"!model[field]\"><i class=\"fa fa-times mr-1\"></i>No</span></div><div *ngIf=\"type=='foreignkey'\" (click)=\"changeMode(true)\"><span *ngIf=\"tpl &amp;&amp; model[field+'_details']\">{{tpl(model[field+\"_details\"])}}</span><span *ngIf=\"!tpl || !model[field+'_details']\">{{model[field] || relatedEmpty}}</span></div><div *ngIf=\"type=='manytomany'\"><bsac-m2m-field mode=\"select\" [model]=\"model\" [field]=\"field\" [edit]=\"edit\" [desctpl]=\"desctpl\" [descfield]=\"descfield\" [related]=\"related\" [relatedFilter]=\"relatedFilter\" saveMethod=\"none\" [readonly]=\"!editable\" [m2mLink]=\"relatedLink\"></bsac-m2m-field></div><div class=\"textdisplay\" *ngIf=\"type=='json'\" (click)=\"changeMode(true)\"><pre>{{json||'????'}}</pre></div></ng-container></dd><dd *ngIf=\"edit[field]\"><form [formGroup]=\"editForm\"><ng-container *ngIf=\"type=='text'\"><input class=\"form-control\" type=\"text\" (keyup.enter)=\"save()\" (keyup.escape)=\"edit[field]=false\" formControlName=\"edit\" bsacAutoFocus=\"bsacAutoFocus\"/><div class=\"text-danger form-error\" *ngIf=\"editForm.get('edit').invalid\"><div *ngIf=\"editForm.get('edit').errors.required\">Ce champ est requis</div><div *ngIf=\"editForm.get('edit').errors.pattern\">Syntaxe invalide</div><div *ngIf=\"editForm.get('edit').errors.minlength\">Trop court</div><div *ngIf=\"editForm.get('edit').errors.maxlength\">Trop long</div><div *ngIf=\"editForm.get('edit').errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></ng-container><ng-container *ngIf=\"type=='textarea'\"><textarea class=\"form-control\" (keydown.control.enter)=\"save()\" (keyup.escape)=\"edit[field]=false\" formControlName=\"edit\"></textarea><div class=\"text-danger form-error\" *ngIf=\"editForm.get('edit').invalid\"><div *ngIf=\"editForm.get('edit').errors.required\">Ce champ est requis</div><div *ngIf=\"editForm.get('edit').errors.pattern\">Syntaxe invalide</div><div *ngIf=\"editForm.get('edit').errors.minlength\">Trop court</div><div *ngIf=\"editForm.get('edit').errors.maxlength\">Trop long</div><div *ngIf=\"editForm.get('edit').errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div><button class=\"btn btn-block btn-sm\" *ngIf=\"btn\" (click)=\"save()\"><i class=\"fa fa-save\"></i></button></ng-container><ng-container *ngIf=\"type=='number'\"><input class=\"form-control\" type=\"number\" (keyup.enter)=\"save()\" (keyup.escape)=\"edit[field]=false\" formControlName=\"edit\" bsacAutoFocus=\"bsacAutoFocus\"/><div class=\"text-danger form-error\" *ngIf=\"editForm.get('edit').invalid\"><div *ngIf=\"editForm.get('edit').errors.required\">Ce champ est requis</div><div *ngIf=\"editForm.get('edit').errors.pattern\">Syntaxe invalide</div><div *ngIf=\"editForm.get('edit').errors.min\">Trop petit</div><div *ngIf=\"editForm.get('edit').errors.max\">Trop grand</div><div *ngIf=\"editForm.get('edit').errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></ng-container><ng-container *ngIf=\"type=='decimal'\"><bsac-decimal-input [factor]=\"factor\" (keyup.enter)=\"save()\" (keyup.escape)=\"edit[field]=false\" formControlName=\"edit\" bsacAutoFocus=\"bsacAutoFocus\"></bsac-decimal-input><div class=\"text-danger form-error\" *ngIf=\"editForm.get('edit').invalid\"><div *ngIf=\"editForm.get('edit').errors.required\">Ce champ est requis</div><div *ngIf=\"editForm.get('edit').errors.pattern\">Syntaxe invalide</div><div *ngIf=\"editForm.get('edit').errors.min\">Trop petit</div><div *ngIf=\"editForm.get('edit').errors.max\">Trop grand</div><div *ngIf=\"editForm.get('edit').errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></ng-container><bsac-datetime-input *ngIf=\"type=='date'\" [native]=\"native\" [dateOnly]=\"true\" [defaultTime]=\"defaultTime\" [dateFormat]=\"dateFormat\" [dateFormatter]=\"dateFormatter\" [timeFormatter]=\"timeFormatter\" (enter)=\"save()\" (escape)=\"edit[field]=false\" formControlName=\"edit\"></bsac-datetime-input><bsac-datetime-input *ngIf=\"type=='datetime'\" [native]=\"native\" [dateFormat]=\"dateFormat\" [dateFormatter]=\"dateFormatter\" [timeFormatter]=\"timeFormatter\" (enter)=\"save()\" (escape)=\"edit[field]=false\" formControlName=\"edit\"></bsac-datetime-input><select class=\"form-control\" *ngIf=\"type=='select'\" formControlName=\"edit\" (change)=\"save($event.target.value)\" (keyup.escape)=\"edit[field]=false\"><option *ngFor=\"let o of getChoices()|async\" [value]=\"o.value\">{{o.desc}}</option></select><div *ngIf=\"type=='boolean'\"><label class=\"custom-control custom-radio\"><input class=\"custom-control-input\" type=\"radio\" name=\"edit\" formControlName=\"edit\" [value]=\"true\" (change)=\"save(); edit[field]=false\"/><span class=\"custom-control-indicator\"></span><span class=\"custom-control-description\">Yes</span></label><label class=\"custom-control custom-radio\"><input class=\"custom-control-input\" type=\"radio\" name=\"edit\" formControlName=\"edit\" [value]=\"false\" (change)=\"save(); edit[field]=false\"/><span class=\"custom-control-indicator\"></span><span class=\"custom-control-description\">No</span></label></div><div *ngIf=\"type=='foreignkey'\"><bsac-select-related [queryset]=\"related.queryset\" [context]=\"relatedParams\" [desctpl]=\"desctpl\" [descfield]=\"descfield\" [label]=\"relatedLabel\" [filter]=\"relatedFilter\" [reset]=\"relatedReset\" [searchparam]=\"relatedSearchparam\" (selected)=\"onFkSelect($event)\" (clear)=\"onFkClear()\"></bsac-select-related></div><div *ngIf=\"type=='manytomany'\"><bsac-m2m-field mode=\"select\" [model]=\"model\" [field]=\"field\" [edit]=\"edit\" [desctpl]=\"desctpl\" [descfield]=\"descfield\" [relatedParams]=\"relatedParams\" [related]=\"related\" [relatedFilter]=\"relatedFilter\" saveMethod=\"none\" [m2mLink]=\"relatedLink\" (m2mChanged)=\"onM2mChanged($event)\"><span class=\"m2madd\">{{relatedLabel}}</span></bsac-m2m-field></div><ng-container *ngIf=\"type=='json'\"><textarea class=\"form-control\" (keydown.control.enter)=\"save()\" (keyup.escape)=\"edit[field]=false\" formControlName=\"edit\"></textarea><div class=\"text-danger form-error\" *ngIf=\"editForm.get('edit').invalid\"><div *ngIf=\"editForm.get('edit').errors.required\">Ce champ est requis</div><div *ngIf=\"editForm.get('edit').errors.pattern\">Syntaxe invalide</div><div *ngIf=\"editForm.get('edit').errors.minlength\">Trop court</div><div *ngIf=\"editForm.get('edit').errors.maxlength\">Trop long</div><div *ngIf=\"editForm.get('edit').errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div><button class=\"btn btn-block btn-sm\" *ngIf=\"btn\" (click)=\"save()\"><i class=\"fa fa-save\"></i></button></ng-container></form></dd>",
                styles: [".ng-invalid input,input.ng-invalid{border-right:5px solid red}.ng-valid input,input.ng-valid{border-right:5px solid green}.textdisplay{white-space:pre-wrap;max-height:300px;overflow:auto}.pointer{cursor:pointer}"]
            }]
    }], function () { return [{ type: BsacApiConstantsService }, { type: BsacMessageService }]; }, { edit: [{
            type: Input
        }], editable: [{
            type: Input
        }], custom: [{
            type: Input
        }], type: [{
            type: Input
        }], choices: [{
            type: Input
        }], validators: [{
            type: Input
        }], asyncvalidators: [{
            type: Input
        }], btn: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], dateFormatter: [{
            type: Input
        }], timeFormatter: [{
            type: Input
        }], defaultTime: [{
            type: Input
        }], relatedFilter: [{
            type: Input
        }], relatedParams: [{
            type: Input
        }], relatedLabel: [{
            type: Input
        }], relatedSearchparam: [{
            type: Input
        }], relatedEmpty: [{
            type: Input
        }], changed: [{
            type: Output
        }], relatedSelected: [{
            type: Output
        }], factor: [{
            type: Input
        }], model: [{
            type: Input
        }], field: [{
            type: Input
        }], desctpl: [{
            type: Input
        }], descfield: [{
            type: Input
        }], native: [{
            type: Input
        }], related: [{
            type: Input
        }], relatedQueryset: [{
            type: Input
        }], relatedReset: [{
            type: Input
        }], relatedLink: [{
            type: Input
        }] }); })();

class FrenchDateFormatter {
    parse(value) {
        const dt = parse(value, "dd/MM/yyyy", new Date());
        return {
            year: dt.getUTCFullYear(),
            month: dt.getUTCMonth(),
            day: dt.getUTCDate()
        };
    }
    format(date) {
        if (date === null) {
            return "";
        }
        const dt = new Date(date.year, date.month, date.day);
        return format$1(dt, "dd/MM/yyyy");
    }
}
FrenchDateFormatter.ɵfac = function FrenchDateFormatter_Factory(t) { return new (t || FrenchDateFormatter)(); };
FrenchDateFormatter.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FrenchDateFormatter, factory: FrenchDateFormatter.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FrenchDateFormatter, [{
        type: Injectable
    }], null, null); })();
class BsacFieldControlComponent {
    constructor(_formatter) {
        this._formatter = _formatter;
        this.validators = [];
        this.asyncvalidators = [];
        this.dateFormat = "short";
        this.dateFormatter = "yyyy-MM-dd";
        this.timeFormatter = "HH:mm";
        this.defaultTime = "12:00";
        this.descfield = "name";
        this.relatedFilter = {};
        this.relatedLabel = "Select item";
        this.relatedSearchparam = "search";
        this.relatedParams = {};
        this.relatedMode = "autocomplete";
        this.relatedSelected = new EventEmitter();
        this.mrelated = [];
        this.madd = false;
        this.search = this._search.bind(this);
        this.display = this._display.bind(this);
        this._subscription = new Subject();
    }
    ngOnDestroy() {
        this._subscription.next();
        this._subscription.complete();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // Prepare validators
            let validators = this.validators;
            let asyncvalidators = this.asyncvalidators;
            // Prepare desc template for related
            if (this.desctpl) {
                this.tpl = template(this.desctpl);
            }
            else if (this.descfield) {
                this.tpl = template("<%= " + this.descfield + " %>");
            }
            // Model defined ? use model validators
            if (this.model && this.model._fields) {
                this.mfield = this.model._fields[this.field];
                if (this.mfield.validators) {
                    validators = validators.concat(this.mfield.validators);
                }
                // TODO: add async validation
                if (this.mfield.asyncvalidators) {
                    asyncvalidators = asyncvalidators.concat(this.mfield.asyncvalidators);
                }
            }
            else {
                this.mfield = { type: "charfield" };
            }
            // Process for special cases (choices, fk...)
            this.type = this.mfield.type;
            if (this.mfield.choices && this.mfield.choices.length) {
                // choices enabled
                this.type = "selectfield";
                this.choices = this.mfield.choices;
            }
            if (this.mfield.type === "foreignkey") {
                // foreign key
                this.queryset = this.related.queryset;
                if (this.model[this.field]) {
                    this.related.get(this.model[this.field]).subscribe((res) => {
                        this.thvalue = res;
                    });
                }
                if (this.relatedMode === "select") {
                    this.related.queryset.query(this.relatedFilter).get().subscribe((res) => {
                        this.choices = [];
                        for (const r of res.items) {
                            this.choices.push([r.id, this._display(r)]);
                        }
                    });
                }
                if (this.relatedReset && this.relatedReset.subscribe) {
                    this.relatedReset.pipe(takeUntil(this._subscription)).subscribe(() => {
                        this.thvalue = undefined;
                    });
                }
            }
            if (this.mfield.type === "manytomanyfield") {
                // manytomany
                this.queryset = this.related.queryset;
                if (this.model[this.field + "_details"]) {
                    for (const r of this.model[this.field + "_details"]) {
                        this.mrelated.push({ id: r.id, name: r.name });
                    }
                }
            }
            // date field special
            if (!this.native && this.mfield.type === "datefield") {
                const dt = new Date(this.model[this.field]);
                this.cform = new FormGroup({
                    date: new FormControl(format$1(dt, "dd/MM/y"))
                });
                this.cform.valueChanges.subscribe((value) => {
                    const out = {};
                    out[this.field] = new Date(value.date);
                    this.form.patchValue(out);
                });
            }
            // listeners for related reset
            if (this.relatedReset && this.relatedReset.subscribe) {
                this.relatedReset.pipe(takeUntil(this._subscription)).subscribe(() => {
                    this.thvalue = undefined;
                });
            }
            // placeholder default contents
            if (this.placeholder === undefined && this.mfield.helpText) {
                this.placeholder = this.mfield.helpText;
            }
            if (this.placeholder === undefined && this.mfield.verboseName) {
                this.placeholder = this.mfield.verboseName;
            }
            if (this.placeholder === undefined) {
                this.placeholder = "";
            }
            if (this.form === undefined || this.form.controls === undefined) {
                // no form, it's an error
                console.error("Form group not available for field %s", this.field);
            }
            else {
                if (this.form.controls[this.field] !== undefined) {
                    // existing form control, update it and use it
                    this.form.controls[this.field].clearValidators();
                    this.form.controls[this.field].clearAsyncValidators();
                    this.form.controls[this.field].setValidators(validators);
                    this.form.controls[this.field].setAsyncValidators(asyncvalidators);
                    this.form.controls[this.field].updateValueAndValidity();
                }
                else {
                    // no form control, add it
                    let value = this.model[this.field];
                    if (this.factor) {
                        value = value / this.factor;
                    }
                    this.form.addControl(this.field, new FormControl(value, validators, asyncvalidators));
                }
            }
        });
    }
    typeAheadItem(event) {
        this.form.controls[this.field].setValue(event.item.id);
        this.relatedSelected.emit(event.item);
    }
    m2mGetIds() {
        const out = [];
        for (const m of this.mrelated) {
            out.push(m.id);
        }
        return out;
    }
    m2mRemove(item) {
        let index = 0;
        for (const m of this.mrelated) {
            index += 1;
            if (item.id === m.id) {
                this.mrelated.splice(index, 1);
                break;
            }
        }
        this.form.controls[this.field].setValue(this.m2mGetIds());
    }
    m2mTypeAheadItem(event) {
        this.m2mRemove(event.item);
        this.mrelated.push(event.item);
        this.form.controls[this.field].setValue(this.m2mGetIds());
        this.thvalue = null;
    }
    /**
     * Display function. Uses descfield or desc tpl (lodash template using model fields).
     */
    _display(x) {
        if (x) {
            if (x._disp) {
                return x._disp;
            }
            return this.tpl(x);
        }
        return "";
    }
    _search(text$) {
        return text$.pipe(takeUntil(this._subscription), debounceTime(750), distinctUntilChanged(), switchMap((term) => {
            const f = {};
            for (const k of Object.keys(this.relatedFilter)) {
                if (this.relatedFilter[k] !== null || this.relatedFilter[k] !== undefined) {
                    f[k] = this.relatedFilter[k];
                }
            }
            f[this.relatedSearchparam] = term;
            this.queryset.filter.update(f);
            return this.queryset.get(this.relatedParams).pipe(map((result) => result.items));
        }));
    }
}
BsacFieldControlComponent.ɵfac = function BsacFieldControlComponent_Factory(t) { return new (t || BsacFieldControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbDateParserFormatter)); };
BsacFieldControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacFieldControlComponent, selectors: [["bsac-field-control"]], inputs: { validators: "validators", asyncvalidators: "asyncvalidators", dateFormat: "dateFormat", dateFormatter: "dateFormatter", timeFormatter: "timeFormatter", defaultTime: "defaultTime", descfield: "descfield", relatedFilter: "relatedFilter", relatedLabel: "relatedLabel", relatedSearchparam: "relatedSearchparam", relatedParams: "relatedParams", relatedMode: "relatedMode", form: "form", model: "model", field: "field", placeholder: "placeholder", native: "native", desctpl: "desctpl", related: "related", relatedQueryset: "relatedQueryset", relatedReset: "relatedReset", relatedLink: "relatedLink" }, outputs: { relatedSelected: "relatedSelected" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NgbDateParserFormatter, useClass: FrenchDateFormatter }])], ngContentSelectors: _c3, decls: 16, vars: 11, consts: [["help", ""], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "form-text", "text-muted"], [1, "form-group", 3, "formGroup"], ["type", "text", 1, "form-control", 3, "id", "formControlName", "placeholder"], [4, "ngTemplateOutlet"], ["class", "text-danger form-error", 4, "ngIf"], [1, "text-danger", "form-error"], [4, "ngIf"], [3, "formControlName", "placeholder"], [1, "form-control", 3, "id", "formControlName", "placeholder"], [1, "form-control", 3, "id", "formControlName"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["ngbRadioGroup", "", "name", "yesno", 1, "btn-group", "btn-group-toggle", 3, "formControlName"], ["ngbButtonLabel", "", 1, "btn-primary"], ["ngbButton", "", "type", "radio", 3, "value"], ["dateFormat", "shortDate", 3, "native", "formControlName", "dateFormatter", "timeFormatter", "defaultTime"], [1, "input-group"], ["placeholder", "jj/mm/aaaa", "ngbDatepicker", "", 1, "form-control", 3, "formControlName"], ["d", "ngbDatepicker"], [1, "input-group-addon"], ["type", "button", 1, "btn", "btn-outline-secondary", 3, "click"], [1, "fa", "fa-calendar"], ["dateFormat", "shortDate", 3, "native", "formControlName", "dateFormatter", "timeFormatter", "defaultTime", "dateOnly"], ["class", "form-group", 4, "ngIf"], ["class", "form-group", 3, "formGroup", 4, "ngIf"], [1, "form-group"], [1, "form-control", 3, "ngbTypeahead", "editable", "ngModel", "inputFormatter", "resultFormatter", "placeholder", "ngModelChange", "selectItem"], [4, "ngFor", "ngForOf"], [1, "fa", "fa-plus", "mr-2", 3, "click"], [1, "fa", "fa-trash", "mr-2", "text-danger", 3, "click"]], template: function BsacFieldControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵtemplate(0, BsacFieldControlComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementContainerStart(2, 1);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BsacFieldControlComponent_ng_container_5_Template, 5, 6, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(6, BsacFieldControlComponent_ng_container_6_Template, 5, 5, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(7, BsacFieldControlComponent_ng_container_7_Template, 5, 6, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(8, BsacFieldControlComponent_ng_container_8_Template, 5, 6, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(9, BsacFieldControlComponent_ng_container_9_Template, 6, 6, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(10, BsacFieldControlComponent_ng_container_10_Template, 11, 6, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(11, BsacFieldControlComponent_ng_container_11_Template, 5, 8, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(12, BsacFieldControlComponent_ng_container_12_Template, 5, 4, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(13, BsacFieldControlComponent_ng_container_13_Template, 3, 2, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(14, BsacFieldControlComponent_ng_container_14_Template, 5, 2, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(15, BsacFieldControlComponent_ng_container_15_Template, 4, 5, "ng-container", 3);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.type);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "charfield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "decimalfield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "slugfield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "textfield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "selectfield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "booleanfield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "datetimefield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "datefield");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "foreignkey");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "manytomanyfield");
    } }, directives: function () { return [ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc1.NgSwitchDefault, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, BsacDecimalInputComponent, ɵngcc5.SelectControlValueAccessor, ɵngcc1.NgForOf, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x, ɵngcc4.NgbRadioGroup, ɵngcc4.NgbButtonLabel, ɵngcc4.NgbRadio, BsacDatetimeInputComponent, ɵngcc4.NgbInputDatepicker, ɵngcc4.NgbTypeahead, ɵngcc5.NgModel]; }, styles: ["input.form-control.ng-invalid[_ngcontent-%COMP%], select.form-control.ng-invalid[_ngcontent-%COMP%], textarea.form-control.ng-invalid[_ngcontent-%COMP%]{border-left:3px solid red}"] });
BsacFieldControlComponent.ctorParameters = () => [
    { type: NgbDateParserFormatter }
];
BsacFieldControlComponent.propDecorators = {
    form: [{ type: Input }],
    model: [{ type: Input }],
    field: [{ type: Input }],
    validators: [{ type: Input }],
    asyncvalidators: [{ type: Input }],
    placeholder: [{ type: Input }],
    native: [{ type: Input }],
    dateFormat: [{ type: Input }],
    dateFormatter: [{ type: Input }],
    timeFormatter: [{ type: Input }],
    defaultTime: [{ type: Input }],
    desctpl: [{ type: Input }],
    descfield: [{ type: Input }],
    related: [{ type: Input }],
    relatedQueryset: [{ type: Input }],
    relatedFilter: [{ type: Input }],
    relatedLabel: [{ type: Input }],
    relatedReset: [{ type: Input }],
    relatedSearchparam: [{ type: Input }],
    relatedLink: [{ type: Input }],
    relatedParams: [{ type: Input }],
    relatedMode: [{ type: Input }],
    relatedSelected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFieldControlComponent, [{
        type: Component,
        args: [{
                selector: "bsac-field-control",
                template: "<!DOCTYPE html><ng-template #help><small class=\"form-text text-muted\"><ng-content select=\".help\"></ng-content></small></ng-template><ng-container [ngSwitch]=\"type\"><label><ng-content select=\".label\"></ng-content></label><ng-container *ngSwitchCase=\"'charfield'\"><div class=\"form-group\" [formGroup]=\"form\"><input class=\"form-control\" [id]=\"field\" type=\"text\" [formControlName]=\"field\" [placeholder]=\"placeholder\"><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'decimalfield'\"><div class=\"form-group\" [formGroup]=\"form\"><bsac-decimal-input [formControlName]=\"field\" [placeholder]=\"placeholder\"></bsac-decimal-input><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.min\">Trop petit</div><div *ngIf=\"form.get(field).errors.max\">Trop grand</div></div></div></ng-container><ng-container *ngSwitchCase=\"'slugfield'\"><div class=\"form-group\" [formGroup]=\"form\"><input class=\"form-control\" [id]=\"field\" type=\"text\" [formControlName]=\"field\" [placeholder]=\"placeholder\"><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'textfield'\"><div class=\"form-group\" [formGroup]=\"form\"><textarea class=\"form-control\" [id]=\"field\" [formControlName]=\"field\" [placeholder]=\"placeholder\"></textarea><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'selectfield'\"><div class=\"form-group\" [formGroup]=\"form\"><select class=\"form-control\" [id]=\"field\" [formControlName]=\"field\"><option *ngFor=\"let o of choices\" [value]=\"o[0]\">{{o[1]}}</option></select><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'booleanfield'\"><div class=\"form-group\" [formGroup]=\"form\"><div class=\"btn-group btn-group-toggle\" ngbRadioGroup name=\"yesno\" [formControlName]=\"field\"><label class=\"btn-primary\" ngbButtonLabel><input ngbButton type=\"radio\" [value]=\"true\">Oui</label><label class=\"btn-primary\" ngbButtonLabel><input ngbButton type=\"radio\" [value]=\"false\">Non</label></div><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'datetimefield'\"><div class=\"form-group\" [formGroup]=\"form\"><bsac-datetime-input [native]=\"native\" [formControlName]=\"field\" dateFormat=\"shortDate\" [dateFormatter]=\"dateFormatter\" [timeFormatter]=\"timeFormatter\" [defaultTime]=\"defaultTime\"></bsac-datetime-input><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'datefield'\"><ng-container *ngIf=\"!native\"><div class=\"form-group\" [formGroup]=\"cform\"><div class=\"input-group\"><input class=\"form-control\" placeholder=\"jj/mm/aaaa\" [formControlName]=\"'date'\" ngbDatepicker #d=\"ngbDatepicker\"><div class=\"input-group-addon\"><button class=\"btn btn-outline-secondary\" (click)=\"d.toggle()\" type=\"button\"><i class=\"fa fa-calendar\"></i></button></div></div></div></ng-container><ng-container *ngIf=\"native\"><div class=\"form-group\" [formGroup]=\"form\"><bsac-datetime-input [native]=\"true\" [formControlName]=\"field\" dateFormat=\"shortDate\" [dateFormatter]=\"dateFormatter\" [timeFormatter]=\"timeFormatter\" [defaultTime]=\"defaultTime\" [dateOnly]=\"true\"></bsac-datetime-input></div></ng-container><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></ng-container><ng-container *ngSwitchCase=\"'foreignkey'\"><div class=\"form-group\" *ngIf=\"relatedMode==='autocomplete'\"><input class=\"form-control\" [ngbTypeahead]=\"search\" [editable]=\"false\" [(ngModel)]=\"thvalue\" (selectItem)=\"typeAheadItem($event)\" [inputFormatter]=\"display\" [resultFormatter]=\"display\" [placeholder]=\"placeholder\"><ng-container *ngTemplateOutlet=\"help\"></ng-container></div><div class=\"form-group\" [formGroup]=\"form\" *ngIf=\"relatedMode==='select'\"><select class=\"form-control\" [id]=\"field\" [formControlName]=\"field\"><option *ngFor=\"let o of choices\" [value]=\"o[0]\">{{o[1]}}</option></select><ng-container *ngTemplateOutlet=\"help\"></ng-container><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container><ng-container *ngSwitchCase=\"'manytomanyfield'\"><div *ngFor=\"let m of mrelated\"><i class=\"fa fa-trash mr-2 text-danger\" (click)=\"m2mRemove(m)\"></i>{{m.name}}</div><i class=\"fa fa-plus mr-2\" (click)=\"madd=!madd\"><ng-content select=\".m2madd\"></ng-content></i><div class=\"form-group\" *ngIf=\"madd\"><input class=\"form-control\" [ngbTypeahead]=\"search\" [editable]=\"false\" [(ngModel)]=\"thvalue\" (selectItem)=\"m2mTypeAheadItem($event)\" [inputFormatter]=\"display\" [resultFormatter]=\"display\" [placeholder]=\"placeholder\"></div></ng-container><ng-container *ngSwitchDefault><div class=\"form-group\" [formGroup]=\"form\"><input class=\"form-control\" [id]=\"field\" type=\"text\" [formControlName]=\"field\" [placeholder]=\"placeholder\"><div class=\"text-danger form-error\" *ngIf=\"form.get(field).invalid\"><div *ngIf=\"form.get(field).errors.required\">Ce champ est requis</div><div *ngIf=\"form.get(field).errors.pattern\">Syntaxe invalide</div><div *ngIf=\"form.get(field).errors.minlength\">Trop court</div><div *ngIf=\"form.get(field).errors.maxlength\">Trop long</div><div *ngIf=\"form.get(field).errors.choices\">Vous devez entrer une valeur autoris\u00E9e</div></div></div></ng-container></ng-container>",
                providers: [{ provide: NgbDateParserFormatter, useClass: FrenchDateFormatter }],
                styles: ["input.form-control.ng-invalid,select.form-control.ng-invalid,textarea.form-control.ng-invalid{border-left:3px solid red}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgbDateParserFormatter }]; }, { validators: [{
            type: Input
        }], asyncvalidators: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], dateFormatter: [{
            type: Input
        }], timeFormatter: [{
            type: Input
        }], defaultTime: [{
            type: Input
        }], descfield: [{
            type: Input
        }], relatedFilter: [{
            type: Input
        }], relatedLabel: [{
            type: Input
        }], relatedSearchparam: [{
            type: Input
        }], relatedParams: [{
            type: Input
        }], relatedMode: [{
            type: Input
        }], relatedSelected: [{
            type: Output
        }], form: [{
            type: Input
        }], model: [{
            type: Input
        }], field: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], native: [{
            type: Input
        }], desctpl: [{
            type: Input
        }], related: [{
            type: Input
        }], relatedQueryset: [{
            type: Input
        }], relatedReset: [{
            type: Input
        }], relatedLink: [{
            type: Input
        }] }); })();

class BsacFlagsFieldComponent {
    constructor(_msg) {
        this._msg = _msg;
        this.field = "flags";
        this.get_flags_endpoint = "get_flags";
        this.edit = {};
        this.free = false;
        this.action = false; // if set to true, use add_flag and remove_flag model actions
        this.curflags = [];
        this.txtflag = "";
        this.selflag = "";
        this.flaglist = [];
        this._subscriptions$ = new Subject();
    }
    ngOnDestroy() {
        this._subscriptions$.next();
        this._subscriptions$.complete();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.flags) {
                // FIXME: make public collection link (ngdataservice)
                this.flags = this.model._collection.action(null, this.get_flags_endpoint, { method: "GET" });
            }
            this.flaglist = yield this.flags.toPromise();
            if (this.model && this.field && this.model[this.field]) {
                this.curflags = this.model[this.field];
            }
            else {
                console.warn("Model or field problem in flagsfield component");
                this.curflags = [];
            }
            this.ft = new FormControl("");
            this.fs = new FormControl("");
            this.fs.valueChanges.pipe(takeUntil(this._subscriptions$), debounceTime(250)).subscribe((value) => {
                if (value) {
                    this.addFlag(value);
                }
            });
        });
    }
    addFreeFlag() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addFlag(this.ft.value);
        });
    }
    addFlag(flag) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.flagPresent(flag)) {
                this.curflags.push(flag);
                if (this.action) {
                    try {
                        yield this.model.action("add_flag", { method: "POST", body: { flag } }).toPromise();
                        this._msg.success("Saved");
                    }
                    catch (e) {
                        this._msg.error("Saving flag failed", e);
                    }
                }
                else {
                    this.update();
                }
            }
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.model[this.field] = this.curflags;
            try {
                yield this.model.update([this.field]).toPromise();
                this.fs.setValue("", { emitEvent: false });
                this.ft.setValue("", { emitEvent: false });
                this._msg.success("Saved");
            }
            catch (error) {
                this._msg.error("Saving flags failed", "API Return : " + error.toString(), error._body);
            }
        });
    }
    flagPresent(flag) {
        return this.curflags.findIndex((f) => flag === f) !== -1;
    }
    removeFlag(flag) {
        return __awaiter(this, void 0, void 0, function* () {
            this.curflags.splice(this.curflags.findIndex((f) => flag === f), 1);
            if (this.action) {
                try {
                    yield this.model.action("remove_flag", { method: "POST", body: { flag } }).toPromise();
                    this._msg.success("Removed");
                }
                catch (e) {
                    this._msg.error("Removing flag failed", e);
                }
            }
            else {
                this.update();
            }
        });
    }
}
BsacFlagsFieldComponent.ɵfac = function BsacFlagsFieldComponent_Factory(t) { return new (t || BsacFlagsFieldComponent)(ɵngcc0.ɵɵdirectiveInject(BsacMessageService)); };
BsacFlagsFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacFlagsFieldComponent, selectors: [["bsac-flags-field"]], inputs: { field: "field", get_flags_endpoint: "get_flags_endpoint", edit: "edit", free: "free", action: "action", model: "model", flags: "flags" }, ngContentSelectors: _c4, decls: 4, vars: 2, consts: [[1, "pointer", 3, "click"], ["class", "pointer", 3, "click", 4, "ngIf"], [4, "ngIf"], ["class", "badge badge-info badge-spaced", 4, "ngFor", "ngForOf"], [1, "badge", "badge-info", "badge-spaced"], [1, "row"], [1, "row", "m-2"], [1, "col-sm-12"], ["class", "badge badge-info badge-spaced", 3, "click", 4, "ngFor", "ngForOf"], [1, "col-6"], [1, "form-control", 3, "formControl"], [3, "value", 4, "ngFor", "ngForOf"], ["placeholder", "New flag", 1, "form-control", 3, "formControl", "keyup.enter"], [3, "value"], [1, "col-12"], ["placeholder", "New flag", 1, "form-control", 3, "formControl", "keyup.enter", "keyup.escape"], [1, "badge", "badge-info", "badge-spaced", 3, "click"], [1, "fa", "fa-trash", "fa-s"]], template: function BsacFlagsFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "dt", 0);
        ɵngcc0.ɵɵlistener("click", function BsacFlagsFieldComponent_Template_dt_click_0_listener() { return (ctx.edit[ctx.field] = !ctx.edit[ctx.field]); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, BsacFlagsFieldComponent_dd_2_Template, 2, 1, "dd", 1);
        ɵngcc0.ɵɵtemplate(3, BsacFlagsFieldComponent_dd_3_Template, 7, 3, "dd", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.edit[ctx.field]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.edit[ctx.field]);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x], styles: [""] });
BsacFlagsFieldComponent.ctorParameters = () => [
    { type: BsacMessageService }
];
BsacFlagsFieldComponent.propDecorators = {
    model: [{ type: Input }],
    field: [{ type: Input }],
    get_flags_endpoint: [{ type: Input }],
    edit: [{ type: Input }],
    flags: [{ type: Input }],
    free: [{ type: Input }],
    action: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFlagsFieldComponent, [{
        type: Component,
        args: [{
                selector: "bsac-flags-field",
                template: "<dt class=\"pointer\" (click)=\"edit[field]=!edit[field]\"><ng-content></ng-content></dt><dd class=\"pointer\" *ngIf=\"!edit[field]\" (click)=\"edit[field]=true\"><span class=\"badge badge-info badge-spaced\" *ngFor=\"let flag of curflags\">{{flag}}</span></dd><dd *ngIf=\"edit[field]\"><div class=\"row\"><ng-container *ngIf=\"!free\"><div class=\"col-6\"><select class=\"form-control\" [formControl]=\"fs\"><option *ngFor=\"let flag of flaglist\" [value]=\"flag.flag\">{{flag.flag}} <span *ngIf=\"flag.count\">({{flag.count}})</span></option></select></div><div class=\"col-6\"><input class=\"form-control\" placeholder=\"New flag\" [formControl]=\"ft\" (keyup.enter)=\"addFreeFlag()\"/></div></ng-container><ng-container *ngIf=\"free\"><div class=\"col-12\"><input class=\"form-control\" placeholder=\"New flag\" [formControl]=\"ft\" (keyup.enter)=\"addFreeFlag()\" (keyup.escape)=\"edit[field]=false\"/></div></ng-container></div><div class=\"row m-2\"><div class=\"col-sm-12\"><span class=\"badge badge-info badge-spaced\" *ngFor=\"let flag of curflags\" (click)=\"removeFlag(flag)\"><i class=\"fa fa-trash fa-s\"></i>{{flag}}</span></div></div></dd>",
                styles: [""]
            }]
    }], function () { return [{ type: BsacMessageService }]; }, { field: [{
            type: Input
        }], get_flags_endpoint: [{
            type: Input
        }], edit: [{
            type: Input
        }], free: [{
            type: Input
        }], action: [{
            type: Input
        }], model: [{
            type: Input
        }], flags: [{
            type: Input
        }] }); })();

/**
 * **M2M Field management.**
 *
 * 2 modes are possible :
 * - **compact** : displayed as enabled/disabled labels, all m2m possible
 *   related data must be given through `values`
 * - **select** : displayed as typeahead select value, `related` service
 *   must be given
 *
 * Related fields are displayed though `descfield` (field name) or `desctpl` (lodash `template`)
 * (default : descfield=name)
 *
 * Model field is saved if `save` is true. Outputs can be used to
 * process changes from outside :
 *
 * - `m2mAdded` {id, m2mModel} each time a related item is added (before saving)
 * - `m2mRemoved` {id, m2mModel} each time a related item is removed (before saving)
 * - `m2mChanged` {ids[], data: {id,m2mModel}[]} each time a related item is added/removed (after saving)
 */
class BsacM2mFieldComponent {
    constructor(_msg) {
        this._msg = _msg;
        /**
         * Is readonly ?
         */
        this.readonly = false;
        /**
         * Global edit mode. default : `{}`
         */
        this.edit = {};
        /**
         * Use custom content descriptions :
         * - .desc for field description in compact mode
         */
        this.custom = false;
        /**
         * Display field for related fields.
         */
        this.descfield = "name";
        /**
         * Select field placeholder (for select mode)
         */
        this.placeholder = "";
        /**
         * Save method : 'patch', 'action', 'none' :
         * - **patch** sends m2m field through model's PATCH method
         * - **action** sends m2m related item addition/removal through
         *   specific POST action on model (**not implemented**)
         * - **none** don't save changes.
         */
        this.saveMethod = "patch";
        /**
         * Related queryset filtering (optional).
         */
        this.relatedFilter = {};
        /** Related queryset get params (context...) */
        this.relatedParams = {};
        /**
         * Outputs {id, m2mModel} each time a related item is added (before saving)
         */
        this.m2mAdded = new EventEmitter();
        /**
         * Outputs {id, m2mModel} each time a related item is removed (before saving)
         */
        this.m2mRemoved = new EventEmitter();
        /**
         * Outputs {id[], m2mModel[]} each time a related item is changed (after saving)
         */
        this.m2mChanged = new EventEmitter();
        // Display typeahead selector
        this.madd = false;
        // Enabled m2m items
        this.enabled = [];
        // Disabled m2m items
        this.disabled = [];
        this.typeAheadSearch = this._typeAheadSearch.bind(this);
    }
    ngOnInit() {
        // Mode selection
        if (!this.mode) {
            if (this.values) {
                this.mode = "compact";
            }
            else if (this.related) {
                this.mode = "select";
            }
            else {
                throw Error("values or related MUST be defined");
            }
        }
        // Display template compilation.
        if (this.desctpl) {
            this.tpl = template(this.desctpl);
        }
        else {
            this.tpl = template("<%= " + this.descfield + " %>");
        }
        // Init related values
        if (this.mode === "select") {
            this.getRelated();
        }
        else {
            this.getEnabled();
        }
    }
    /**
     * Remove m2m item from currently enabled items.
     *
     * @param item Item to be removed.
     * @returns true if item have been removed.
     */
    m2mRemove(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let index = 0;
            let found = false;
            for (const m of this.enabled) {
                if (item.id === m.id) {
                    this.enabled.splice(index, 1);
                    found = true;
                    break;
                }
                index += 1;
            }
            if (found) {
                this.disabled.push({ id: item.id, m2mModel: item });
                this.m2mRemoved.emit({ id: item.id, m2mModel: item });
                this.model[this.field] = this.m2mGetResult().ids;
                yield this.save();
                this.m2mChanged.emit(this.m2mGetResult());
            }
            return found;
        });
    }
    /**
     * Add m2m item to currently enabled items.
     *
     * @param item Item to be added.
     * @param event Typeahead event (optional) - used to prevent default action
     * @param input Typeahead input reference (optional) - used to reset input after selection
     * @returns true if item have been added.
     */
    m2mAdd(item, event = null, input = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let found = false;
            for (const m of this.enabled) {
                if (item.id === m.id) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.enabled.push({ id: item.id, m2mModel: item });
                let index = 0;
                for (const m of this.disabled) {
                    if (item.id === m.id) {
                        this.disabled.splice(index, 1);
                        break;
                    }
                    index += 1;
                }
                this.model[this.field] = this.m2mGetResult().ids;
                this.m2mAdded.emit({ id: item.id, m2mModel: item });
                yield this.save();
                if (event && input) {
                    event.preventDefault();
                    input.value = "";
                }
                this.thvalue = undefined;
                this.madd = false;
                this.m2mChanged.emit(this.m2mGetResult());
            }
            return !found;
        });
    }
    /**
     * Save changed values.
     */
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.saveMethod === "patch") {
                yield this.model.update([this.field]).toPromise();
                this._msg.success("Saved !");
            }
        });
    }
    /**
     * Returns full m2m result.
     */
    m2mGetResult() {
        const out = { ids: [], data: [] };
        for (const m of this.enabled) {
            out.ids.push(m.id);
            out.data.push({ id: m.id, m2mModel: m.m2mModel });
        }
        return out;
    }
    /**
     * Populate enabled field using model fields and model xxxx_details value.
     * If xxxx_details is not provided, raises an error.
     */
    getRelated() {
        this._qs = this.related.queryset;
        this.enabled = [];
        if (this.model[this.field + "_details"]) {
            for (const r of this.model[this.field + "_details"]) {
                this.enabled.push({ id: r.id, m2mModel: r });
            }
        }
        else {
            throw Error("m2m detail field not provided");
        }
    }
    /**
     * Populate enabled/disabled fields using model field & provided m2m values.
     */
    getEnabled() {
        this.enabled = [];
        this.disabled = [];
        if (this.values) {
            for (const v of this.values) {
                let found = false;
                for (const f of this.model[this.field]) {
                    if (v.id === f) {
                        found = true;
                    }
                }
                if (found) {
                    this.enabled.push({ id: v.id, m2mModel: v });
                }
                else {
                    this.disabled.push({ id: v.id, m2mModel: v });
                }
            }
        }
    }
    _typeAheadSearch(text$) {
        return text$.pipe(debounceTime(200), switchMap((term) => {
            const filter = this.relatedFilter;
            filter.search = term;
            this._qs.query(filter);
            return this._qs.get(this.relatedParams).pipe(map((result) => result.items));
        }));
    }
}
BsacM2mFieldComponent.ɵfac = function BsacM2mFieldComponent_Factory(t) { return new (t || BsacM2mFieldComponent)(ɵngcc0.ɵɵdirectiveInject(BsacMessageService)); };
BsacM2mFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacM2mFieldComponent, selectors: [["bsac-m2m-field"]], inputs: { readonly: "readonly", edit: "edit", custom: "custom", descfield: "descfield", placeholder: "placeholder", saveMethod: "saveMethod", relatedFilter: "relatedFilter", relatedParams: "relatedParams", mode: "mode", model: "model", field: "field", values: "values", desctpl: "desctpl", m2mLink: "m2mLink", related: "related" }, outputs: { m2mAdded: "m2mAdded", m2mRemoved: "m2mRemoved", m2mChanged: "m2mChanged" }, ngContentSelectors: _c6, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "pointer", 3, "click"], ["class", "fa fa-pencil ml-2", 4, "ngIf"], ["class", "pointer", 3, "click", 4, "ngIf"], [1, "fa", "fa-pencil", "ml-2"], ["class", "badge badge-primary mr-1", 4, "ngFor", "ngForOf"], ["class", "badge badge-secondary mr-1", 4, "ngFor", "ngForOf"], [1, "badge", "badge-primary", "mr-1"], [1, "badge", "badge-secondary", "mr-1"], ["class", "badge badge-danger mr-1 pointer", 3, "click", 4, "ngFor", "ngForOf"], ["class", "badge badge-primary mr-1 pointer", 3, "click", 4, "ngFor", "ngForOf"], [1, "badge", "badge-danger", "mr-1", "pointer", 3, "click"], [1, "fa", "fa-trash", "fa-s"], [1, "badge", "badge-primary", "mr-1", "pointer", 3, "click"], [1, "fa", "fa-plus", "fa-s"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "routerLink"], [1, "fa", "fa-link", "ml-3"], [1, "fa", "fa-plus", "mr-2"], ["class", "form-group", 4, "ngIf"], [1, "fa", "fa-trash", "mr-2", "text-danger", 3, "click"], [1, "form-group"], [1, "form-control", 3, "ngbTypeahead", "editable", "ngModel", "inputFormatter", "resultFormatter", "placeholder", "ngModelChange", "selectItem"], ["input", ""]], template: function BsacM2mFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c5);
        ɵngcc0.ɵɵtemplate(0, BsacM2mFieldComponent_ng_container_0_Template, 7, 5, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, BsacM2mFieldComponent_ng_container_1_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "compact");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "select");
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.RouterLinkWithHref, ɵngcc4.NgbTypeahead, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel], styles: [""] });
BsacM2mFieldComponent.ctorParameters = () => [
    { type: BsacMessageService }
];
BsacM2mFieldComponent.propDecorators = {
    mode: [{ type: Input }],
    readonly: [{ type: Input }],
    model: [{ type: Input }],
    field: [{ type: Input }],
    values: [{ type: Input }],
    edit: [{ type: Input }],
    custom: [{ type: Input }],
    desctpl: [{ type: Input }],
    descfield: [{ type: Input }],
    m2mLink: [{ type: Input }],
    related: [{ type: Input }],
    placeholder: [{ type: Input }],
    saveMethod: [{ type: Input }],
    relatedFilter: [{ type: Input }],
    relatedParams: [{ type: Input }],
    m2mAdded: [{ type: Output }],
    m2mRemoved: [{ type: Output }],
    m2mChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacM2mFieldComponent, [{
        type: Component,
        args: [{
                selector: "bsac-m2m-field",
                template: "<!DOCTYPE html><ng-container *ngIf=\"mode=='compact'\"><dt class=\"pointer\" (click)=\"edit[field]=!edit[field]\"><ng-content *ngIf=\"custom\" select=\".desc\"></ng-content><ng-content *ngIf=\"!custom\"></ng-content><i class=\"fa fa-pencil ml-2\" *ngIf=\"edit[field]\"></i></dt><dd class=\"pointer\" *ngIf=\"readonly || !edit[field]\" (click)=\"edit[field]=!edit[field]\"><span class=\"badge badge-primary mr-1\" *ngFor=\"let e of enabled\">{{tpl(e.m2mModel)}}</span><span class=\"badge badge-secondary mr-1\" *ngFor=\"let e of disabled\">{{tpl(e.m2mModel)}}</span></dd><dd *ngIf=\"!readonly &amp;&amp; edit[field]\"><span class=\"badge badge-danger mr-1 pointer\" *ngFor=\"let e of enabled\" (click)=\"m2mRemove(e.m2mModel)\"><i class=\"fa fa-trash fa-s\"></i>{{tpl(e)}}</span><span class=\"badge badge-primary mr-1 pointer\" *ngFor=\"let e of disabled\" (click)=\"m2mAdd(e.m2mModel)\"><i class=\"fa fa-plus fa-s\"></i>{{tpl(e)}}</span></dd></ng-container><ng-container *ngIf=\"mode=='select'\"><div *ngIf=\"readonly || !edit[field]\"><div class=\"pointer\" *ngIf=\"enabled.length==0\" (click)=\"edit[field]=!edit[field]\"><ng-content select=\".m2mempty\"></ng-content></div><div *ngFor=\"let m of enabled\"><span class=\"pointer\" (click)=\"edit[field]=!readonly &amp;&amp;  !edit[field]\">{{tpl(m.m2mModel)}}</span><ng-container *ngIf=\"m2mLink\"><a [routerLink]=\"m2mLink(m.m2mModel)\" target=\"_blank\"><i class=\"fa fa-link ml-3\"></i></a></ng-container></div></div><div *ngIf=\"!readonly &amp;&amp; edit[field]\"><div *ngFor=\"let m of enabled\"><i class=\"fa fa-trash mr-2 text-danger\" (click)=\"m2mRemove(m.m2mModel)\"></i>{{tpl(m.m2mModel)}}</div><div class=\"pointer\" (click)=\"madd=!madd\"><i class=\"fa fa-plus mr-2\"></i><ng-content select=\".m2madd\"></ng-content></div><div class=\"form-group\" *ngIf=\"madd\"><input class=\"form-control\" [ngbTypeahead]=\"typeAheadSearch\" [editable]=\"false\" [(ngModel)]=\"thvalue\" (selectItem)=\"m2mAdd($event.item, $event, input)\" [inputFormatter]=\"tpl\" [resultFormatter]=\"tpl\" [placeholder]=\"placeholder\" #input></div></div></ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: BsacMessageService }]; }, { readonly: [{
            type: Input
        }], edit: [{
            type: Input
        }], custom: [{
            type: Input
        }], descfield: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], saveMethod: [{
            type: Input
        }], relatedFilter: [{
            type: Input
        }], relatedParams: [{
            type: Input
        }], m2mAdded: [{
            type: Output
        }], m2mRemoved: [{
            type: Output
        }], m2mChanged: [{
            type: Output
        }], mode: [{
            type: Input
        }], model: [{
            type: Input
        }], field: [{
            type: Input
        }], values: [{
            type: Input
        }], desctpl: [{
            type: Input
        }], m2mLink: [{
            type: Input
        }], related: [{
            type: Input
        }] }); })();

class BsacSelectRelatedComponent {
    constructor() {
        this.context = {};
        this.filter = {};
        this.descfield = "name";
        this.label = "Select item";
        this.searchparam = "search";
        this.placeholder = "";
        this.selected = new EventEmitter();
        this.clear = new EventEmitter();
        this.search = this._search.bind(this);
        this.display = this._display.bind(this);
        this._subscription = new Subject();
    }
    ngOnInit() {
        if (!this.queryset) {
            this.queryset = this.source.queryset;
        }
        if (this.desctpl) {
            this._tpl = template(this.desctpl);
        }
        else {
            this._tpl = template("<%= " + this.descfield + " %>");
        }
        this.fc = new FormControl("");
        this.fc.valueChanges.pipe(takeUntil(this._subscription), distinctUntilChanged())
            .subscribe((value) => {
            if (value) {
                this.selected.emit(value);
            }
        });
    }
    ngOnDestroy() {
        this._subscription.next();
        this._subscription.complete();
    }
    clearAction() {
        this.clear.emit();
    }
    /**
     * Display function. Uses descfield or desc tpl (lodash template using model fields).
     */
    _display(x) {
        if (x) {
            if (x._disp) {
                return x._disp;
            }
            return this._tpl(x);
        }
        return "";
    }
    _search(text$) {
        return text$.pipe(takeUntil(this._subscription), debounceTime(750), distinctUntilChanged(), switchMap((term) => {
            const f = {};
            for (const k of Object.keys(this.filter)) {
                if (this.filter[k] !== null || this.filter[k] !== undefined) {
                    f[k] = this.filter[k];
                }
            }
            f[this.searchparam] = term;
            this.queryset.filter.update(f);
            return this.queryset.get(this.context).pipe(map((result) => result.items));
        }));
    }
}
BsacSelectRelatedComponent.ɵfac = function BsacSelectRelatedComponent_Factory(t) { return new (t || BsacSelectRelatedComponent)(); };
BsacSelectRelatedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacSelectRelatedComponent, selectors: [["bsac-select-related"]], inputs: { context: "context", filter: "filter", descfield: "descfield", label: "label", searchparam: "searchparam", placeholder: "placeholder", queryset: "queryset", source: "source", desctpl: "desctpl", reset: "reset" }, outputs: { selected: "selected", clear: "clear" }, decls: 5, vars: 8, consts: [[1, "form-group"], [1, "fa", "fa-trash", "float-right", "pointer", 3, "click"], [1, "form-control", 3, "formControl", "placeholder", "ngbTypeahead", "editable", "focusFirst", "inputFormatter", "resultFormatter"]], template: function BsacSelectRelatedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "i", 1);
        ɵngcc0.ɵɵlistener("click", function BsacSelectRelatedComponent_Template_i_click_1_listener() { return ctx.clearAction(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "input", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc)("placeholder", ctx.placeholder)("ngbTypeahead", ctx.search)("editable", false)("focusFirst", true)("inputFormatter", ctx.display)("resultFormatter", ctx.display);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc4.NgbTypeahead, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective], styles: [""] });
BsacSelectRelatedComponent.ctorParameters = () => [];
BsacSelectRelatedComponent.propDecorators = {
    source: [{ type: Input }],
    queryset: [{ type: Input }],
    context: [{ type: Input }],
    filter: [{ type: Input }],
    desctpl: [{ type: Input }],
    descfield: [{ type: Input }],
    label: [{ type: Input }],
    reset: [{ type: Input }],
    searchparam: [{ type: Input }],
    placeholder: [{ type: Input }],
    selected: [{ type: Output }],
    clear: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacSelectRelatedComponent, [{
        type: Component,
        args: [{
                selector: "bsac-select-related",
                template: "<div class=\"form-group\"><i class=\"fa fa-trash float-right pointer\" (click)=\"clearAction()\"></i><label>{{label}}</label><input class=\"form-control\" [formControl]=\"fc\" [placeholder]=\"placeholder\" [ngbTypeahead]=\"search\" [editable]=\"false\" [focusFirst]=\"true\" [inputFormatter]=\"display\" [resultFormatter]=\"display\"/></div>",
                styles: [""]
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }], filter: [{
            type: Input
        }], descfield: [{
            type: Input
        }], label: [{
            type: Input
        }], searchparam: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], selected: [{
            type: Output
        }], clear: [{
            type: Output
        }], queryset: [{
            type: Input
        }], source: [{
            type: Input
        }], desctpl: [{
            type: Input
        }], reset: [{
            type: Input
        }] }); })();

const noop = (_) => {
};
const ɵ0 = noop;
/**
 * Provides a numeric form input taking into account fake decimals
 * (decimals stored as integer with a multiplicative factor).
 *
 * Exemple : 12.44 stored as 12440 with x1000 factor.
 *
 * `factor` parameter is used to store this factor
 *
 * Styling is made from host element (valid/invalid)
 */
class BsacDecimalInputComponent {
    constructor() {
        /**
         * Numeric factor for storage / display transform.
         */
        this.factor = 1;
        /**
         * Field placeholder text.
         */
        this.placeholder = "";
        /**
         * Back value propagation on changes.
         */
        this.propagateChange = noop;
        /**
         * Back value propagation on touched.
         */
        this.propagateTouched = noop;
        this._subscriptions$ = new Subject();
    }
    /**
     * Create inner form & subscribe it's changes for propagation.
     */
    ngOnInit() {
        this.form = new FormGroup({
            dec: new FormControl("")
        });
        this.form.valueChanges
            .pipe(takeUntil(this._subscriptions$))
            .subscribe((vals) => {
            this.propagateChange(vals.dec * this.factor);
        });
    }
    /**
     * Destroy form subscription.
     */
    ngOnDestroy() {
        this._subscriptions$.next();
        this._subscriptions$.complete();
    }
    /**
     * Write value from form.
     *
     * @param obj value
     */
    writeValue(obj) {
        this.form.setValue({ dec: obj / this.factor });
    }
    /**
     * ControlValueAccessor register function.
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * ControlValueAccessor register function.
     */
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
}
BsacDecimalInputComponent.ɵfac = function BsacDecimalInputComponent_Factory(t) { return new (t || BsacDecimalInputComponent)(); };
BsacDecimalInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacDecimalInputComponent, selectors: [["bsac-decimal-input"]], inputs: { factor: "factor", placeholder: "placeholder" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => BsacDecimalInputComponent),
                multi: true
            }
        ])], decls: 2, vars: 2, consts: [[3, "formGroup"], ["formControlName", "dec", "type", "number", 1, "form-control", 3, "placeholder"]], template: function BsacDecimalInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0);
        ɵngcc0.ɵɵelement(1, "input", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder);
    } }, directives: [ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NumberValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName], styles: [".ng-valid[_nghost-%COMP%]   input[_ngcontent-%COMP%], .ng-valid   [_nghost-%COMP%]   input[_ngcontent-%COMP%]{border-left:3px solid green}.ng-invalid[_nghost-%COMP%]   input[_ngcontent-%COMP%], .ng-invalid   [_nghost-%COMP%]   input[_ngcontent-%COMP%]{border-left:3px solid red}"] });
BsacDecimalInputComponent.ctorParameters = () => [];
BsacDecimalInputComponent.propDecorators = {
    factor: [{ type: Input }],
    placeholder: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacDecimalInputComponent, [{
        type: Component,
        args: [{
                selector: "bsac-decimal-input",
                template: "<form [formGroup]=\"form\"><input class=\"form-control\" formControlName=\"dec\" [placeholder]=\"placeholder\" type=\"number\"/></form>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => BsacDecimalInputComponent),
                        multi: true
                    }
                ],
                styles: [":host-context(.ng-valid) input{border-left:3px solid green}:host-context(.ng-invalid) input{border-left:3px solid red}"]
            }]
    }], function () { return []; }, { factor: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();

const BSAC_I18N_LANGUAGES = new InjectionToken("bsac.i18n.languages", {
    factory: () => ["fr", "en"]
});
const BSAC_I18N_DEFAULT_LANGUAGE = new InjectionToken("bsac.i18n.defaultlanguage", {
    factory: () => "fr"
});
const BSAC_I18N_TRANSLATION_STATUSES = new InjectionToken("bsac.i18n.translationstatuses", {
    factory: () => ({ OK: "Traduction valide" })
});
const BSAC_I18N_VALID_TRANSLATION_STATUSES = new InjectionToken("bsac.i18n.validtranslationstatuses", {
    factory: () => ["OK"]
});
const BSAC_I18N_INVALID_TRANSLATION_STATUSES = new InjectionToken("bsac.i18n.invalidtranslationstatuses", {
    factory: () => ["KO"]
});
const BSAC_I18N_WARNING_TRANSLATION_STATUSES = new InjectionToken("bsac.i18n.warningtranslationstatuses", {
    factory: () => ["MA"]
});
// noinspection JSUnusedLocalSymbols
class BsacI18nService {
    constructor() {
    }
    getTranslation(model, field, lang) {
        return of(null);
    }
    getTranslations(model, field) {
        return of({});
    }
    setTranslation(model, field, lang, translation) {
        return of(null);
    }
}
BsacI18nService.ɵfac = function BsacI18nService_Factory(t) { return new (t || BsacI18nService)(); };
BsacI18nService.ɵprov = ɵɵdefineInjectable({ factory: function BsacI18nService_Factory() { return new BsacI18nService(); }, token: BsacI18nService, providedIn: "root" });
BsacI18nService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacI18nService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();

class BsacI18nEditorComponent {
    constructor(translationStatuses, validStatuses, invalidStatuses, warningStatuses, _i18n, activeModal) {
        this.translationStatuses = translationStatuses;
        this.validStatuses = validStatuses;
        this.invalidStatuses = invalidStatuses;
        this.warningStatuses = warningStatuses;
        this._i18n = _i18n;
        this.activeModal = activeModal;
    }
    load(changes) {
        this._i18n.getTranslation(this.model, this.field, this.lang)
            .pipe(first())
            .subscribe((trs) => {
            this.translation = trs;
            this.trForm = new FormGroup({
                orig: new FormControl(this.model[this.field]),
                translation: new FormControl(this.translation.text),
                message: new FormControl(this.translation.message)
            });
        });
    }
    save(status) {
        console.log("Save");
        this.translation.message = this.trForm.value.message;
        this.translation.status = status;
        this.translation.text = this.trForm.value.translation;
        this._i18n.setTranslation(this.model, this.field, this.lang, this.translation)
            .subscribe((res) => {
            this.activeModal.close();
        });
    }
}
BsacI18nEditorComponent.ɵfac = function BsacI18nEditorComponent_Factory(t) { return new (t || BsacI18nEditorComponent)(ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_VALID_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_INVALID_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_WARNING_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BsacI18nService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbActiveModal)); };
BsacI18nEditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacI18nEditorComponent, selectors: [["bsac-i18n-editor"]], inputs: { model: "model", field: "field", type: "type", lang: "lang" }, decls: 9, vars: 2, consts: [[1, "modal-header"], [1, "modal-title"], [1, "ml-2", 3, "ngClass"], ["type", "button", 1, "close", 3, "click"], [1, "modal-body"], [3, "formGroup", 4, "ngIf"], [3, "formGroup"], [1, "form-group"], ["class", "form-control", "type", "text", "formControlName", "orig", 3, "readonly", 4, "ngIf"], ["class", "form-control", "formControlName", "orig", 3, "readonly", 4, "ngIf"], ["class", "form-control", "type", "text", "formControlName", "translation", 4, "ngIf"], ["class", "form-control", "formControlName", "translation", 4, "ngIf"], ["formControlName", "message", 1, "form-control", "form-control-sm"], [1, "row"], ["class", "col", 4, "ngFor", "ngForOf"], ["type", "text", "formControlName", "orig", 1, "form-control", 3, "readonly"], ["formControlName", "orig", 1, "form-control", 3, "readonly"], ["type", "text", "formControlName", "translation", 1, "form-control"], ["formControlName", "translation", 1, "form-control"], [1, "col"], [1, "btn", "btn-block", 3, "click"]], template: function BsacI18nEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h4", 1);
        ɵngcc0.ɵɵtext(2, "Traduction");
        ɵngcc0.ɵɵelement(3, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "button", 3);
        ɵngcc0.ɵɵlistener("click", function BsacI18nEditorComponent_Template_button_click_4_listener() { return ctx.activeModal.dismiss("x"); });
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtext(6, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵtemplate(8, BsacI18nEditorComponent_form_8_Template, 18, 7, "form", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", "flag-icon flag-icon-squared flag-icon-" + ctx.lang);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.trForm);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, ɵngcc1.NgForOf], styles: [""] });
BsacI18nEditorComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BSAC_I18N_TRANSLATION_STATUSES,] }] },
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_VALID_TRANSLATION_STATUSES,] }] },
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_INVALID_TRANSLATION_STATUSES,] }] },
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_WARNING_TRANSLATION_STATUSES,] }] },
    { type: BsacI18nService },
    { type: NgbActiveModal }
];
BsacI18nEditorComponent.propDecorators = {
    model: [{ type: Input }],
    field: [{ type: Input }],
    type: [{ type: Input }],
    lang: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacI18nEditorComponent, [{
        type: Component,
        args: [{
                selector: "bsac-i18n-editor",
                template: "<div class=\"modal-header\"><h4 class=\"modal-title\">Traduction<i class=\"ml-2\" [ngClass]=\"'flag-icon flag-icon-squared flag-icon-'+lang\"></i></h4><button class=\"close\" type=\"button\" (click)=\"activeModal.dismiss('x')\"><span>&times;</span></button></div><div class=\"modal-body\"><form [formGroup]=\"trForm\" *ngIf=\"trForm\"><div class=\"form-group\"><label>Texte original</label><input class=\"form-control\" type=\"text\" formControlName=\"orig\" [readonly]=\"true\" *ngIf=\"type!='textarea'\"/><textarea class=\"form-control\" formControlName=\"orig\" [readonly]=\"true\" *ngIf=\"type=='textarea'\"></textarea></div><div class=\"form-group\"><label>Traduction<i class=\"ml-2\" [ngClass]=\"'flag-icon flag-icon-squared flag-icon-'+lang\"></i></label><input class=\"form-control\" type=\"text\" formControlName=\"translation\" *ngIf=\"type!='textarea'\"/><textarea class=\"form-control\" formControlName=\"translation\" *ngIf=\"type=='textarea'\"></textarea></div><div class=\"form-group\"><label>Commentaires</label><textarea class=\"form-control form-control-sm\" formControlName=\"message\"></textarea></div><div class=\"row\"><div class=\"col\" *ngFor=\"let s of translationStatuses\"><button class=\"btn btn-block\" [class.btn-success]=\"translation.status == s &amp;&amp; validStatuses.indexOf(s) !== -1\" [class.btn-warning]=\"translation.status == s &amp;&amp; warningStatuses.indexOf(s) !== -1\" [class.btn-danger]=\"translation.status == s &amp;&amp; invalidStatuses.indexOf(s) !== -1\" [class.btn-outline-success]=\"translation.status != s &amp;&amp; validStatuses.indexOf(s) !== -1\" [class.btn-outline-warning]=\"translation.status != s &amp;&amp; warningStatuses.indexOf(s) !== -1\" [class.btn-outline-danger]=\"translation.status != s &amp;&amp; invalidStatuses.indexOf(s) !== -1\" (click)=\"save(s)\">{{s}}</button></div></div></form></div>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BSAC_I18N_TRANSLATION_STATUSES]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_VALID_TRANSLATION_STATUSES]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_INVALID_TRANSLATION_STATUSES]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_WARNING_TRANSLATION_STATUSES]
            }] }, { type: BsacI18nService }, { type: ɵngcc4.NgbActiveModal }]; }, { model: [{
            type: Input
        }], field: [{
            type: Input
        }], type: [{
            type: Input
        }], lang: [{
            type: Input
        }] }); })();

class BsacI18nComponent {
    constructor(languages, defaultlanguage, translationStatuses, validStatuses, invalidStatuses, warningStatuses, _i18n, modalService) {
        this.languages = languages;
        this.defaultlanguage = defaultlanguage;
        this.translationStatuses = translationStatuses;
        this.validStatuses = validStatuses;
        this.invalidStatuses = invalidStatuses;
        this.warningStatuses = warningStatuses;
        this._i18n = _i18n;
        this.modalService = modalService;
        this.translations = {};
        this._subscriptions = new Subject();
    }
    ngOnInit() {
        if (this.ref && this.ref.model && this.ref.field) {
            this._i18n.getTranslations(this.ref.model, this.ref.field)
                .pipe(takeUntil(this._subscriptions))
                .subscribe((trs) => {
                this.translations = trs;
            });
        }
    }
    ngOnDestroy() {
        this._subscriptions.next();
        this._subscriptions.complete();
    }
    open(content, lang) {
        const modalInstance = this.modalService.open(BsacI18nEditorComponent);
        const ci = modalInstance.componentInstance;
        ci.model = this.ref.model;
        ci.field = this.ref.field;
        ci.type = this.type;
        ci.lang = lang;
        ci.load();
        modalInstance.result.then((result) => {
        }, (reason) => {
        });
    }
    getStatusClass(status) {
        if (this.validStatuses.indexOf(status) !== -1) {
            return "valid";
        }
        if (this.warningStatuses.indexOf(status) !== -1) {
            return "warning";
        }
        if (this.invalidStatuses.indexOf(status) !== -1) {
            return "invalid";
        }
        return "invalid";
    }
}
BsacI18nComponent.ɵfac = function BsacI18nComponent_Factory(t) { return new (t || BsacI18nComponent)(ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_LANGUAGES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_DEFAULT_LANGUAGE), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_VALID_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_INVALID_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BSAC_I18N_WARNING_TRANSLATION_STATUSES), ɵngcc0.ɵɵdirectiveInject(BsacI18nService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal)); };
BsacI18nComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacI18nComponent, selectors: [["bsac-i18n"]], inputs: { ref: "ref", type: "type", lang: "lang" }, decls: 4, vars: 1, consts: [["content", ""], [1, "flags"], ["class", "flag", "placement", "top", 3, "ngClass", "ngbTooltip", "click", 4, "ngFor", "ngForOf"], ["placement", "top", 1, "flag", 3, "ngClass", "ngbTooltip", "click"], [3, "ngClass"]], template: function BsacI18nComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacI18nComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, BsacI18nComponent_div_3_Template, 2, 3, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.languages);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass, ɵngcc4.NgbTooltip], styles: [".flags[_ngcontent-%COMP%]{float:right}.flag[_ngcontent-%COMP%]{display:inline-block;margin-right:3px}.flag.warning[_ngcontent-%COMP%]{border-bottom:3px solid orange}.flag.valid[_ngcontent-%COMP%]{border-bottom:3px solid green}.flag.invalid[_ngcontent-%COMP%]{border-bottom:3px solid red}"] });
BsacI18nComponent.ctorParameters = () => [
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_LANGUAGES,] }] },
    { type: String, decorators: [{ type: Inject, args: [BSAC_I18N_DEFAULT_LANGUAGE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [BSAC_I18N_TRANSLATION_STATUSES,] }] },
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_VALID_TRANSLATION_STATUSES,] }] },
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_INVALID_TRANSLATION_STATUSES,] }] },
    { type: Array, decorators: [{ type: Inject, args: [BSAC_I18N_WARNING_TRANSLATION_STATUSES,] }] },
    { type: BsacI18nService },
    { type: NgbModal }
];
BsacI18nComponent.propDecorators = {
    ref: [{ type: Input }],
    type: [{ type: Input }],
    lang: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacI18nComponent, [{
        type: Component,
        args: [{
                selector: "bsac-i18n",
                template: "<!DOCTYPE html><ng-template #content let-modal></ng-template><div class=\"flags\"><div class=\"flag\" *ngFor=\"let l of languages\" (click)=\"open(content, l)\" [ngClass]=\"getStatusClass(translations[l]?.status)\" [ngbTooltip]=\"translations[l]?.text\" placement=\"top\"><i [ngClass]=\"'flag-icon flag-icon-squared flag-icon-'+l\"></i></div></div>",
                styles: [".flags{float:right}.flag{display:inline-block;margin-right:3px}.flag.warning{border-bottom:3px solid orange}.flag.valid{border-bottom:3px solid green}.flag.invalid{border-bottom:3px solid red}"]
            }]
    }], function () { return [{ type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_LANGUAGES]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [BSAC_I18N_DEFAULT_LANGUAGE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [BSAC_I18N_TRANSLATION_STATUSES]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_VALID_TRANSLATION_STATUSES]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_INVALID_TRANSLATION_STATUSES]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [BSAC_I18N_WARNING_TRANSLATION_STATUSES]
            }] }, { type: BsacI18nService }, { type: ɵngcc4.NgbModal }]; }, { ref: [{
            type: Input
        }], type: [{
            type: Input
        }], lang: [{
            type: Input
        }] }); })();

class BsacI18nModule {
}
BsacI18nModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacI18nModule });
BsacI18nModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacI18nModule_Factory(t) { return new (t || BsacI18nModule)(); }, imports: [[
            ReactiveFormsModule,
            NgbModalModule,
            NgbTooltipModule,
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacI18nModule, { declarations: function () { return [BsacI18nComponent, BsacI18nEditorComponent]; }, imports: function () { return [ReactiveFormsModule,
        NgbModalModule,
        NgbTooltipModule,
        CommonModule]; }, exports: function () { return [BsacI18nComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacI18nModule, [{
        type: NgModule,
        args: [{
                declarations: [BsacI18nComponent, BsacI18nEditorComponent],
                entryComponents: [BsacI18nEditorComponent],
                exports: [BsacI18nComponent],
                imports: [
                    ReactiveFormsModule,
                    NgbModalModule,
                    NgbTooltipModule,
                    CommonModule
                ]
            }]
    }], null, null); })();

class BsacFormsModule {
}
BsacFormsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacFormsModule });
BsacFormsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacFormsModule_Factory(t) { return new (t || BsacFormsModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            RouterModule,
            NgbModule,
            ReactiveFormsModule,
            BsacMessageModule,
            BsacUtilsModule,
            BsacI18nModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacFormsModule, { declarations: function () { return [BsacDdFieldComponent, BsacFlagsFieldComponent, BsacM2mFieldComponent, BsacDatetimeInputComponent, BsacFieldControlComponent, BsacSelectRelatedComponent, BsacDecimalInputComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        RouterModule,
        NgbModule,
        ReactiveFormsModule, BsacMessageModule, BsacUtilsModule, BsacI18nModule]; }, exports: function () { return [BsacDdFieldComponent, BsacFlagsFieldComponent, BsacM2mFieldComponent, BsacDatetimeInputComponent, BsacFieldControlComponent, BsacSelectRelatedComponent, BsacDecimalInputComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFormsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    RouterModule,
                    NgbModule,
                    ReactiveFormsModule,
                    BsacMessageModule,
                    BsacUtilsModule,
                    BsacI18nModule
                ],
                declarations: [
                    BsacDdFieldComponent,
                    BsacFlagsFieldComponent,
                    BsacM2mFieldComponent,
                    BsacDatetimeInputComponent,
                    BsacFieldControlComponent,
                    BsacSelectRelatedComponent,
                    BsacDecimalInputComponent,
                ],
                exports: [
                    BsacDdFieldComponent,
                    BsacFlagsFieldComponent,
                    BsacM2mFieldComponent,
                    BsacDatetimeInputComponent,
                    BsacFieldControlComponent,
                    BsacSelectRelatedComponent,
                    BsacDecimalInputComponent,
                ]
            }]
    }], null, null); })();

/**
 * Model field display container.
 */
class BsacModelField {
}
/**
 * Field list container.
 * Stores list of fields and their display status (enabled, position, ..)
 */
class BsacModelListFields {
    /**
     * Create a ModelListFields instance.
     *
     * @param model    model reference
     * @param allowed_fields  allowed fields name list (empty list = all fields)
     * @param default_fields default fields display (list of field data)
     * @param excluded_fields excluded fields (empty list = no field excluded)
     * @param custom   custom fields description (name, verbose_name)
     */
    constructor(model = null, allowed_fields = [], default_fields = [], excluded_fields = [], custom = []) {
        this.field_list = [];
        // Fields list
        this._fields = [];
        this._output = new ReplaySubject(1);
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this._registered = [];
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this._enabled = [];
        this.model = model;
        this.allowed_fields = allowed_fields;
        this.default_fields = default_fields;
        this.excluded_fields = excluded_fields;
        let fields = allowed_fields;
        // Get a model instance to read model fields
        let m;
        if (model !== null) {
            m = new model();
            if (m._fields) {
                fields = Object.keys(m._fields);
            }
        }
        else {
            m = model;
        }
        // Retrieve model fields and filter them
        for (const fn of fields) {
            // Register fields
            this._registered.push({ name: fn, description: m._fields[fn].verboseName });
            if (allowed_fields.length !== 0 && allowed_fields.indexOf(fn) === -1) {
                // Check if field is in allowed fields.
                continue;
            }
            if (excluded_fields.length !== 0 && excluded_fields.indexOf(fn) !== -1) {
                // Check if field is in excluded fields.
                continue;
            }
            // Field allowed. Store & set defaults.
            const lf = new BsacModelField();
            lf.name = fn;
            lf.verbose_name = m._fields[fn].verboseName;
            if (default_fields.length === 0) {
                lf.enabled = true;
                lf.position = this._fields.length * 10;
            }
            else {
                const def = default_fields.indexOf(fn);
                if (def !== -1) {
                    lf.enabled = true;
                    lf.position = def * 10;
                }
                else {
                    lf.enabled = false;
                    lf.position = (default_fields.length + this._fields.length) * 10;
                }
            }
            this._fields.push(lf);
        }
        // Add custom fields
        for (const cs of custom) {
            this._registered.push({ name: cs.name, description: cs.verbose_name });
            if (excluded_fields.length !== 0 && excluded_fields.indexOf(cs.name) !== -1) {
                continue;
            }
            const lf = new BsacModelField();
            lf.name = cs.name;
            lf.verbose_name = cs.verbose_name;
            if (default_fields.length === 0) {
                lf.enabled = true;
                lf.position = this._fields.length * 10;
            }
            else {
                const def = default_fields.indexOf(cs.name);
                if (def !== -1) {
                    lf.enabled = true;
                    lf.position = def * 10;
                }
                else {
                    lf.enabled = false;
                    lf.position = (default_fields.length + this._fields.length) * 10;
                }
            }
            this._fields.push(lf);
        }
        this._update();
    }
    /**
     * Returns all registered fields (from dsmodel).
     *
     * @returns registered fields
     */
    get registered() {
        return this._registered;
    }
    /**
     * Returns enabled fields (in order)
     *
     * @returns enabled fields (only their names)
     */
    get enabled() {
        return this._enabled;
    }
    /**
     * Returns all allowed fields with their details.
     *
     * @returns allowed fields details.
     */
    get allowed() {
        return this._fields;
    }
    /**
     * Observable of current enabled fields.
     */
    get output$() {
        return this._output.asObservable();
    }
    /**
     * Enable a field by name. Position is optional.
     *
     * @param fname : name of field to be enabled
     * @param  position : position (optional)
     * @returns current enabled fields
     */
    enable(fname, position = null) {
        const f = find(this._fields, ["name", fname]);
        if (f) {
            f.enabled = true;
            if (position !== null) {
                f.position = position;
            }
        }
        else {
            console.error("Field not found", f);
        }
        this._update();
        return this._enabled;
    }
    /**
     * Disable a field by name.
     *
     * @param fname : name of field to be disabled
     * @returns  current enabled fields
     */
    disable(fname) {
        const f = find(this._fields, ["name", fname]);
        if (f) {
            f.enabled = false;
        }
        else {
            console.error("Field not found", f);
        }
        this._update();
        return this._enabled;
    }
    /**
     * Move field `fname` before or after (depending on `position`) field `dest`.
     *
     * @param fname field to move
     * @param position ("before" or "after")
     * @param dest reference field
     * @returns current enabled fields
     */
    move(fname, position, dest) {
        const ftarget = find(this._fields, ["name", fname]);
        const fdest = find(this._fields, ["name", dest]);
        if (!ftarget || !fdest) {
            console.error("Target / dest not found", fname, dest);
            return this._enabled;
        }
        ftarget.position = fdest.position + (position === "before" ? -5 : +5);
        this._update();
        let i = 0;
        for (const f of this._fields) {
            f.position = i * 10;
            i += 10;
        }
        return this._enabled;
    }
    /**
     * Check if field with name `fname` is enabled.
     *
     * @param fname : name of field
     * @returns  enabled (true) or disabled (false)
     */
    isEnabled(fname) {
        return this._enabled.indexOf(fname) !== -1;
    }
    /**
     * Sort fields by position and update caches.
     */
    _update() {
        this._fields = sortBy(this._fields, "position");
        this._enabled = map$1(filter(this._fields, ["enabled", true]), "name");
        this._output.next(this._enabled);
    }
}
class BsacModelListFieldsService {
    constructor() {
        this._values = {};
    }
    /**
     * Get a fields list container, by name.
     * No checks are made to ensure that model & fields matches stored fields.
     *
     * @param name : container name
     * @param model : IDSModel used for this container
     * @param allowed : list of allowed fields (all fields if blank)
     * @param defaults : list of default enabled fields
     * @param excluded : list of excluded fields
     * @param custom : list of custom fields ({name, verbose_name})
     * @returns field list container instance
     */
    get(name, model, allowed = [], defaults = [], excluded = [], custom = []) {
        if (!this._values[name]) {
            this._values[name] = new BsacModelListFields(model, allowed, defaults, excluded, custom);
        }
        return this._values[name];
    }
}
BsacModelListFieldsService.ɵfac = function BsacModelListFieldsService_Factory(t) { return new (t || BsacModelListFieldsService)(); };
BsacModelListFieldsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacModelListFieldsService, factory: BsacModelListFieldsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFieldsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

// noinspection JSUnusedGlobalSymbols
/**
 * Filter advanced value, enable PrefixSeparatorOperation=Value queries.
 *
 * Default separator is __
 */
class FilterValue {
    /**
     * FieldValue constructor.
     *
     * Field name is mandatory, field init is used to prefill other fields.
     *
     * @param name field name
     * @param init init values
     */
    constructor(name, init) {
        this.allowed = true;
        if (isObject(init)) {
            assign(this, init);
        }
        else {
            this.value = init;
            this.enabled = true;
        }
        this.name = name;
        if (!this.prefix) {
            this.prefix = name;
        }
    }
    get disabled() {
        return !(this.allowed && !this.enabled);
    }
    /**
     * True if field is empty (null/undefined,empty value)
     */
    get empty() {
        return this.value === "" || this.value === null || this.value === undefined || this.value === [];
    }
    /**
     * Add a value to multi-valued field.
     *
     * @param  value : string value to add
     * @param  desc : description of field value
     */
    add(value, desc) {
        if (!isArray(this.value)) {
            this.value = [];
        }
        if (this.value.indexOf(value) === -1) {
            this.value.push(value);
        }
        if (!isObject(this.desc)) {
            this.desc = {};
        }
        this.desc[value] = desc;
    }
    /**
     * Remove a value from multi-valued field.
     *
     * @param  value : string value to add
     */
    remove(value) {
        if (!isArray(this.value)) {
            this.value = [];
        }
        const pos = this.value.indexOf(value);
        if (pos !== -1) {
            this.value.splice(pos, 1);
        }
        if (!isObject(this.desc)) {
            this.desc = {};
        }
        delete this.desc[value];
    }
    /**
     * Updates an IFilterOutput object with current filter values.
     *
     * If values are empty or field is not enabled, don't update anything. *
     *
     * @param output object (updated in-place)
     */
    output(output) {
        // No-op, just added if needed
        const encodeURIPartial = (a) => a;
        if (!this.enabled) {
            return;
        }
        if (this.empty) {
            return;
        }
        let key = this.prefix;
        if (this.operation) {
            const sep = !this.separator ? "__" : this.separator;
            key += sep + this.operation;
        }
        if (isArray(this.value)) {
            output[key] = encodeURIPartial("" + this.value.join(","));
        }
        else {
            output[key] = encodeURIPartial("" + this.value);
        }
    }
    /**
     * Returns description for current field. If value is given, returns description for it.
     *
     * @param  value field name
     */
    getDescription(value) {
        if (isString(this.desc)) {
            return this.desc;
        }
        if (value && isObject(this.desc)) {
            return this.desc[value] || "????";
        }
        return "????";
    }
}
/**
 * Filter data class.
 *
 * Manages filter set, unset, export values.
 */
class FilterData {
    /**
     * FilterData constructor.
     *
     * @param defaults : IFilterDefaults object to set filter defaults values.
     * @param allowed_filters : list of allowed filter names
     * @param default_filters : list of filters enabled by default
     * @param excluded_filters : list of excluded filters
     */
    constructor(defaults = {}, allowed_filters = [], default_filters = [], excluded_filters = []) {
        this._vdict = {};
        this._values = [];
        this._defaults = [];
        this._enabled = new ReplaySubject(1);
        this._output = new ReplaySubject(1);
        this._changed = new ReplaySubject(1);
        this._oldenabled = [];
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this._registeredFields = [];
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this._registeredGroups = [];
        for (const n of Object.keys(defaults).sort()) {
            this._defaults.push(new FilterValue(n, defaults[n]));
        }
        this._values = cloneDeep(this._defaults);
        this.allowed_filters = allowed_filters;
        this.default_filters = default_filters;
        this.excluded_filters = excluded_filters;
        this.setVisibility();
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
    }
    get registeredFields() {
        return this._registeredFields;
    }
    get registeredGroups() {
        return this._registeredGroups;
    }
    get filters() {
        return this._vdict;
    }
    /**
     * Observable of the list of currently enabled filter names.
     */
    get enabled$() {
        return this._enabled.asObservable();
    }
    /**
     * Observable of the list of externally changed filters.
     */
    get changed$() {
        return this._changed.asObservable();
    }
    /**
     * Observable of current output value for all enabled filters.
     */
    get output$() {
        return this._output.asObservable();
    }
    /**
     * Get registered field by name.
     *
     * @param name name of registered field
     * @returns registered field or undefined if not found
     */
    registeredField(name) {
        for (const f of this._registeredFields) {
            if (f.name === name) {
                return f;
            }
        }
        return undefined;
    }
    // noinspection JSUnusedGlobalSymbols
    /**
     * Get registered group by name.
     *
     * @param name name of registered group
     * @returns registered group or undefined if not found
     */
    registeredGroup(name) {
        for (const f of this._registeredGroups) {
            if (f.name === name) {
                return f;
            }
        }
        return undefined;
    }
    /**
     * Register a filter and its description.
     *
     * @param name filter name
     * @param description filter description
     * @param group filter group name (default = "default")
     * @returns true if field was registered for the first time
     */
    registerField(name, description, group = "default") {
        for (let i = 0; i < this._registeredFields.length; i++) {
            if (this._registeredFields[i].name === name) {
                this._registeredFields[i] = { description, group, name };
                return false;
            }
        }
        this._registeredFields.push({ description, group, name });
        return true;
    }
    /**
     * Register a group and its description.
     *
     * @param name group name
     * @param description filter description
     * @returns true if group was registered for the first time
     */
    registerGroup(name, description) {
        for (let i = 0; i < this._registeredGroups.length; i++) {
            if (this._registeredGroups[i].name === name) {
                this._registeredGroups[i] = { description, name };
                return false;
            }
        }
        this._registeredGroups.push({ description, name });
        return true;
    }
    /**
     * Reset filter values to default values.
     *
     * If no default argument is given, uses default values from constructor.
     *
     * @param defaults filter default arguments
     */
    reset(defaults) {
        const oldfilters = map$1(this._values, "name");
        if (defaults === undefined) {
            this._values = cloneDeep(this._defaults);
        }
        else {
            this._values = [];
            this.setVisibility();
            for (const n of Object.keys(defaults).sort()) {
                this._values.push(new FilterValue(n, defaults[n]));
            }
        }
        const newfilters = map$1(this._values, "name");
        const filters = union(oldfilters, newfilters);
        this._updateDict();
        this._updateChangedFilters(filters);
        this._updateEnabledFilters();
        this._updateFilterOutput();
        return this;
    }
    setVisibility() {
        for (const fname of this.allowed_filters) {
            let f = this._get(fname);
            if (f === undefined) {
                this.set(fname, "");
                f = this._get(fname);
            }
            f.enabled = false;
            f.allowed = true;
        }
        for (const fname of this.default_filters) {
            let f = this._get(fname);
            if (f === undefined) {
                this.set(fname, "");
                f = this._get(fname);
            }
            f.enabled = true;
            f.allowed = true;
        }
        for (const fname of this.excluded_filters) {
            let f = this._get(fname);
            if (f === undefined) {
                this.set(fname, "");
                f = this._get(fname);
            }
            f.enabled = false;
            f.allowed = false;
        }
    }
    /**
     * Set properties to filter.
     *
     * @param name field name
     * @param defaults field default values
     */
    setProperties(name, defaults = {}) {
        let f = this._get(name);
        if (f === undefined) {
            f = new FilterValue(name, defaults);
            this._values.push(f);
        }
        assign(f, defaults);
        this._updateDict();
        return f;
    }
    /**
     * Set filter value, overwriting previous value.
     *
     * If field does not exist, it is created.
     * Field is enabled & output/enabled observables are updated after setting value.
     *
     * @param name field name
     * @param value field value
     * @param desc field description
     */
    set(name, value, desc) {
        let f = this._get(name);
        if (f === undefined) {
            f = new FilterValue(name, value);
            this._values.push(f);
        }
        if (isObject(value)) {
            assign(f, pick(value, ["operation", "separator", "value"]));
        }
        else {
            f.value = value;
        }
        if (desc !== undefined) {
            f.desc = desc;
        }
        f.enabled = true;
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
        return this;
    }
    /**
     * Add a value to multi-value filter.
     *
     * If field does not exist, it is created.
     * Field is enabled & output/enabled observables are updated after setting value.
     *
     * @param name field name
     * @param value field value
     * @param desc field description
     */
    add(name, value, desc) {
        let f = this._get(name);
        if (f === undefined) {
            f = new FilterValue(name, value);
            this._values.push(f);
        }
        f.add(value, desc);
        f.enabled = true;
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
        return this;
    }
    /**
     * Remove a value to multi-value filter.
     *
     * If field does not exist, it is created.
     * Field is enabled & output/enabled observables are updated after setting value.
     *
     * @param name field name
     * @param value field value
     */
    remove(name, value) {
        let f = this._get(name);
        if (f === undefined) {
            f = new FilterValue(name, value);
            this._values.push(f);
        }
        f.remove(value);
        f.enabled = !f.empty;
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
        return this;
    }
    /**
     * Remove filter.
     *
     * @param  name field name
     */
    unset(name) {
        for (const f of this._values) {
            if (f.name === name) {
                f.value = "";
                f.enabled = false;
                break;
            }
        }
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
        return this;
    }
    /**
     * Enable filter.
     *
     * @param name : field name
     * @param status : force field status (if given)
     */
    toggle(name, status) {
        if (this.excluded_filters.indexOf(name) !== -1) {
            status = false;
        }
        if (this.allowed_filters.length > 0) {
            if (this.allowed_filters.indexOf(name) === -1) {
                status = false;
            }
        }
        for (const f of this._values) {
            if (f.name === name) {
                if (status === undefined) {
                    f.enabled = !f.enabled;
                }
                else {
                    f.enabled = status;
                }
                this._updateDict();
                this._updateChangedFilters([name]);
                this._updateEnabledFilters();
                this._updateFilterOutput();
                return;
            }
        }
        const nv = new FilterValue(name, "");
        nv.enabled = status === undefined ? true : status;
        this._values.push(nv);
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
        return this;
    }
    /**
     * Get filter value.
     *
     * @param  name field value
     */
    get(name) {
        for (const f of this._values) {
            if (f.name === name) {
                return f;
            }
        }
        return { value: undefined };
    }
    // noinspection JSUnusedGlobalSymbols
    /**
     * Outputs filter values for queryset.
     */
    getFilter() {
        console.warn("DEPRECATED, use output$ observable instead");
        const output = {};
        for (const f of this._values) {
            f.output(output);
        }
        return output;
    }
    /**
     * Export filter values.
     */
    export() {
        const out = [];
        for (const c of this._values) {
            out.push(pick(c, ["name", "prefix", "operation", "enabled", "value", "desc", "order", "separator"]));
        }
        return out;
    }
    /**
     * Import filter values.
     */
    import(data) {
        const oldfilters = map$1(this._values, "name");
        this._values = [];
        for (const d of data) {
            this._values.push(new FilterValue(d.name, d));
        }
        const newfilters = map$1(this._values, "name");
        const filters = union(oldfilters, newfilters);
        this._updateDict();
        this._updateEnabledFilters();
        this._updateFilterOutput();
        this._updateChangedFilters(filters);
        return this;
    }
    /**
     * Computes enabled filter names.
     */
    _updateEnabledFilters() {
        const out = [];
        for (const f of this._values) {
            if (f.enabled) {
                out.push(f.name);
            }
        }
        if (!this._oldenabled) {
            this._oldenabled = out;
            this._enabled.next(out);
        }
        else {
            if (!isEqual(out, this._oldenabled)) {
                this._oldenabled = out;
                this._enabled.next(out);
            }
        }
    }
    /**
     * Update current filter output;
     */
    _updateFilterOutput() {
        const output = {};
        for (const f of this._values) {
            f.output(output);
        }
        this._output.next(output);
    }
    /** Update changed filters
     *
     */
    _updateChangedFilters(filters) {
        this._changed.next(filters);
    }
    /**
     * Get FilterValue by name.
     *
     * @param  name : FilterValue name
     * @returns filter value or undefined
     */
    _get(name) {
        for (const f of this._values) {
            if (f.name === name) {
                return f;
            }
        }
        return undefined;
    }
    _updateDict() {
        this._vdict = keyBy(this._values, "name");
    }
}
/**
 * Filters service.
 *
 * Stores named filtersets, load / save filter values.
 */
class BsacModelListFilterService {
    constructor() {
        this.filters = {};
    }
    get(name, defaults = {}, allowed_filters = [], default_filters = [], excluded_filters = []) {
        if (!this.filters[name]) {
            this.filters[name] = { cur: new FilterData(defaults, allowed_filters, default_filters, excluded_filters), saved: {} };
        }
        return this.filters[name].cur;
    }
    // public save(filterName: string, saveName: string): Observable<FilterData> {
    //   const val = this.filters[filterName].cur.export();
    //   this.filters[filterName].saved[saveName] = val;
    //   if (this._persistence) {
    //     return this._persistence.create({type: "filter", zone: filterName, key: saveName, value: val}, {save: true})
    //       .map((result) => {
    //         return this.filters[filterName].cur;
    //       });
    //   }
    //   return Observable.of(this.filters[filterName].cur);
    // }
    //
    // public load(filterName: string, saveName: string): Observable<FilterData> {
    //   if (this.filters[filterName].saved[saveName]) {
    //     this.filters[filterName].cur.import(this.filters[filterName].saved[saveName]);
    //     return Observable.of(this.filters[filterName].cur);
    //   } else {
    //     return Observable.throw("Unknown filter");
    //   }
    // }
    list(filterName) {
        return of(Object.keys(this.filters[filterName].saved));
    }
}
BsacModelListFilterService.ɵfac = function BsacModelListFilterService_Factory(t) { return new (t || BsacModelListFilterService)(); };
BsacModelListFilterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacModelListFilterService, factory: BsacModelListFilterService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFilterService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PaginationData {
    constructor(defaults = null) {
        this._output = new ReplaySubject(1);
        if (!defaults) {
            defaults = { page_size: 20, page: 1 };
        }
        this.page_size = defaults.page_size || 20;
        this.page = defaults.page || 1;
        this._updateOutput("constructor");
    }
    get output$() {
        return this._output.asObservable();
    }
    get() {
        return { page: this.page, page_size: this.page_size };
    }
    setPage(page) {
        if (page !== this.page) {
            this.page = page;
            this._updateOutput("setPage");
        }
    }
    updatePage(page) {
        if (page !== this.page) {
            this.page = page;
        }
    }
    setPageSize(size) {
        if (size !== this.page_size) {
            this.page_size = size;
            this._updateOutput("setPageSize");
        }
    }
    getPageSize() {
        return this.page_size;
    }
    _updateOutput(from = "") {
        this._output.next({ page: this.page, page_size: this.page_size });
    }
}
class BsacModelListPaginatorService {
    constructor() {
        this.pdata = {};
    }
    get(name, defaults = null) {
        if (!this.pdata[name]) {
            this.pdata[name] = new PaginationData(defaults);
        }
        return this.pdata[name];
    }
}
BsacModelListPaginatorService.ɵfac = function BsacModelListPaginatorService_Factory(t) { return new (t || BsacModelListPaginatorService)(); };
BsacModelListPaginatorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacModelListPaginatorService, factory: BsacModelListPaginatorService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListPaginatorService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class SorterData {
    constructor(defaults = []) {
        this._values = [];
        this._output = new ReplaySubject(1);
        // SEE: is copy needed ?
        this._values = cloneDeep(defaults);
        this._updateOutput("constructor");
    }
    get output$() {
        return this._output.asObservable();
    }
    /**
     * Set sorting for `name` key, in direction `direction`.
     * If sorting is already set for `name` key, updates direction without changing order.
     * If sorting isn't set for `name` key, adds it at the end of sorting directions.
     *
     * @param name field name
     * @param direction sort direction
     * @returns sorter data
     */
    set(name, direction) {
        for (const v of this._values) {
            if (v.field === name) {
                v.direction = direction;
                this._updateOutput();
                return this;
            }
        }
        this._values.push({ field: name, direction });
        this._updateOutput("set");
        return this;
    }
    /**
     * Removes `name` sorting key from current keys.
     *
     * @param  name sort key to be removed
     * @returns sorter data
     */
    unset(name) {
        for (let i = 0; i < this._values.length; i++) {
            if (this._values[i].field === name) {
                this._values.splice(i, 1);
                break;
            }
        }
        this._updateOutput("unset");
        return this;
    }
    /**
     * Get sorting status for `field` argument.
     * If `field` is not found, returns null.
     *
     * @param  field field name
     * @returns ordering direction / null
     */
    get(field) {
        for (const v of this._values) {
            if (v.field === field) {
                return v;
            }
        }
        return null;
    }
    /**
     * Return all sorter data values.
     *
     * @returns all sorter data values.
     */
    getAll() {
        return this._values;
    }
    /**
     * Get the ordering position for `field` argument. If not found, returns -1.
     *
     * @param  field field name
     * @returns ordering position for field
     */
    getOrder(field) {
        for (let i = 0; i < this._values.length; i++) {
            if (this._values[i].field === field) {
                return i + 1;
            }
        }
        return -1;
    }
    _updateOutput(_from = "") {
        this._output.next(this._values);
    }
}
/**
 * ModelListSorterServices : stores sort parameters for views.
 */
class BsacModelListSorterService {
    constructor() {
        this.sorts = {};
    }
    /**
     * Get or create sort data for `name` context.
     *
     * @param name field name
     * @param defaults values
     * @returns sorter data object for `name` context
     */
    get(name, defaults = []) {
        if (!this.sorts[name]) {
            this.sorts[name] = new SorterData(defaults);
        }
        return this.sorts[name];
    }
}
BsacModelListSorterService.ɵfac = function BsacModelListSorterService_Factory(t) { return new (t || BsacModelListSorterService)(); };
BsacModelListSorterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacModelListSorterService, factory: BsacModelListSorterService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSorterService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const BSAC_MODEL_LIST_PERSISTENCE = new InjectionToken("bsac.modellist.persistence");
class BsacModelListPersistence {
}
class BsacModelListLocalStoragePersistenceService {
    constructor() {
        this._data = [];
    }
    listP(type, zone) {
        this._load();
        return of(this._data);
    }
    getP(type, zone, key, pub) {
        this._load();
        return of(find(this._data, { type, zone, key, public: pub }));
    }
    saveP(type, zone, key, value, pub) {
        this._load();
        const pos = findIndex(this._data, { type, zone, key, public: pub });
        if (pos === -1) {
            this._data.push({ type, zone, key, value, public: pub });
        }
        else {
            this._data[pos] = { type, zone, key, value, public: pub };
        }
        this._save();
        return of({ type, zone, key, value, public: pub });
    }
    removeP(type, zone, key) {
        this._load();
        const pos = findIndex(this._data, { type, zone, key });
        if (pos >= 0) {
            this._data.splice(pos, 1);
        }
        this._save();
        return of(true);
    }
    _load() {
        if (!localStorage) {
            throw new Error("NO LOCAL STORAGE");
        }
        this._data = JSON.parse(localStorage.getItem("_bsacModelListPersistence"));
        if (!this._data) {
            this._data = [];
        }
    }
    _save() {
        if (!localStorage) {
            throw new Error("NO LOCAL STORAGE");
        }
        localStorage.setItem("_bsacModelListPersistence", JSON.stringify(this._data));
    }
}
BsacModelListLocalStoragePersistenceService.ɵfac = function BsacModelListLocalStoragePersistenceService_Factory(t) { return new (t || BsacModelListLocalStoragePersistenceService)(); };
BsacModelListLocalStoragePersistenceService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacModelListLocalStoragePersistenceService, factory: BsacModelListLocalStoragePersistenceService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListLocalStoragePersistenceService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const BSAC_SETTINGS_SERVICE = new InjectionToken("modellist.settings.service");
class BsacModelListSettingsService {
    constructor(_ss) {
        this._ss = _ss;
        this._cache = {};
    }
    get(type, key, opt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._ss) {
                console.warn("No settings service provided through BSAC_SETTINGS_SERVICE, using defaults");
                return undefined;
            }
            if (this._cache[`${type}@@${key}@@${opt}`]) {
                return this._cache[`${type}@@${key}@@${opt}`].value_json;
            }
            if (!this._qs) {
                this._qs = this._ss.queryset;
            }
            const qr = yield this._ss.queryset.query({ type, key, opt }).get().toPromise();
            for (const sr of qr.items) {
                if (sr.type === type && sr.key === key && sr.opt === opt) {
                    this._cache[`${sr.type}@@${sr.key}@@${sr.opt}`] = sr;
                    return sr.value_json;
                }
                else {
                    console.warn("Settings value mismatch, not matching key/opt/type", key, opt, type, sr);
                }
            }
            console.warn("No settings found for this view : ", type, key, opt);
            return undefined;
        });
    }
}
BsacModelListSettingsService.ɵfac = function BsacModelListSettingsService_Factory(t) { return new (t || BsacModelListSettingsService)(ɵngcc0.ɵɵinject(BSAC_SETTINGS_SERVICE, 8)); };
BsacModelListSettingsService.ɵprov = ɵɵdefineInjectable({ factory: function BsacModelListSettingsService_Factory() { return new BsacModelListSettingsService(ɵɵinject(BSAC_SETTINGS_SERVICE, 8)); }, token: BsacModelListSettingsService, providedIn: "root" });
BsacModelListSettingsService.ctorParameters = () => [
    { type: DSRestCollection, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_SETTINGS_SERVICE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSettingsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc6.DSRestCollection, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_SETTINGS_SERVICE]
            }] }]; }, null); })();

/**
 * Manages a model list : filters, fields, sort, pagination.
 */
class BsacModelList {
    constructor(_msg, _persistence) {
        this._msg = _msg;
        this._persistence = _persistence;
        this.searching = true;
        this.emitFields = false;
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this._results = new ReplaySubject(1);
    }
    /**
     * Results observable.
     */
    get results() {
        return this._results.asObservable();
    }
    /**
     * Launches results retrieving from current parameters.
     *
     * @param params: additional query parameters (TODO: check format)
     * @param force: if true, force query relaunch
     */
    get(params = {}, force = false) {
        if (!force) {
            console.warn("Don't use force GET for lists");
            // throw new Error("Don't use this ");
        }
        if (force) {
            this.queryset.get(params)
                .subscribe((results) => {
                this._results.next(results);
            }, (error) => {
                console.error("Error in BsacModelList.get : ", error);
                this._msg.error("Error getting data", "API failed : " + error.toString(), error._body);
            });
        }
        return this._results.asObservable();
    }
    start(params = {}, unsubscribe) {
        if (this.subscription) {
            return;
        }
        if (unsubscribe === undefined) {
            this._unsubscribe$ = new Subject();
        }
        else {
            this._unsubscribe$ = unsubscribe;
        }
        this.subscription = combineLatest([
            this.filter.output$.pipe(takeUntil(this._unsubscribe$)),
            this.paginator.output$.pipe(takeUntil(this._unsubscribe$)),
            this.sorter.output$.pipe(takeUntil(this._unsubscribe$)),
            this.fields.output$.pipe(takeUntil(this._unsubscribe$))
        ])
            .pipe(debounceTime(40), switchMap(([filter, paginator, sorter, fields]) => {
            this.searching = true;
            this.queryset.query(filter).paginate(paginator).sort(sorter);
            if (this.emitFields) {
                this.queryset.fields(fields);
            }
            return this.queryset.get(params);
        })).subscribe((results) => {
            this._results.next(results);
            this.searching = false;
        }, (error) => {
            console.error("Error in BsacModelList.get : ", error);
            this._msg.error("Error getting data", "API failed : " + error.toString(), error._body);
        });
        this._unsubscribe$.subscribe(() => {
            this.subscription.unsubscribe();
            this.subscription = null;
            this.searching = true;
        });
    }
    end(force = false) {
        console.warn("DEPRECATED: please use unsubscribe parameter");
        if (force) {
            this._unsubscribe$.next();
            this._unsubscribe$.complete();
        }
    }
    save(saveName) {
        if (this._persistence) {
            const f = this.filter.export();
            return this._persistence.saveP("filter", this.name, saveName, f, false);
        }
        return throwError("No persistence service");
    }
    load(saveName) {
        if (!this._persistence) {
            return throwError("No persistence service");
        }
        return this._persistence.getP("filter", this.name, saveName, false)
            .pipe(map((saved) => {
            if (saved && saved.value) {
                this.filter.import(saved.value);
            }
            else {
                console.warn("No saved value filter");
            }
            return true;
        }));
    }
    saved() {
        if (!this._persistence) {
            return throwError("No persistence service");
        }
        return this._persistence.listP("filter", this.name);
    }
    connect(_viewer) {
        return this.results.pipe(map((results) => results.items));
    }
    disconnect() {
        this.end();
    }
}
BsacModelList.ctorParameters = () => [
    { type: BsacMessageService },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_MODEL_LIST_PERSISTENCE,] }] }
];
class BsacModelListProvider {
    constructor(_fields, _filter, _sorter, _paginator, _msg, _settings, _persistence) {
        this._fields = _fields;
        this._filter = _filter;
        this._sorter = _sorter;
        this._paginator = _paginator;
        this._msg = _msg;
        this._settings = _settings;
        this._persistence = _persistence;
        this.values = {};
    }
    get(name, collection, defaults) {
        if (!this.values[name] || defaults.reload) {
            const list = new BsacModelList(this._msg, this._persistence);
            list.name = name;
            list.filter = this._filter.get(name, defaults.filter, defaults.allowed_filters, defaults.default_filters, defaults.excluded_filters);
            list.sorter = this._sorter.get(name, defaults.sorter);
            list.paginator = this._paginator.get(name, defaults.paginator);
            list.queryset = collection.queryset;
            list.fields = this._fields.get(name, collection.model, defaults.allowed_fields, defaults.default_fields, defaults.excluded_fields, defaults.custom_fields);
            list.start(defaults.qsparams || {}, defaults.unsubscribe);
            this.values[name] = list;
        }
        else {
            this.values[name].start(defaults.qsparams || {}, defaults.unsubscribe);
        }
        return this.values[name];
    }
    // noinspection JSUnusedGlobalSymbols
    sget(name, mode, collection, defaults) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = yield this._settings.get("modellistsettings", name, mode);
            if (params) {
                if (params.allowed_fields) {
                    defaults.allowed_fields = params.allowed_fields;
                }
                if (params.default_fields) {
                    defaults.default_fields = params.default_fields;
                }
                if (params.allowed_fields && params.default_fields) {
                    defaults.excluded_fields = [];
                }
                if (params.allowed_filters) {
                    defaults.allowed_filters = params.allowed_filters;
                }
                if (params.default_filters) {
                    defaults.default_filters = params.default_filters;
                }
                if (params.allowed_filters && params.default_filters) {
                    defaults.excluded_filters = [];
                }
            }
            return this.get(name, collection, defaults);
        });
    }
}
BsacModelListProvider.ɵfac = function BsacModelListProvider_Factory(t) { return new (t || BsacModelListProvider)(ɵngcc0.ɵɵinject(BsacModelListFieldsService), ɵngcc0.ɵɵinject(BsacModelListFilterService), ɵngcc0.ɵɵinject(BsacModelListSorterService), ɵngcc0.ɵɵinject(BsacModelListPaginatorService), ɵngcc0.ɵɵinject(BsacMessageService), ɵngcc0.ɵɵinject(BsacModelListSettingsService), ɵngcc0.ɵɵinject(BSAC_MODEL_LIST_PERSISTENCE, 8)); };
BsacModelListProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacModelListProvider, factory: BsacModelListProvider.ɵfac });
BsacModelListProvider.ctorParameters = () => [
    { type: BsacModelListFieldsService },
    { type: BsacModelListFilterService },
    { type: BsacModelListSorterService },
    { type: BsacModelListPaginatorService },
    { type: BsacMessageService },
    { type: BsacModelListSettingsService },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BSAC_MODEL_LIST_PERSISTENCE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListProvider, [{
        type: Injectable
    }], function () { return [{ type: BsacModelListFieldsService }, { type: BsacModelListFilterService }, { type: BsacModelListSorterService }, { type: BsacModelListPaginatorService }, { type: BsacMessageService }, { type: BsacModelListSettingsService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BSAC_MODEL_LIST_PERSISTENCE]
            }] }]; }, null); })();

class BsacModelListAutocompleteFilterComponent {
    constructor() {
        this.searchparam = "search";
        this.resultfield = "id";
        this.filter = {};
        this.empty = "-------";
        this.update = true;
        // eslint-disable-next-line
        this._subscription = new Subject();
        /**
         * Search function.
         *
         * @param text$ typed text observable.
         */
        this.search = (text$) => text$.pipe(takeUntil(this._subscription), debounceTime(750), distinctUntilChanged(), switchMap((term) => {
            const f = {};
            f[this.searchparam] = term;
            this.queryset.filter.update(f);
            return this.queryset.get().pipe(map((result) => result.items));
        }));
    }
    /**
     * Display function. Uses descfield or desc tpl (lodash template using model fields).
     */
    get display() {
        const that = this;
        if (this.desctpl) {
            this.tpl = template(this.desctpl);
        }
        else {
            this.tpl = template("<%= " + this.descfield + " %>");
        }
        return (x) => {
            if (x) {
                if (x._disp) {
                    return x._disp;
                }
                return that.tpl(x);
            }
            return "";
        };
    }
    /**
     * Init form & update subscription.
     */
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Filter by value";
            }
        }
        this.fc = new FormControl("");
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        if (this.list.filter.get(this.name).desc !== undefined) {
            this.fc.setValue(this.list.filter.get(this.name).desc, { emitEvent: false });
        }
        this._changed = this.list.filter.changed$.pipe(takeUntil(this._subscription)).subscribe((changed) => {
            if (changed.indexOf(this.name) !== -1) {
                this._update();
            }
        });
        this.fc.valueChanges.pipe(takeUntil(this._subscription), debounceTime(750), distinctUntilChanged())
            .subscribe((value) => {
            if (value) {
                const desc = { _disp: this.display(value) };
                this.list.filter.set(this.name, { value: value[this.resultfield] }, desc);
            }
        });
    }
    ngOnDestroy() {
        this._subscription.next();
        this._subscription.complete();
    }
    /**
     * Selected item callback.
     *
     * Not used.
     *
     * @param model selected model
     */
    selectItem(model) {
    }
    /**
     * Clear filter.
     */
    clearFilter() {
        this.fc.setValue("", { emitEvent: false });
        this.list.filter.unset(this.name);
    }
    check() {
        this.fc.setValue({ code: "toto" }, { emitEvent: false });
    }
    _update() {
        const fmodel = {};
        if (this.descfield) {
            fmodel[this.descfield] = this.list.filter.get(this.name).desc;
        }
        else {
            // FIXME: add real model fetching for templated fields
            console.error("IMPLEMENT REAL MODEL FETCHING ?");
        }
        fmodel[this.resultfield] = this.list.filter.get(this.name).value;
        this.fc.setValue(fmodel, { emitEvent: false });
    }
}
BsacModelListAutocompleteFilterComponent.ɵfac = function BsacModelListAutocompleteFilterComponent_Factory(t) { return new (t || BsacModelListAutocompleteFilterComponent)(); };
BsacModelListAutocompleteFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListAutocompleteFilterComponent, selectors: [["bsac-model-list-autocomplete-filter"]], inputs: { searchparam: "searchparam", resultfield: "resultfield", filter: "filter", empty: "empty", update: "update", label: "label", name: "name", field: "field", list: "list", queryset: "queryset", descfield: "descfield", desctpl: "desctpl" }, decls: 5, vars: 7, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "float-right", "pointer", 3, "click"], [1, "form-control", 3, "formControl", "ngbTypeahead", "editable", "focusFirst", "inputFormatter", "resultFormatter"]], template: function BsacModelListAutocompleteFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "i", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListAutocompleteFilterComponent_Template_i_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "input", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc)("ngbTypeahead", ctx.search)("editable", false)("focusFirst", true)("inputFormatter", ctx.display)("resultFormatter", ctx.display);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc4.NgbTypeahead, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective], styles: [""] });
BsacModelListAutocompleteFilterComponent.propDecorators = {
    name: [{ type: Input }],
    field: [{ type: Input }],
    list: [{ type: Input }],
    queryset: [{ type: Input }],
    searchparam: [{ type: Input }],
    descfield: [{ type: Input }],
    resultfield: [{ type: Input }],
    desctpl: [{ type: Input }],
    filter: [{ type: Input }],
    empty: [{ type: Input }],
    label: [{ type: Input }],
    update: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListAutocompleteFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-autocomplete-filter",
                template: "<div class=\"filteritem\"><i class=\"fa fa-trash float-right pointer\" (click)=\"clearFilter()\"></i><label>{{label}}</label><input class=\"form-control\" [formControl]=\"fc\" [ngbTypeahead]=\"search\" [editable]=\"false\" [focusFirst]=\"true\" [inputFormatter]=\"display\" [resultFormatter]=\"display\"/></div>",
                styles: [""]
            }]
    }], function () { return []; }, { searchparam: [{
            type: Input
        }], resultfield: [{
            type: Input
        }], filter: [{
            type: Input
        }], empty: [{
            type: Input
        }], update: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], field: [{
            type: Input
        }], list: [{
            type: Input
        }], queryset: [{
            type: Input
        }], descfield: [{
            type: Input
        }], desctpl: [{
            type: Input
        }] }); })();

class BsacModelListMetaFilterComponent {
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Search by meta";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        this.prefix = this.field;
        const initial = this.list.filter.get(this.name).value;
        if (initial) {
            const val = initial.split("|");
            if (val[0]) {
                this.fp = new FormControl(val[0]);
            }
            else {
                this.fp = new FormControl("");
            }
            if (val[1]) {
                this.fo = new FormControl(val[1]);
            }
            else {
                this.fo = new FormControl("");
            }
            if (val[2]) {
                this.fv = new FormControl(val[2]);
            }
            else {
                this.fv = new FormControl("");
            }
        }
        else {
            this.fp = new FormControl("");
            this.fo = new FormControl("");
            this.fv = new FormControl("");
        }
        this.fo.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            this.update();
        });
        this.fp.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            this.update();
        });
        this.fv.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            this.update();
        });
    }
    clearFilter() {
        this.fp.setValue("", { emitEvent: false });
        this.fo.setValue("", { emitEvent: false });
        this.fv.setValue("", { emitEvent: false });
        this.list.filter.unset(this.name);
    }
    update() {
        const value = this.fp.value + "|" + this.fo.value + "|" + this.fv.value;
        this.list.filter.set(this.name, value);
    }
}
BsacModelListMetaFilterComponent.ɵfac = function BsacModelListMetaFilterComponent_Factory(t) { return new (t || BsacModelListMetaFilterComponent)(); };
BsacModelListMetaFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListMetaFilterComponent, selectors: [["bsac-model-list-meta-filter"]], inputs: { label: "label", name: "name", list: "list", field: "field" }, decls: 24, vars: 4, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "input-group"], ["type", "text", "placeholder", "Field name", 1, "input-group-prepend", "form-control", 3, "formControl"], [1, "form-control", 3, "formControl"], ["value", ""], ["value", "icontains"], ["value", "iexact"], ["value", "gte"], ["value", "gt"], ["value", "lt"], ["value", "lte"], ["value", "exists"], ["type", "text", "placeholder", "Value", 1, "input-group-append", "form-control", 3, "formControl"]], template: function BsacModelListMetaFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListMetaFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "input", 3);
        ɵngcc0.ɵɵelementStart(6, "select", 4);
        ɵngcc0.ɵɵelementStart(7, "option", 5);
        ɵngcc0.ɵɵtext(8, "----------");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "option", 6);
        ɵngcc0.ɵɵtext(10, "contains");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "option", 7);
        ɵngcc0.ɵɵtext(12, "=");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "option", 8);
        ɵngcc0.ɵɵtext(14, ">=");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "option", 9);
        ɵngcc0.ɵɵtext(16, ">");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "option", 10);
        ɵngcc0.ɵɵtext(18, "<");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "option", 11);
        ɵngcc0.ɵɵtext(20, "<=");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "option", 12);
        ɵngcc0.ɵɵtext(22, "Not null");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(23, "input", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControl", ctx.fp);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fo);
        ɵngcc0.ɵɵadvance(17);
        ɵngcc0.ɵɵproperty("formControl", ctx.fv);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x], styles: [""] });
BsacModelListMetaFilterComponent.propDecorators = {
    list: [{ type: Input }],
    name: [{ type: Input }],
    field: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListMetaFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-meta-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><div class=\"input-group\"><input class=\"input-group-prepend form-control\" type=\"text\" [formControl]=\"fp\" placeholder=\"Field name\"/><select class=\"form-control\" [formControl]=\"fo\"><option value=\"\">----------</option><option value=\"icontains\">contains</option><option value=\"iexact\">=</option><option value=\"gte\">>=</option><option value=\"gt\">></option><option value=\"lt\"><</option><option value=\"lte\"><=</option><option value=\"exists\">Not null</option></select><input class=\"input-group-append form-control\" type=\"text\" [formControl]=\"fv\" placeholder=\"Value\"/></div></div>",
                styles: [""]
            }]
    }], null, { label: [{
            type: Input
        }], name: [{
            type: Input
        }], list: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class BsacModelListSelectFilterComponent {
    constructor(cstt) {
        this.cstt = cstt;
        this.choices = [];
        this.empty = "-------";
        this.curdesc = "";
        this.curchoices = [];
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Select a value";
            }
        }
        this.curdesc = this.list.filter.get(this.field).desc || "";
        this.fc = new FormControl(this.list.filter.get(this.field).value);
        this._getChoices().subscribe((choices) => {
            this.curchoices = choices;
        });
        this.fc.valueChanges.pipe(debounceTime(750), distinctUntilChanged()).subscribe((value) => {
            this.list.filter.set(this.field, value, this._getDescription(value));
            this.curdesc = this.list.filter.get(this.field).desc || "";
        });
        this._changed = this.list.filter.changed$.subscribe((changed) => {
            if (changed.indexOf(this.field) !== -1) {
                this._update();
            }
        });
    }
    ngOnDestroy() {
        if (this._changed) {
            this._changed.unsubscribe();
        }
    }
    isEmpty() {
        return (this.list.filter.get(this.field).value === "");
    }
    clearFilter() {
        this.fc.setValue("", { emitEvent: false });
        this.list.filter.unset(this.field);
        this.curdesc = "";
    }
    _getChoices() {
        if (isString(this.choices)) {
            return this.cstt.get(this.choices);
        }
        else {
            return of((this.choices || []));
        }
    }
    _getDescription(value) {
        for (const v of this.curchoices) {
            if (v.value === value) {
                return v.desc;
            }
        }
        return "????";
    }
    _update() {
        this.fc.reset();
        this.curdesc = this.list.filter.get(this.field).desc;
    }
}
BsacModelListSelectFilterComponent.ɵfac = function BsacModelListSelectFilterComponent_Factory(t) { return new (t || BsacModelListSelectFilterComponent)(ɵngcc0.ɵɵdirectiveInject(BsacApiConstantsService)); };
BsacModelListSelectFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListSelectFilterComponent, selectors: [["bsac-model-list-select-filter"]], inputs: { choices: "choices", empty: "empty", label: "label", field: "field", list: "list" }, decls: 8, vars: 5, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "form-control", 3, "formControl"], ["value", "", 3, "selected"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function BsacModelListSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListSelectFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "select", 2);
        ɵngcc0.ɵɵelementStart(5, "option", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, BsacModelListSelectFilterComponent_option_7_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", ctx.isEmpty());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.empty);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.curchoices);
    } }, directives: [ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x, ɵngcc1.NgForOf], styles: [""] });
BsacModelListSelectFilterComponent.ctorParameters = () => [
    { type: BsacApiConstantsService }
];
BsacModelListSelectFilterComponent.propDecorators = {
    field: [{ type: Input }],
    list: [{ type: Input }],
    choices: [{ type: Input }],
    empty: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSelectFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-select-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><select class=\"form-control\" [formControl]=\"fc\"><option value=\"\" [selected]=\"isEmpty()\">{{empty}}</option><option *ngFor=\"let ch of curchoices\" [value]=\"ch.value\">{{ch.desc}}</option></select></div>",
                styles: [""]
            }]
    }], function () { return [{ type: BsacApiConstantsService }]; }, { choices: [{
            type: Input
        }], empty: [{
            type: Input
        }], label: [{
            type: Input
        }], field: [{
            type: Input
        }], list: [{
            type: Input
        }] }); })();

class BsacModelListTextFilterComponent {
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Search by text";
            }
        }
        this.fc = new FormControl(this.list.filter.get(this.field).value);
        this.list.filter.changed$.subscribe((changed) => {
            if (changed.indexOf(this.field) !== -1) {
                this.update();
            }
        });
        this.fc.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            this.list.filter.set(this.field, { value });
        });
    }
    ngOnDestroy() {
        if (this._changed) {
            this._changed.unsubscribe();
        }
    }
    update() {
        this.fc.setValue(this.list.filter.get(this.field).value, { emitEvent: false });
    }
    clearFilter() {
        this.fc.setValue("", { emitEvent: false });
        this.list.filter.unset(this.field);
    }
}
BsacModelListTextFilterComponent.ɵfac = function BsacModelListTextFilterComponent_Factory(t) { return new (t || BsacModelListTextFilterComponent)(); };
BsacModelListTextFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListTextFilterComponent, selectors: [["bsac-model-list-text-filter"]], inputs: { label: "label", list: "list", field: "field" }, decls: 5, vars: 3, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], ["type", "text", 1, "form-control", 3, "formControl", "placeholder"]], template: function BsacModelListTextFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListTextFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "input", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc)("placeholder", ctx.label);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective], styles: [""] });
BsacModelListTextFilterComponent.propDecorators = {
    list: [{ type: Input }],
    field: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListTextFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-text-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><input class=\"form-control\" type=\"text\" [formControl]=\"fc\" [placeholder]=\"label\"/></div>",
                styles: [""]
            }]
    }], null, { label: [{
            type: Input
        }], list: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class BsacModelListValueFilterComponent {
    constructor() {
        this.enabled = ["eq", "gte", "gt", "lte", "lt", "exists"];
        this.separator = "__";
    }
    ngOnInit() {
        this.prefix = this.field;
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Search by value";
            }
        }
        const initial = this.list.filter.get(this.field);
        if (initial && initial.operation) {
            this.fo = new FormControl(initial.operation);
        }
        else {
            this.fo = new FormControl("eq");
        }
        this.fo.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            const cur = this.list.filter.get(this.field);
            cur.operation = value;
            cur.separator = this.separator;
            this.list.filter.set(this.field, cur);
        });
        if (initial && initial.value) {
            this.fv = new FormControl(initial.value);
        }
        else {
            this.fv = new FormControl("");
        }
        this.fv.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            const cur = this.list.filter.get(this.field);
            cur.separator = this.separator;
            cur.value = value;
            this.list.filter.set(this.field, cur);
        });
    }
    clearFilter() {
        this.fo.setValue("eq", { emitEvent: false });
        this.fv.setValue("", { emitEvent: false });
        this.list.filter.unset(this.field);
    }
}
BsacModelListValueFilterComponent.ɵfac = function BsacModelListValueFilterComponent_Factory(t) { return new (t || BsacModelListValueFilterComponent)(); };
BsacModelListValueFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListValueFilterComponent, selectors: [["bsac-model-list-value-filter"]], inputs: { enabled: "enabled", separator: "separator", label: "label", list: "list", field: "field" }, decls: 13, vars: 9, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "input-group"], [1, "input-group-prepend", "form-control", "vl", 3, "formControl"], ["value", "eq", 4, "ngIf"], ["value", "gte", 4, "ngIf"], ["value", "gt", 4, "ngIf"], ["value", "lt", 4, "ngIf"], ["value", "lte", 4, "ngIf"], ["value", "exists", 4, "ngIf"], ["type", "number", "placeholder", "Value", 1, "form-control", 3, "formControl"], ["value", "eq"], ["value", "gte"], ["value", "gt"], ["value", "lt"], ["value", "lte"], ["value", "exists"]], template: function BsacModelListValueFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListValueFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "select", 3);
        ɵngcc0.ɵɵtemplate(6, BsacModelListValueFilterComponent_option_6_Template, 2, 0, "option", 4);
        ɵngcc0.ɵɵtemplate(7, BsacModelListValueFilterComponent_option_7_Template, 2, 0, "option", 5);
        ɵngcc0.ɵɵtemplate(8, BsacModelListValueFilterComponent_option_8_Template, 2, 0, "option", 6);
        ɵngcc0.ɵɵtemplate(9, BsacModelListValueFilterComponent_option_9_Template, 2, 0, "option", 7);
        ɵngcc0.ɵɵtemplate(10, BsacModelListValueFilterComponent_option_10_Template, 2, 0, "option", 8);
        ɵngcc0.ɵɵtemplate(11, BsacModelListValueFilterComponent_option_11_Template, 2, 0, "option", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "input", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControl", ctx.fo);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled.indexOf("eq") >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled.indexOf("gte") >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled.indexOf("gt") >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled.indexOf("lt") >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled.indexOf("lte") >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enabled.indexOf("exists") >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fv);
    } }, directives: [ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc1.NgIf, ɵngcc5.NumberValueAccessor, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x], styles: [".vl[_ngcontent-%COMP%]{max-width:33%}"] });
BsacModelListValueFilterComponent.propDecorators = {
    list: [{ type: Input }],
    field: [{ type: Input }],
    label: [{ type: Input }],
    enabled: [{ type: Input }],
    separator: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListValueFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-value-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><div class=\"input-group\"><select class=\"input-group-prepend form-control vl\" [formControl]=\"fo\"><option value=\"eq\" *ngIf=\"enabled.indexOf('eq')&gt;=0\">=</option><option value=\"gte\" *ngIf=\"enabled.indexOf('gte')&gt;=0\">>=</option><option value=\"gt\" *ngIf=\"enabled.indexOf('gt')&gt;=0\">></option><option value=\"lt\" *ngIf=\"enabled.indexOf('lt')&gt;=0\"><</option><option value=\"lte\" *ngIf=\"enabled.indexOf('lte')&gt;=0\"><=</option><option value=\"exists\" *ngIf=\"enabled.indexOf('exists')&gt;=0\">Not null</option></select><input class=\"form-control\" type=\"number\" [formControl]=\"fv\" placeholder=\"Value\"/></div></div>",
                styles: [".vl{max-width:33%}"]
            }]
    }], function () { return []; }, { enabled: [{
            type: Input
        }], separator: [{
            type: Input
        }], label: [{
            type: Input
        }], list: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class BsacModelListFlagsFilterComponent {
    constructor() {
        this.empty = "-------";
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Please select flags";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        const init = this.list.filter.get(this.name).value;
        if (init) {
            this.curflags = init.split(",");
        }
        else {
            this.curflags = [];
        }
        this.fc = new FormControl("");
        this.fc.valueChanges.pipe(debounceTime(250)).subscribe((value) => {
            if (value) {
                if (!this.flagPresent(value)) {
                    this.curflags.push(value);
                    this.update();
                }
            }
        });
    }
    clearFilter() {
        this.curflags = [];
        this.fc.setValue("", { emitEvent: false });
        this.list.filter.unset(this.name);
    }
    update() {
        this.list.filter.set(this.name, this.curflags.join(","));
    }
    flagPresent(flag) {
        return this.curflags.findIndex((f) => flag === f) !== -1;
    }
    removeFlag(flag) {
        this.curflags.splice(this.curflags.findIndex((f) => flag === f), 1);
        this.update();
    }
}
BsacModelListFlagsFilterComponent.ɵfac = function BsacModelListFlagsFilterComponent_Factory(t) { return new (t || BsacModelListFlagsFilterComponent)(); };
BsacModelListFlagsFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListFlagsFilterComponent, selectors: [["bsac-model-list-flags-filter"]], inputs: { empty: "empty", label: "label", name: "name", field: "field", list: "list", flags: "flags" }, decls: 10, vars: 6, consts: [[1, "filteritem"], [1, "select"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "form-control", 3, "formControl"], [4, "ngFor", "ngForOf"], [1, "enabled", "mt-1"], ["class", "badge badge-info badge-spaced pointer", 3, "click", 4, "ngFor", "ngForOf"], [3, "value", 4, "ngIf"], [3, "value"], [4, "ngIf"], [1, "badge", "badge-info", "badge-spaced", "pointer", 3, "click"], [1, "fa", "fa-trash", "mr-1"]], template: function BsacModelListFlagsFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "i", 2);
        ɵngcc0.ɵɵlistener("click", function BsacModelListFlagsFilterComponent_Template_i_click_2_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "select", 3);
        ɵngcc0.ɵɵtemplate(6, BsacModelListFlagsFilterComponent_ng_container_6_Template, 2, 1, "ng-container", 4);
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtemplate(9, BsacModelListFlagsFilterComponent_span_9_Template, 3, 1, "span", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(7, 4, ctx.flags));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.curflags);
    } }, directives: [ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x], pipes: [ɵngcc1.AsyncPipe], styles: [""] });
BsacModelListFlagsFilterComponent.propDecorators = {
    name: [{ type: Input }],
    field: [{ type: Input }],
    list: [{ type: Input }],
    flags: [{ type: Input }],
    empty: [{ type: Input }],
    label: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFlagsFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-flags-filter",
                template: "<div class=\"filteritem\"><div class=\"select\"><i class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></i><label>{{label}}</label><select class=\"form-control\" [formControl]=\"fc\"><ng-container *ngFor=\"let flag of flags|async\"><option *ngIf=\"!flagPresent(flag)\" [value]=\"flag.flag\">{{flag.flag}} <ng-container *ngIf=\"flag.count\">- {{flag.count}}</ng-container></option></ng-container></select></div><div class=\"enabled mt-1\"><span class=\"badge badge-info badge-spaced pointer\" *ngFor=\"let flag of curflags\" (click)=\"removeFlag(flag)\"><i class=\"fa fa-trash mr-1\"></i>{{flag}}</span></div></div>",
                styles: [""]
            }]
    }], function () { return []; }, { empty: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], field: [{
            type: Input
        }], list: [{
            type: Input
        }], flags: [{
            type: Input
        }] }); })();

class BsacGeolocService {
    constructor() {
    }
    geocodeAddress(location, region = "fr") {
        console.error("No geoloc provider defined");
        return of(null);
    }
}
BsacGeolocService.ɵfac = function BsacGeolocService_Factory(t) { return new (t || BsacGeolocService)(); };
BsacGeolocService.ɵprov = ɵɵdefineInjectable({ factory: function BsacGeolocService_Factory() { return new BsacGeolocService(); }, token: BsacGeolocService, providedIn: "root" });
BsacGeolocService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacGeolocService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();

class BsacModelListGeodistanceFilterComponent {
    constructor(_fb, _geoloc) {
        this._fb = _fb;
        this._geoloc = _geoloc;
        this.filter = {};
        this.update = true;
        this.operation = "lte";
        this.distances = [10, 20, 50, 100, 150, 200, 300, 500];
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Please select location";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        this.locForm = this._fb.group({
            location: [""],
            distance: [10]
        });
        this.locForm.controls.distance.valueChanges.subscribe(() => {
            if (this.locForm.controls.location.value !== "") {
                this.geoLoc();
            }
        });
        this._changed = this.list.filter.changed$.subscribe((changed) => {
            if (changed.indexOf(this.name) !== -1) {
                this._update();
            }
        });
    }
    clearFilter() {
        this.locForm.setValue({ location: "", distance: 10 }, { emitEvent: false });
        this.geolocation = null;
        this.list.filter.unset(this.name);
    }
    geoLoc($event) {
        this.geolocation = null;
        this._geoloc.geocodeAddress(this.locForm.value.location).subscribe((result) => {
            this.geolocation = result;
            if (this.geolocation && this.geolocation.geometry) {
                this.list.filter.set(this.name, `${this.operation}|${this.locForm.value.distance}|${result.geometry.coordinates[0]}|${result.geometry.coordinates[1]}`, this.locForm.value);
            }
        });
        if ($event) {
            $event.preventDefault();
        }
    }
    ngOnDestroy() {
        if (this._changed) {
            this._changed.unsubscribe();
        }
    }
    _update() {
        const values = this.list.filter.get(this.name).value.split("|");
        if (values.length === 4) {
            this.locForm.setValue(this.list.filter.get(this.name).desc, { emitEvent: false });
            this.geolocation = {
                type: "Feature",
                geometry: { type: "Point", coordinates: [parseFloat(values[2]), parseFloat(values[3])] },
                properties: {}
            };
        }
    }
}
BsacModelListGeodistanceFilterComponent.ɵfac = function BsacModelListGeodistanceFilterComponent_Factory(t) { return new (t || BsacModelListGeodistanceFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.FormBuilder), ɵngcc0.ɵɵdirectiveInject(BsacGeolocService)); };
BsacModelListGeodistanceFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListGeodistanceFilterComponent, selectors: [["bsac-model-list-geodistance-filter"]], inputs: { filter: "filter", update: "update", operation: "operation", distances: "distances", label: "label", name: "name", field: "field", list: "list", queryset: "queryset" }, decls: 13, vars: 4, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [3, "formGroup"], [1, "input-group"], ["formControlName", "distance", 1, "input-group-prepend", "form-control", "dst"], [3, "value", 4, "ngFor", "ngForOf"], ["formControlName", "location", 1, "form-control"], [1, "input-group-append"], [1, "btn", "btn-secondary-outline", 3, "click"], [1, "fa", "fa-search"], ["class", "result", 4, "ngIf"], [3, "value"], [1, "result"], [3, "lat", "lng"]], template: function BsacModelListGeodistanceFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListGeodistanceFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "form", 2);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "select", 4);
        ɵngcc0.ɵɵtemplate(7, BsacModelListGeodistanceFilterComponent_option_7_Template, 2, 2, "option", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "input", 6);
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "button", 8);
        ɵngcc0.ɵɵlistener("click", function BsacModelListGeodistanceFilterComponent_Template_button_click_10_listener() { return ctx.geoLoc(); });
        ɵngcc0.ɵɵelement(11, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, BsacModelListGeodistanceFilterComponent_div_12_Template, 2, 2, "div", 10);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.locForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.distances);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.geolocation && ctx.geolocation.geometry && ctx.geolocation.geometry.coordinates);
    } }, directives: function () { return [ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, ɵngcc1.NgForOf, ɵngcc5.DefaultValueAccessor, ɵngcc1.NgIf, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x, BsacGeoStaticGmapComponent]; }, styles: [".dst[_ngcontent-%COMP%]{max-width:33%}"] });
BsacModelListGeodistanceFilterComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: BsacGeolocService }
];
BsacModelListGeodistanceFilterComponent.propDecorators = {
    name: [{ type: Input }],
    field: [{ type: Input }],
    list: [{ type: Input }],
    queryset: [{ type: Input }],
    filter: [{ type: Input }],
    label: [{ type: Input }],
    update: [{ type: Input }],
    operation: [{ type: Input }],
    distances: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListGeodistanceFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-geodistance-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><form [formGroup]=\"locForm\"><label>{{label}}</label><div class=\"input-group\"><select class=\"input-group-prepend form-control dst\" formControlName=\"distance\"><option *ngFor=\"let d of distances\" [value]=\"d\">{{d}} km</option></select><input class=\"form-control\" formControlName=\"location\"/><div class=\"input-group-append\"><button class=\"btn btn-secondary-outline\" (click)=\"geoLoc()\"><i class=\"fa fa-search\"></i></button></div></div></form><div class=\"result\" *ngIf=\"geolocation &amp;&amp; geolocation.geometry &amp;&amp; geolocation.geometry.coordinates\"><bsac-geo-static-gmap [lat]=\"geolocation.geometry.coordinates[1]\" [lng]=\"geolocation.geometry.coordinates[0]\"></bsac-geo-static-gmap></div></div>",
                styles: [".dst{max-width:33%}"]
            }]
    }], function () { return [{ type: ɵngcc5.FormBuilder }, { type: BsacGeolocService }]; }, { filter: [{
            type: Input
        }], update: [{
            type: Input
        }], operation: [{
            type: Input
        }], distances: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], field: [{
            type: Input
        }], list: [{
            type: Input
        }], queryset: [{
            type: Input
        }] }); })();

class BsacModelListMultiselectFilterComponent {
    constructor(cstt) {
        this.cstt = cstt;
        this.choices = [];
        this.empty = " ----------";
        this.curdesc = {};
        this.selected = [];
        this.curchoices = [];
        this._subscriptions$ = new Subject();
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Filter by values";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        const initial = this.list.filter.get(this.name).value;
        if (initial) {
            this.selected = initial;
            this.curdesc = this.list.filter.get(this.name).desc;
        }
        else {
            this.selected = [];
        }
        this._getChoices().subscribe((choices) => {
            this.curchoices = choices;
        });
        this.fc = new FormControl("");
        this.fc.valueChanges.pipe(takeUntil(this._subscriptions$), debounceTime(750), distinctUntilChanged()).subscribe((value) => {
            if (!isString(value)) {
                value = value.toString();
            }
            this.list.filter.add(this.name, value, this._getDescription(value));
            this.curdesc = this.list.filter.get(this.name).desc;
            this.selected = this.list.filter.get(this.name).value;
            this.fc.setValue("", { emitEvent: false });
        });
        this.list.filter.changed$.pipe(takeUntil(this._subscriptions$)).subscribe((changed) => {
            if (changed.indexOf(this.name) !== -1) {
                this._update();
            }
        });
    }
    ngOnDestroy() {
        this._subscriptions$.next();
        this._subscriptions$.complete();
    }
    isEmpty() {
        return (this.list.filter.get(this.name).value === "");
    }
    removeSelection(s) {
        this.list.filter.remove(this.name, s);
        this.curdesc = this.list.filter.get(this.name).desc;
        this.selected = this.list.filter.get(this.name).value;
    }
    clearFilter() {
        this.selected = [];
        this.fc.setValue("", { emitEvent: false });
        this.list.filter.unset(this.name);
    }
    _getDescription(value) {
        for (const v of this.curchoices) {
            if (v.value.toString() === value) {
                return v.desc;
            }
        }
        return "????";
    }
    _getChoices() {
        if (isString(this.choices)) {
            return this.cstt.get(this.choices);
        }
        else {
            return of((this.choices || []));
        }
    }
    _update() {
        this.fc.reset("", { emitEvent: false });
        this.curdesc = this.list.filter.get(this.name).desc;
        this.selected = this.list.filter.get(this.name).value;
    }
}
BsacModelListMultiselectFilterComponent.ɵfac = function BsacModelListMultiselectFilterComponent_Factory(t) { return new (t || BsacModelListMultiselectFilterComponent)(ɵngcc0.ɵɵdirectiveInject(BsacApiConstantsService)); };
BsacModelListMultiselectFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListMultiselectFilterComponent, selectors: [["bsac-model-list-multiselect-filter"]], inputs: { choices: "choices", empty: "empty", label: "label", name: "name", field: "field", list: "list", filtersetName: "filtersetName" }, decls: 11, vars: 6, consts: [[1, "filteritem"], [1, "select"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "form-control", 3, "formControl"], ["value", "", 3, "selected"], [3, "value", 4, "ngFor", "ngForOf"], [1, "selected"], [4, "ngFor", "ngForOf"], [3, "value"], [1, "fa", "fa-trash", "mr-2", "pointer", 3, "click"]], template: function BsacModelListMultiselectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function BsacModelListMultiselectFilterComponent_Template_div_click_2_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "select", 3);
        ɵngcc0.ɵɵelementStart(6, "option", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, BsacModelListMultiselectFilterComponent_option_8_Template, 2, 2, "option", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵtemplate(10, BsacModelListMultiselectFilterComponent_div_10_Template, 3, 1, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", ctx.isEmpty());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.empty);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.curchoices);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.selected);
    } }, directives: [ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x, ɵngcc1.NgForOf], styles: [""] });
BsacModelListMultiselectFilterComponent.ctorParameters = () => [
    { type: BsacApiConstantsService }
];
BsacModelListMultiselectFilterComponent.propDecorators = {
    field: [{ type: Input }],
    name: [{ type: Input }],
    list: [{ type: Input }],
    choices: [{ type: Input }],
    empty: [{ type: Input }],
    label: [{ type: Input }],
    filtersetName: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListMultiselectFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-multiselect-filter",
                template: "<div class=\"filteritem\"><div class=\"select\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><select class=\"form-control\" [formControl]=\"fc\"><option value=\"\" [selected]=\"isEmpty()\">{{empty}}</option><option *ngFor=\"let ch of curchoices\" [value]=\"ch.value\">{{ch.desc}}</option></select></div><div class=\"selected\"><div *ngFor=\"let s of selected\"><i class=\"fa fa-trash mr-2 pointer\" (click)=\"removeSelection(s)\"></i>{{curdesc[s]}}</div></div></div>",
                styles: [""]
            }]
    }], function () { return [{ type: BsacApiConstantsService }]; }, { choices: [{
            type: Input
        }], empty: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], field: [{
            type: Input
        }], list: [{
            type: Input
        }], filtersetName: [{
            type: Input
        }] }); })();

class BsacModelListMultiautocompleteFilterComponent {
    constructor() {
        this.searchparam = "search";
        this.resultfield = "id";
        this.filter = {};
        this.empty = "-------";
        this.update = true;
        this.curdesc = {};
        this.selected = [];
        this.search = (text$) => text$.pipe(debounceTime(750), distinctUntilChanged(), switchMap((term) => {
            const f = cloneDeep(this.filter);
            f[this.searchparam] = term;
            this.queryset.filter.update(f);
            return this.queryset.get().pipe(map((result) => result.items));
        }));
    }
    get display() {
        const that = this;
        if (this.desctpl) {
            this.tpl = template(this.desctpl);
        }
        else {
            this.tpl = template("<%= " + this.descfield + " %>");
        }
        return (x) => {
            if (x) {
                return that.tpl(x);
            }
            return "";
        };
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Filter by values";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        this.fc = new FormControl("");
        if (this.list.filter.get(this.name).value !== undefined) {
            this.curdesc = this.list.filter.get(this.name).desc;
            this.selected = this.list.filter.get(this.name).value;
        }
        this._changed = this.list.filter.changed$.subscribe((changed) => {
            if (changed.indexOf(this.name) !== -1) {
                this._update();
            }
        });
        this.fc.valueChanges.pipe(debounceTime(750), distinctUntilChanged()).subscribe((value) => {
            if (value) {
                const desc = this.display(value);
                this.list.filter.add(this.name, value[this.resultfield], desc);
                this.curdesc = this.list.filter.get(this.name).desc;
                this.selected = this.list.filter.get(this.name).value;
            }
        });
    }
    ngOnDestroy() {
        if (this._changed) {
            this._changed.unsubscribe();
        }
    }
    removeSelection(s) {
        this.list.filter.remove(this.name, s);
        this.curdesc = this.list.filter.get(this.name).desc;
        this.selected = this.list.filter.get(this.name).value;
    }
    clearFilter() {
        this.fc.setValue("", { emitEvent: false });
        this.list.filter.unset(this.name);
    }
    _update() {
        this.fc.reset();
        this.curdesc = this.list.filter.get(this.name).desc;
        this.selected = this.list.filter.get(this.name).value;
    }
}
BsacModelListMultiautocompleteFilterComponent.ɵfac = function BsacModelListMultiautocompleteFilterComponent_Factory(t) { return new (t || BsacModelListMultiautocompleteFilterComponent)(); };
BsacModelListMultiautocompleteFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListMultiautocompleteFilterComponent, selectors: [["bsac-model-list-multiautocomplete-filter"]], inputs: { searchparam: "searchparam", resultfield: "resultfield", filter: "filter", empty: "empty", update: "update", label: "label", name: "name", field: "field", list: "list", queryset: "queryset", descfield: "descfield", desctpl: "desctpl" }, decls: 8, vars: 8, consts: [[1, "filteritem"], [1, "select"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "form-control", 3, "formControl", "ngbTypeahead", "editable", "focusFirst", "inputFormatter", "resultFormatter"], [1, "selected"], [4, "ngFor", "ngForOf"], [1, "fa", "fa-trash", "mr-2", "pointer", 3, "click"]], template: function BsacModelListMultiautocompleteFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function BsacModelListMultiautocompleteFilterComponent_Template_div_click_2_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "input", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵtemplate(7, BsacModelListMultiautocompleteFilterComponent_div_7_Template, 3, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControl", ctx.fc)("ngbTypeahead", ctx.search)("editable", false)("focusFirst", true)("inputFormatter", ctx.display)("resultFormatter", ctx.display);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.selected);
    } }, directives: [ɵngcc5.DefaultValueAccessor, ɵngcc4.NgbTypeahead, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc1.NgForOf], styles: [""] });
BsacModelListMultiautocompleteFilterComponent.propDecorators = {
    field: [{ type: Input }],
    name: [{ type: Input }],
    list: [{ type: Input }],
    queryset: [{ type: Input }],
    searchparam: [{ type: Input }],
    descfield: [{ type: Input }],
    resultfield: [{ type: Input }],
    desctpl: [{ type: Input }],
    filter: [{ type: Input }],
    empty: [{ type: Input }],
    label: [{ type: Input }],
    update: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListMultiautocompleteFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-multiautocomplete-filter",
                template: "<div class=\"filteritem\"><div class=\"select\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><input class=\"form-control\" [formControl]=\"fc\" [ngbTypeahead]=\"search\" [editable]=\"false\" [focusFirst]=\"true\" [inputFormatter]=\"display\" [resultFormatter]=\"display\"/></div><div class=\"selected\"><div *ngFor=\"let s of selected\"><i class=\"fa fa-trash mr-2 pointer\" (click)=\"removeSelection(s)\"></i>{{curdesc[s]}}</div></div></div>",
                styles: [""]
            }]
    }], function () { return []; }, { searchparam: [{
            type: Input
        }], resultfield: [{
            type: Input
        }], filter: [{
            type: Input
        }], empty: [{
            type: Input
        }], update: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], field: [{
            type: Input
        }], list: [{
            type: Input
        }], queryset: [{
            type: Input
        }], descfield: [{
            type: Input
        }], desctpl: [{
            type: Input
        }] }); })();

const BSAC_MAPS_GMAPS_API_LOADER = new InjectionToken("bsac.geo.maps.api.loader");
const BSAC_MAPS_GMAPS_API_KEY = new InjectionToken("bsac.geo.maps.apikey");
class BsacGeolocGmapsService {
    constructor(mapLoader, _zone) {
        this.mapLoader = mapLoader;
        this._zone = _zone;
    }
    geocodeAddress(location, region = "fr") {
        const res = { type: "Feature", geometry: { type: "Point", coordinates: [0, 0] }, properties: {} };
        return this.waitForMapsToLoad().pipe(switchMap(() => new Observable(observer => {
            this.geocoder.geocode({ address: location, region }, (results, status) => {
                this._zone.run(() => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        let precision;
                        try {
                            const ne = results[0].geometry.bounds.getNorthEast();
                            const sw = results[0].geometry.bounds.getSouthWest();
                            precision = Math.max((ne.lat() - sw.lat()) * 110, (ne.lng() - sw.lng()) * 110);
                        }
                        catch (e) {
                            console.warn("No precision");
                            precision = 0;
                        }
                        res.geometry.coordinates[0] = results[0].geometry.location.lng();
                        res.geometry.coordinates[1] = results[0].geometry.location.lat();
                        res.properties.type = results[0].geometry.location_type;
                        res.properties.precision = precision;
                        res.properties.details = results[0];
                        observer.next(res);
                    }
                    else {
                        observer.next(null);
                    }
                    observer.complete();
                });
            });
        })));
    }
    initGeocoder() {
        this.geocoder = new google.maps.Geocoder();
    }
    waitForMapsToLoad() {
        if (!this.geocoder) {
            return from(this.mapLoader.load())
                .pipe(tap(() => this.initGeocoder()), map(() => true));
        }
        return of(true);
    }
}
BsacGeolocGmapsService.ɵfac = function BsacGeolocGmapsService_Factory(t) { return new (t || BsacGeolocGmapsService)(ɵngcc0.ɵɵinject(BSAC_MAPS_GMAPS_API_LOADER), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
BsacGeolocGmapsService.ɵprov = ɵɵdefineInjectable({ factory: function BsacGeolocGmapsService_Factory() { return new BsacGeolocGmapsService(ɵɵinject(BSAC_MAPS_GMAPS_API_LOADER), ɵɵinject(NgZone)); }, token: BsacGeolocGmapsService, providedIn: "root" });
BsacGeolocGmapsService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BSAC_MAPS_GMAPS_API_LOADER,] }] },
    { type: NgZone }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacGeolocGmapsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BSAC_MAPS_GMAPS_API_LOADER]
            }] }, { type: ɵngcc0.NgZone }]; }, null); })();

class BsacGeoStaticGmapComponent {
    constructor(_sanitizer, _apikey) {
        this._sanitizer = _sanitizer;
        this._apikey = _apikey;
        this.zoom = 8;
        this.height = "120px";
    }
    ngOnInit() {
        if (this.lat && this.lng) {
            this.src = this._sanitizer.bypassSecurityTrustStyle(`url('https://maps.googleapis.com/maps/api/staticmap?` +
                `center=${this.lat},${this.lng}` +
                `&zoom=${this.zoom}` +
                `&size=320x640` +
                `&markers=size:small|color:green|${this.lat},${this.lng}` +
                `&key=${this._apikey}')`);
        }
    }
}
BsacGeoStaticGmapComponent.ɵfac = function BsacGeoStaticGmapComponent_Factory(t) { return new (t || BsacGeoStaticGmapComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(BSAC_MAPS_GMAPS_API_KEY)); };
BsacGeoStaticGmapComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacGeoStaticGmapComponent, selectors: [["bsac-geo-static-gmap"]], inputs: { zoom: "zoom", height: "height", lat: "lat", lng: "lng" }, decls: 1, vars: 1, consts: [["class", "staticmap", 3, "height", "background-image", 4, "ngIf"], [1, "staticmap"]], template: function BsacGeoStaticGmapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacGeoStaticGmapComponent_div_0_Template, 1, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.src);
    } }, directives: [ɵngcc1.NgIf], styles: [".staticmap[_ngcontent-%COMP%]{width:100%;min-height:100px;background-repeat:no-repeat;background-position:50%;background-color:rgba(0,0,0,0);background-size:cover}"] });
BsacGeoStaticGmapComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: undefined, decorators: [{ type: Inject, args: [BSAC_MAPS_GMAPS_API_KEY,] }] }
];
BsacGeoStaticGmapComponent.propDecorators = {
    lat: [{ type: Input }],
    lng: [{ type: Input }],
    zoom: [{ type: Input }],
    height: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacGeoStaticGmapComponent, [{
        type: Component,
        args: [{
                selector: "bsac-geo-static-gmap",
                template: "<div class=\"staticmap\" [style.height]=\"height\" [style.background-image]=\"src\" *ngIf=\"src\"></div>",
                styles: [".staticmap{width:100%;min-height:100px;background-repeat:no-repeat;background-position:50%;background-color:rgba(0,0,0,0);background-size:cover}"]
            }]
    }], function () { return [{ type: ɵngcc7.DomSanitizer }, { type: undefined, decorators: [{
                type: Inject,
                args: [BSAC_MAPS_GMAPS_API_KEY]
            }] }]; }, { zoom: [{
            type: Input
        }], height: [{
            type: Input
        }], lat: [{
            type: Input
        }], lng: [{
            type: Input
        }] }); })();

class BsacGeoModule {
}
BsacGeoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacGeoModule });
BsacGeoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacGeoModule_Factory(t) { return new (t || BsacGeoModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacGeoModule, { declarations: function () { return [BsacGeoStaticGmapComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacGeoStaticGmapComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacGeoModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [BsacGeoStaticGmapComponent],
                exports: [BsacGeoStaticGmapComponent]
            }]
    }], null, null); })();

class BsacModelListDatetimeFilterComponent {
    constructor() {
        this.separator = "|";
        this._subscription$ = new Subject();
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Select date/time";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        const initial = this.list.filter.get(this.name);
        if (initial && initial.value) {
            this.date = new FormControl(new Date(initial.value));
        }
        else {
            this.date = new FormControl(new Date());
        }
        this.date.valueChanges.pipe(takeUntil(this._subscription$), debounceTime(250)).subscribe((value) => {
            this.list.filter.set(this.name, value.toISOString());
        });
    }
    ngOnDestroy() {
        this._subscription$.next();
        this._subscription$.complete();
    }
    clearFilter() {
        this.date.setValue(new Date(), { emitEvent: false });
        this.list.filter.unset(this.name);
    }
}
BsacModelListDatetimeFilterComponent.ɵfac = function BsacModelListDatetimeFilterComponent_Factory(t) { return new (t || BsacModelListDatetimeFilterComponent)(); };
BsacModelListDatetimeFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListDatetimeFilterComponent, selectors: [["bsac-model-list-datetime-filter"]], inputs: { separator: "separator", label: "label", name: "name", list: "list", field: "field" }, decls: 7, vars: 2, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "form-control", "pointer"], [1, "fa", "fa-calendar", "mr-2"], [3, "formControl"]], template: function BsacModelListDatetimeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListDatetimeFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "i", 3);
        ɵngcc0.ɵɵelement(6, "bsac-datetime-input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formControl", ctx.date);
    } }, directives: [BsacDatetimeInputComponent, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective], styles: [""] });
BsacModelListDatetimeFilterComponent.ctorParameters = () => [];
BsacModelListDatetimeFilterComponent.propDecorators = {
    list: [{ type: Input }],
    field: [{ type: Input }],
    name: [{ type: Input }],
    label: [{ type: Input }],
    separator: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListDatetimeFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-datetime-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><div class=\"form-control pointer\"><i class=\"fa fa-calendar mr-2\"></i><bsac-datetime-input [formControl]=\"date\"></bsac-datetime-input></div></div>",
                styles: [""]
            }]
    }], function () { return []; }, { separator: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], list: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class BsacModelListDatetimerangeFilterComponent {
    constructor() {
        this.separator = "|";
        this._subscription$ = new Subject();
    }
    ngOnInit() {
        if (!this.label) {
            if (this.list.filter.registeredField(this.field)) {
                this.label = this.list.filter.registeredField(this.field).description;
            }
            else {
                this.label = "Select date/time";
            }
        }
        if (!this.name) {
            this.name = this.field;
        }
        this.list.filter.setProperties(this.name, { prefix: this.field });
        const initial = this.list.filter.get(this.name);
        if (initial && initial.value) {
            const startend = initial.value.split(this.separator);
            this.start = new FormControl(new Date(startend[0]));
            this.end = new FormControl(new Date(startend[1]));
        }
        else {
            this.start = new FormControl(new Date());
            this.end = new FormControl(new Date());
        }
        combineLatest([
            this.start.valueChanges,
            this.end.valueChanges
        ]).pipe(takeUntil(this._subscription$), debounceTime(250)).subscribe((values) => {
            this.list.filter.set(this.name, values[0].toISOString()
                + this.separator + values[1].toISOString());
        });
    }
    ngOnDestroy() {
        this._subscription$.next();
        this._subscription$.complete();
    }
    clearFilter() {
        this.start.setValue(new Date(), { emitEvent: false });
        this.end.setValue(new Date(), { emitEvent: false });
        this.list.filter.unset(this.name);
    }
}
BsacModelListDatetimerangeFilterComponent.ɵfac = function BsacModelListDatetimerangeFilterComponent_Factory(t) { return new (t || BsacModelListDatetimerangeFilterComponent)(); };
BsacModelListDatetimerangeFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListDatetimerangeFilterComponent, selectors: [["bsac-model-list-datetimerange-filter"]], inputs: { separator: "separator", label: "label", name: "name", list: "list", field: "field" }, decls: 12, vars: 3, consts: [[1, "filteritem"], [1, "fa", "fa-trash", "pointer", "float-right", 3, "click"], [1, "form-control", "pointer"], [1, "fa", "fa-calendar", "mr-2"], [3, "formControl"]], template: function BsacModelListDatetimerangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListDatetimerangeFilterComponent_Template_div_click_1_listener() { return ctx.clearFilter(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "i", 3);
        ɵngcc0.ɵɵtext(6, "from");
        ɵngcc0.ɵɵelement(7, "bsac-datetime-input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelement(9, "i", 3);
        ɵngcc0.ɵɵtext(10, "to");
        ɵngcc0.ɵɵelement(11, "bsac-datetime-input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("formControl", ctx.start);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("formControl", ctx.end);
    } }, directives: [BsacDatetimeInputComponent, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective], styles: [""] });
BsacModelListDatetimerangeFilterComponent.ctorParameters = () => [];
BsacModelListDatetimerangeFilterComponent.propDecorators = {
    list: [{ type: Input }],
    field: [{ type: Input }],
    name: [{ type: Input }],
    label: [{ type: Input }],
    separator: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListDatetimerangeFilterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-datetimerange-filter",
                template: "<div class=\"filteritem\"><div class=\"fa fa-trash pointer float-right\" (click)=\"clearFilter()\"></div><label>{{label}}</label><div class=\"form-control pointer\"><i class=\"fa fa-calendar mr-2\"></i>from<bsac-datetime-input [formControl]=\"start\"></bsac-datetime-input></div><div class=\"form-control pointer\"><i class=\"fa fa-calendar mr-2\"></i>to<bsac-datetime-input [formControl]=\"end\"></bsac-datetime-input></div></div>",
                styles: [""]
            }]
    }], function () { return []; }, { separator: [{
            type: Input
        }], label: [{
            type: Input
        }], name: [{
            type: Input
        }], list: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class BsacModelListFilterModule {
}
BsacModelListFilterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListFilterModule });
BsacModelListFilterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListFilterModule_Factory(t) { return new (t || BsacModelListFilterModule)(); }, providers: [
        BsacModelListFilterService
    ], imports: [[
            CommonModule,
            BsacGeoModule,
            BsacFormsModule,
            ReactiveFormsModule,
            NgbTypeaheadModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListFilterModule, { declarations: function () { return [BsacModelListAutocompleteFilterComponent, BsacModelListMetaFilterComponent, BsacModelListSelectFilterComponent, BsacModelListTextFilterComponent, BsacModelListValueFilterComponent, BsacModelListFlagsFilterComponent, BsacModelListGeodistanceFilterComponent, BsacModelListMultiselectFilterComponent, BsacModelListMultiautocompleteFilterComponent, BsacModelListDatetimeFilterComponent, BsacModelListDatetimerangeFilterComponent]; }, imports: function () { return [CommonModule, BsacGeoModule, BsacFormsModule, ReactiveFormsModule,
        NgbTypeaheadModule]; }, exports: function () { return [BsacModelListAutocompleteFilterComponent, BsacModelListMetaFilterComponent, BsacModelListSelectFilterComponent, BsacModelListTextFilterComponent, BsacModelListValueFilterComponent, BsacModelListFlagsFilterComponent, BsacModelListGeodistanceFilterComponent, BsacModelListMultiselectFilterComponent, BsacModelListMultiautocompleteFilterComponent, BsacModelListDatetimeFilterComponent, BsacModelListDatetimerangeFilterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFilterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    BsacGeoModule,
                    BsacFormsModule,
                    ReactiveFormsModule,
                    NgbTypeaheadModule
                ],
                providers: [
                    BsacModelListFilterService
                ],
                declarations: [
                    BsacModelListAutocompleteFilterComponent,
                    BsacModelListMetaFilterComponent,
                    BsacModelListSelectFilterComponent,
                    BsacModelListTextFilterComponent,
                    BsacModelListValueFilterComponent,
                    BsacModelListFlagsFilterComponent,
                    BsacModelListGeodistanceFilterComponent,
                    BsacModelListMultiselectFilterComponent,
                    BsacModelListMultiautocompleteFilterComponent,
                    BsacModelListDatetimeFilterComponent,
                    BsacModelListDatetimerangeFilterComponent
                ],
                exports: [
                    BsacModelListAutocompleteFilterComponent,
                    BsacModelListMetaFilterComponent,
                    BsacModelListSelectFilterComponent,
                    BsacModelListTextFilterComponent,
                    BsacModelListValueFilterComponent,
                    BsacModelListFlagsFilterComponent,
                    BsacModelListGeodistanceFilterComponent,
                    BsacModelListMultiselectFilterComponent,
                    BsacModelListMultiautocompleteFilterComponent,
                    BsacModelListDatetimeFilterComponent,
                    BsacModelListDatetimerangeFilterComponent
                ]
            }]
    }], null, null); })();

/**
 * ModelListSorter component.
 * Add / remove / change sort order.
 */
class BsacModelListSorterComponent {
    constructor() {
        this.update = true; // Update list after change
    }
    isUp() {
        const f = this.list.sorter.get(this.field);
        if (f) {
            return f.direction === "asc";
        }
        return false;
    }
    isDown() {
        const f = this.list.sorter.get(this.field);
        if (f) {
            return f.direction === "desc";
        }
        return false;
    }
    setUp() {
        this.list.sorter.set(this.field, "asc");
        this.list.queryset.sort(this.list.sorter.getAll());
    }
    setDown() {
        this.list.sorter.set(this.field, "desc");
    }
    getCount() {
        return this.list.sorter.getAll().length;
    }
    getOrder() {
        return this.list.sorter.getOrder(this.field);
    }
    cancel() {
        this.list.sorter.unset(this.field);
    }
}
BsacModelListSorterComponent.ɵfac = function BsacModelListSorterComponent_Factory(t) { return new (t || BsacModelListSorterComponent)(); };
BsacModelListSorterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListSorterComponent, selectors: [["bsac-model-list-sorter"]], inputs: { update: "update", list: "list", field: "field" }, ngContentSelectors: _c4, decls: 7, vars: 6, consts: [[1, "dirs"], ["class", "tag tag-default", 3, "click", 4, "ngIf"], ["class", "fa fa-times pointer", 3, "click", 4, "ngIf"], [1, "fa", "fa-chevron-up", "pointer", 3, "click"], [1, "fa", "fa-chevron-down", "pointer", 3, "click"], [1, "tag", "tag-default", 3, "click"], [1, "fa", "fa-times", "pointer", 3, "click"]], template: function BsacModelListSorterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, BsacModelListSorterComponent_span_1_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, BsacModelListSorterComponent_span_2_Template, 1, 0, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵlistener("click", function BsacModelListSorterComponent_Template_span_click_3_listener() { return ctx.setUp(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵlistener("click", function BsacModelListSorterComponent_Template_span_click_4_listener() { return ctx.setDown(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(5, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getCount() > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.getOrder() >= 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("active", ctx.isUp());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("active", ctx.isDown());
    } }, directives: [ɵngcc1.NgIf], styles: [".dirs[_ngcontent-%COMP%]{color:#d3d3d3}.active[_ngcontent-%COMP%]{color:#000}"] });
BsacModelListSorterComponent.propDecorators = {
    list: [{ type: Input }],
    update: [{ type: Input }],
    field: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSorterComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-sorter",
                template: "<span class=\"dirs\"><span class=\"tag tag-default\" *ngIf=\"getCount()&gt;1\" (click)=\"cancel()\">{{getOrder()}}</span><span class=\"fa fa-times pointer\" *ngIf=\"getOrder()&gt;=0\" (click)=\"cancel()\"></span><span class=\"fa fa-chevron-up pointer\" (click)=\"setUp()\" [class.active]=\"isUp()\"></span><span class=\"fa fa-chevron-down pointer\" (click)=\"setDown()\" [class.active]=\"isDown()\"></span>&nbsp;</span><ng-content></ng-content>",
                styles: [".dirs{color:#d3d3d3}.active{color:#000}"]
            }]
    }], function () { return []; }, { update: [{
            type: Input
        }], list: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class BsacModelListSorterModule {
}
BsacModelListSorterModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListSorterModule });
BsacModelListSorterModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListSorterModule_Factory(t) { return new (t || BsacModelListSorterModule)(); }, providers: [BsacModelListSorterService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListSorterModule, { declarations: function () { return [BsacModelListSorterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacModelListSorterComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSorterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                providers: [BsacModelListSorterService],
                declarations: [BsacModelListSorterComponent],
                exports: [BsacModelListSorterComponent]
            }]
    }], null, null); })();

class BsacModelListPaginatorComponent {
    constructor() {
        this.update = true;
        this.maxpages = 200;
        this.hide = false;
        this.paginationUpdate = new EventEmitter();
        this.perpageControl = new FormControl();
        this.showDirectAccess = false;
        this.directAccess = new FormControl();
        this.curpage = 1;
        this._unsubscribe = new Subject();
    }
    onPageChange(page) {
        if (!page) {
            return;
        }
        this.list.paginator.setPage(page);
        this.paginationUpdate.emit();
    }
    ngOnDestroy() {
        this._unsubscribe.next();
        this._unsubscribe.complete();
    }
    ngOnChanges() {
        if (this.list) {
            this.perpageControl.setValue(this.list.paginator.getPageSize(), { emitEvent: false });
            this.list.results.pipe(takeUntil(this._unsubscribe)).subscribe((results) => {
                const nav = results.pagination.nav;
                if (nav) {
                    this.results = results;
                    this.list.paginator.updatePage(nav.page || 1);
                    this.curpage = nav.page || 1;
                    this.curcount = nav.count;
                    this.list.paginator.setPageSize(nav.size);
                    this.pagesize = this.list.paginator.getPageSize();
                    this.perpageControl.setValue(this.pagesize, { emitEvent: false });
                }
            });
            this.perpageControl.valueChanges.pipe(takeUntil(this._unsubscribe)).subscribe((count) => {
                this.list.paginator.setPageSize(count);
                this.paginationUpdate.emit();
            });
            this.directAccess.valueChanges.pipe(takeUntil(this._unsubscribe), debounceTime(400)).subscribe((count) => {
                this.list.paginator.setPage(+count);
                this.paginationUpdate.emit();
            });
        }
    }
}
BsacModelListPaginatorComponent.ɵfac = function BsacModelListPaginatorComponent_Factory(t) { return new (t || BsacModelListPaginatorComponent)(); };
BsacModelListPaginatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListPaginatorComponent, selectors: [["bsac-model-list-paginator"]], inputs: { update: "update", maxpages: "maxpages", hide: "hide", list: "list" }, outputs: { paginationUpdate: "paginationUpdate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "row bsac-paginator", 4, "ngIf"], [1, "row", "bsac-paginator"], [1, "col-sm-4"], [1, "form-control", "perpage", 3, "formControl"], ["value", "10", 4, "ngIf"], ["value", "20", 4, "ngIf"], ["value", "50", 4, "ngIf"], ["value", "100", 4, "ngIf"], ["value", "200", 4, "ngIf"], ["value", "500", 4, "ngIf"], ["value", "1000", 4, "ngIf"], ["value", "2000", 4, "ngIf"], ["value", "5000", 4, "ngIf"], ["value", "10000", 4, "ngIf"], ["class", "col-sm-5 pagination", 4, "ngIf"], [1, "col-sm-3", "results"], [1, "pointer", 3, "click"], [4, "ngIf"], ["value", "10"], ["value", "20"], ["value", "50"], ["value", "100"], ["value", "200"], ["value", "500"], ["value", "1000"], ["value", "2000"], ["value", "5000"], ["value", "10000"], [1, "col-sm-5", "pagination"], [1, "text-xs-center"], [3, "pageSize", "collectionSize", "page", "maxSize", "rotate", "pageChange"], ["type", "number", "placeholder", "Page number (direct)", 1, "form-control", 3, "formControl"]], template: function BsacModelListPaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacModelListPaginatorComponent_div_0_Template, 18, 14, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.curcount > ctx.pagesize && !ctx.hide);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.SelectControlValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlDirective, ɵngcc5.NgSelectOption, ɵngcc5.ɵangular_packages_forms_forms_x, ɵngcc4.NgbPagination, ɵngcc5.NumberValueAccessor, ɵngcc5.DefaultValueAccessor], styles: [""] });
BsacModelListPaginatorComponent.propDecorators = {
    update: [{ type: Input }],
    list: [{ type: Input }],
    maxpages: [{ type: Input }],
    hide: [{ type: Input }],
    paginationUpdate: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListPaginatorComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-paginator",
                template: "<div class=\"row bsac-paginator\" *ngIf=\"curcount&gt;pagesize &amp;&amp; !hide\"><div class=\"col-sm-4\"><select class=\"form-control perpage\" [formControl]=\"perpageControl\"><option value=\"10\" *ngIf=\"maxpages&gt;=10\">10 / page</option><option value=\"20\" *ngIf=\"maxpages&gt;=20\">20 / page</option><option value=\"50\" *ngIf=\"maxpages&gt;=50\">50 / page</option><option value=\"100\" *ngIf=\"maxpages&gt;=100\">100 / page</option><option value=\"200\" *ngIf=\"maxpages&gt;=200\">200 / page</option><option value=\"500\" *ngIf=\"maxpages&gt;=500\">500 / page</option><option value=\"1000\" *ngIf=\"maxpages&gt;=1000\">1000 / page</option><option value=\"2000\" *ngIf=\"maxpages&gt;=2000\">2000 / page</option><option value=\"5000\" *ngIf=\"maxpages&gt;=5000\">5000 / page</option><option value=\"10000\" *ngIf=\"maxpages&gt;=10000\">10000 / page</option></select></div><div class=\"col-sm-5 pagination\" *ngIf=\"list\"><div class=\"text-xs-center\"><ngb-pagination [pageSize]=\"pagesize\" [collectionSize]=\"curcount\" [page]=\"curpage\" (pageChange)=\"onPageChange($event)\" [maxSize]=\"5\" [rotate]=\"true\"></ngb-pagination></div></div><div class=\"col-sm-3 results\"><p class=\"pointer\" (click)=\"showDirectAccess=!showDirectAccess\">{{curcount}} r\u00E9sultats</p><div *ngIf=\"showDirectAccess\"><input class=\"form-control\" [formControl]=\"directAccess\" type=\"number\" placeholder=\"Page number (direct)\"/></div></div></div>",
                styles: [""]
            }]
    }], function () { return []; }, { update: [{
            type: Input
        }], maxpages: [{
            type: Input
        }], hide: [{
            type: Input
        }], paginationUpdate: [{
            type: Output
        }], list: [{
            type: Input
        }] }); })();

class BsacModelListPaginatorModule {
}
BsacModelListPaginatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListPaginatorModule });
BsacModelListPaginatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListPaginatorModule_Factory(t) { return new (t || BsacModelListPaginatorModule)(); }, providers: [BsacModelListPaginatorService], imports: [[
            CommonModule,
            ReactiveFormsModule,
            NgbPaginationModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListPaginatorModule, { declarations: function () { return [BsacModelListPaginatorComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule,
        NgbPaginationModule]; }, exports: function () { return [BsacModelListPaginatorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListPaginatorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    NgbPaginationModule
                ],
                providers: [BsacModelListPaginatorService],
                declarations: [BsacModelListPaginatorComponent],
                exports: [BsacModelListPaginatorComponent]
            }]
    }], null, null); })();

class ModelListFieldsSelectComponent {
    constructor(_modal) {
        this._modal = _modal;
        this.enabled = [];
        this.disabled = [];
        this.search = new FormGroup({
            enabled: new FormControl(""),
            disabled: new FormControl("")
        });
    }
    get fenabled() {
        if (this.search.value.enabled === "") {
            return this.enabled;
        }
        const out = [];
        for (const f of this.enabled) {
            if (f.verbose_name.indexOf(this.search.value.enabled) !== -1) {
                out.push(f);
            }
        }
        return out;
    }
    get fdisabled() {
        if (this.search.value.disabled === "") {
            return this.disabled;
        }
        const out = [];
        for (const f of this.disabled) {
            if (f.verbose_name.indexOf(this.search.value.disabled) !== -1) {
                out.push(f);
            }
        }
        return out;
    }
    ngOnChanges(changes) {
        console.log("fen", this.search.value.enabled);
        if (!this.fields && this.list) {
            this.fields = this.list.fields;
            this.enabled = [];
            this.disabled = [];
            for (const f of this.fields.allowed) {
                if (f.enabled) {
                    this.enabled.push(f);
                }
                else {
                    this.disabled.push(f);
                }
            }
        }
    }
    open(element) {
        this.modal = this._modal.open(element, { size: "lg" });
    }
    enable(f) {
        this.fields.enable(f.name, this.fields.enabled.length);
    }
    disable(f) {
        this.fields.disable(f.name);
    }
    drop(event) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
        this.search.setValue(this.search.value, { emitEvent: true });
    }
    save() {
        for (const f of this.disabled) {
            if (f.enabled) {
                this.fields.disable(f.name);
            }
        }
        let pos = 0;
        for (const f of this.enabled) {
            this.fields.enable(f.name, pos);
            pos += 10;
        }
        this.modal.close();
    }
    cancel() {
        this.modal.close();
    }
}
ModelListFieldsSelectComponent.ɵfac = function ModelListFieldsSelectComponent_Factory(t) { return new (t || ModelListFieldsSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal)); };
ModelListFieldsSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ModelListFieldsSelectComponent, selectors: [["bsac-model-list-fields-select"]], inputs: { fields: "fields", list: "list" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c4, decls: 3, vars: 1, consts: [["content", ""], ["class", "form-group", 4, "ngIf"], [1, "modal-header"], [1, "modal-title"], ["type", "button", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "text-info"], [3, "formGroup"], [1, "row"], [1, "col-6"], ["placeholder", "Filtrer les colonnes masqu\u00E9es", "type", "text", "formControlName", "disabled", 1, "form-control", "mb-2"], [1, "card"], ["cdkDropList", "", 1, "list-group", "list-group-flush", 3, "cdkDropListData", "cdkDropListConnectedTo", "cdkDropListDropped"], ["disabledList", "cdkDropList"], ["class", "list-group-item", "cdkDrag", "", 4, "ngFor", "ngForOf"], ["placeholder", "Filtrer les colonnes affich\u00E9es", "type", "text", "formControlName", "enabled", 1, "form-control", "mb-2"], ["cdkDropList", "", 1, "list-group", 3, "cdkDropListData", "cdkDropListConnectedTo", "cdkDropListDropped"], ["enabledList", "cdkDropList"], [1, "modal-footer"], [1, "btn", "btn-primary", 3, "click"], [1, "btn", "btn-outline-secondary", 3, "click"], ["cdkDrag", "", 1, "list-group-item"], [1, "form-group"], ["id", "fieldsSelect", 1, "btn", "btn-outline-dark", "btn-block", 3, "click"]], template: function ModelListFieldsSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, ModelListFieldsSelectComponent_ng_template_0_Template, 27, 11, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, ModelListFieldsSelectComponent_div_2_Template, 5, 0, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fields);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.ɵangular_packages_forms_forms_y, ɵngcc5.NgControlStatusGroup, ɵngcc5.FormGroupDirective, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.FormControlName, ɵngcc8.CdkDropList, ɵngcc1.NgForOf, ɵngcc8.CdkDrag], styles: [".card[_ngcontent-%COMP%]{max-height:75vh;overflow:auto}.card[_ngcontent-%COMP%], .list-group[_ngcontent-%COMP%]{min-height:60px}.list-group-item[_ngcontent-%COMP%]{cursor:move}.cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);z-index:1250!important}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:.1;background-color:#d3d3d3}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box[_ngcontent-%COMP%]:last-child{border:none}.example-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   .example-box[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}"] });
ModelListFieldsSelectComponent.ctorParameters = () => [
    { type: NgbModal }
];
ModelListFieldsSelectComponent.propDecorators = {
    list: [{ type: Input }],
    fields: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModelListFieldsSelectComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-fields-select",
                template: "<!DOCTYPE html><ng-template #content let-modal><div class=\"modal-header\"><h4 class=\"modal-title\">S\u00E9lection des colonnes</h4><button class=\"close\" type=\"button\" (click)=\"modal.dismiss('x')\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body\"><p class=\"text-info\">Glissez, d\u00E9placez et/ou r\u00E9ordonnez les colonnes que vous voulez afficher</p><form [formGroup]=\"search\"><div class=\"row\"><div class=\"col-6\"><input class=\"form-control mb-2\" placeholder=\"Filtrer les colonnes masqu\u00E9es\" type=\"text\" formControlName=\"disabled\"><div class=\"card\"><ul class=\"list-group list-group-flush\" cdkDropList #disabledList=\"cdkDropList\" [cdkDropListData]=\"disabled\" [cdkDropListConnectedTo]=\"[enabledList]\" (cdkDropListDropped)=\"drop($event)\"><ul class=\"list-group-item\" *ngFor=\"let f of fdisabled\" cdkDrag>{{f.verbose_name}}</ul></ul></div></div><div class=\"col-6\"><input class=\"form-control mb-2\" placeholder=\"Filtrer les colonnes affich\u00E9es\" type=\"text\" formControlName=\"enabled\"><ul class=\"list-group\" cdkDropList #enabledList=\"cdkDropList\" [cdkDropListData]=\"enabled\" [cdkDropListConnectedTo]=\"[disabledList]\" (cdkDropListDropped)=\"drop($event)\"><div class=\"list-group-item\" *ngFor=\"let f of fenabled\" cdkDrag>{{f.verbose_name}}</div></ul></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" (click)=\"save()\">Enregistrer</button><button class=\"btn btn-outline-secondary\" (click)=\"cancel()\">Annuler</button></div></ng-template><div class=\"form-group\" *ngIf=\"fields\"><label><ng-content></ng-content><button class=\"btn btn-outline-dark btn-block\" id=\"fieldsSelect\" (click)=\"open(content)\">S\u00E9lectionner une colonne</button></label></div>",
                styles: [".card{max-height:75vh;overflow:auto}.card,.list-group{min-height:60px}.list-group-item{cursor:move}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);z-index:1250!important}.cdk-drag-placeholder{opacity:.1;background-color:#d3d3d3}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box:last-child{border:none}.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgbModal }]; }, { fields: [{
            type: Input
        }], list: [{
            type: Input
        }] }); })();

class BsacModelListFieldsModule {
}
BsacModelListFieldsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListFieldsModule });
BsacModelListFieldsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListFieldsModule_Factory(t) { return new (t || BsacModelListFieldsModule)(); }, imports: [[
            CommonModule,
            NgbModalModule,
            DragDropModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListFieldsModule, { declarations: function () { return [ModelListFieldsSelectComponent]; }, imports: function () { return [CommonModule,
        NgbModalModule,
        DragDropModule,
        FormsModule,
        ReactiveFormsModule]; }, exports: function () { return [ModelListFieldsSelectComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFieldsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgbModalModule,
                    DragDropModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                declarations: [ModelListFieldsSelectComponent],
                exports: [ModelListFieldsSelectComponent]
            }]
    }], null, null); })();

class BsacFilterSetService {
    constructor() {
        this._childs = [];
        this._groups = [];
        this._subscription = new Subject();
        this._loaded = false;
        this._canload = false;
    }
    registerField(name, description, group, view, tpl) {
        this._childs.push({ name, description, group, view, tpl });
    }
    registerGroup(name, description, view, tpl) {
        this._groups.push({ name, description });
    }
    onChanges(list, placeholder, changeDetectionRef) {
        if (list) {
            for (const ch of this._childs) {
                list.filter.registerField(ch.name, ch.description, ch.group);
            }
            for (const gr of this._groups) {
                list.filter.registerGroup(gr.name, gr.description);
            }
            if (this._canload && !this._loaded) {
                this.enableFilters(list, placeholder, changeDetectionRef);
            }
        }
    }
    onDestroy() {
        this._subscription.next();
        this._subscription.complete();
    }
    afterViewInit(list, placeholder, changeDetectionRef) {
        this._canload = true;
        if (list) {
            if (!this._loaded) {
                this.enableFilters(list, placeholder, changeDetectionRef);
            }
        }
    }
    enableFilters(list, placeholder, changeDetectionRef) {
        this._loaded = true;
        list.filter.enabled$
            .pipe(takeUntil(this._subscription)).subscribe((enabled) => {
            const vl = placeholder.length;
            // Detach all filters
            for (let v = vl - 1; v >= 0; v--) {
                placeholder.detach(v);
            }
            // Mark all filters as non active
            for (const c of this._childs) {
                c.active = false;
            }
            // Add filters and mark them as active following filter order
            for (const e of enabled) {
                for (const c of this._childs) {
                    if (c.name === e) {
                        c.active = true;
                        if (c.viewref) {
                            // c.viewref._view.nodes[1].instance.filtersetName = c.name;
                            placeholder.insert(c.viewref);
                        }
                        else {
                            c.viewref = placeholder.createEmbeddedView(c.tpl);
                            // c.viewref._view.nodes[1].instance.filtersetName = c.name;
                        }
                    }
                }
            }
            // });
        });
        changeDetectionRef.detectChanges();
    }
}
BsacFilterSetService.ɵfac = function BsacFilterSetService_Factory(t) { return new (t || BsacFilterSetService)(); };
BsacFilterSetService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacFilterSetService, factory: BsacFilterSetService.ɵfac });
BsacFilterSetService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFilterSetService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class BsacFilterSetItemDirective {
    constructor(viewContainerRef, templateRef, filterSet) {
        this.viewContainerRef = viewContainerRef;
        this.templateRef = templateRef;
        this.filterSet = filterSet;
        this._value = "";
        this._desc = "";
        this._group = "";
    }
    set bsacFilterSetItem(value) {
        this._value = value;
    }
    set bsacFilterSetItemDesc(value) {
        this._desc = value;
    }
    set bsacFilterSetItemGroup(value) {
        this._group = value;
    }
    ngOnInit() {
        this.filterSet.registerField(this._value, this._desc, this._group, this.viewContainerRef, this.templateRef);
    }
}
BsacFilterSetItemDirective.ɵfac = function BsacFilterSetItemDirective_Factory(t) { return new (t || BsacFilterSetItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(BsacFilterSetService)); };
BsacFilterSetItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BsacFilterSetItemDirective, selectors: [["", "bsacFilterSetItem", ""]], inputs: { bsacFilterSetItem: "bsacFilterSetItem", bsacFilterSetItemDesc: "bsacFilterSetItemDesc", bsacFilterSetItemGroup: "bsacFilterSetItemGroup" } });
BsacFilterSetItemDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: BsacFilterSetService }
];
BsacFilterSetItemDirective.propDecorators = {
    bsacFilterSetItem: [{ type: Input }],
    bsacFilterSetItemDesc: [{ type: Input }],
    bsacFilterSetItemGroup: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFilterSetItemDirective, [{
        type: Directive,
        args: [{
                selector: "[bsacFilterSetItem]"
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: BsacFilterSetService }]; }, { bsacFilterSetItem: [{
            type: Input
        }], bsacFilterSetItemDesc: [{
            type: Input
        }], bsacFilterSetItemGroup: [{
            type: Input
        }] }); })();

class BsacFilterSetComponent {
    constructor(_srvc, _changeDetectionRef) {
        this._srvc = _srvc;
        this._changeDetectionRef = _changeDetectionRef;
    }
    registerField(name, description, group, view, tpl) {
        console.error("Use service instead");
        this._srvc.registerField(name, description, group, view, tpl);
    }
    registerGroup(name, description, view, tpl) {
        console.error("Use service instead");
        this._srvc.registerGroup(name, description, view, tpl);
    }
    ngOnChanges() {
        this._srvc.onChanges(this.list, this.placeholder, this._changeDetectionRef);
    }
    ngOnDestroy() {
        this._srvc.onDestroy();
    }
    ngAfterViewInit() {
        this._srvc.afterViewInit(this.list, this.placeholder, this._changeDetectionRef);
    }
    enableFilters() {
        console.error("Use service instead");
        this._srvc.enableFilters(this.list, this.placeholder, this._changeDetectionRef);
    }
}
BsacFilterSetComponent.ɵfac = function BsacFilterSetComponent_Factory(t) { return new (t || BsacFilterSetComponent)(ɵngcc0.ɵɵdirectiveInject(BsacFilterSetService, 2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BsacFilterSetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacFilterSetComponent, selectors: [["bsac-filter-set"]], viewQuery: function BsacFilterSetComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 3, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.placeholder = _t.first);
    } }, inputs: { list: "list" }, features: [ɵngcc0.ɵɵProvidersFeature([BsacFilterSetService]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["data", ""]], template: function BsacFilterSetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, null, 0);
    } }, encapsulation: 2 });
BsacFilterSetComponent.ctorParameters = () => [
    { type: BsacFilterSetService, decorators: [{ type: Self }] },
    { type: ChangeDetectorRef }
];
BsacFilterSetComponent.propDecorators = {
    placeholder: [{ type: ViewChild, args: ["data", { read: ViewContainerRef, static: true },] }],
    list: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFilterSetComponent, [{
        type: Component,
        args: [{
                selector: "bsac-filter-set",
                template: "<ng-container #data></ng-container>",
                providers: [BsacFilterSetService]
            }]
    }], function () { return [{ type: BsacFilterSetService, decorators: [{
                type: Self
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { placeholder: [{
            type: ViewChild,
            args: ["data", { read: ViewContainerRef, static: true }]
        }], list: [{
            type: Input
        }] }); })();

class BsacModelListFiltersetSelectComponent {
    constructor() {
        this._subscription = new Subject();
    }
    ngOnChanges(changes) {
        if (this.list) {
            this.list.filter.enabled$.pipe(takeUntil(this._subscription)).subscribe(() => {
                this.fg = this.fieldGroups;
            });
        }
    }
    ngOnDestroy() {
        this._subscription.next();
        this._subscription.complete();
    }
    get fieldGroups() {
        const out = [];
        for (const grr of this.list.filter.registeredGroups) {
            const gr = { name: grr.name, title: grr.description, fields: [] };
            for (const fn of this.list.filter.registeredFields) {
                if (fn.group === gr.name) {
                    if (!(this.list.filter.filters[fn.name] && this.list.filter.filters[fn.name].disabled)) {
                        gr.fields.push({ name: fn.name, description: fn.description });
                    }
                }
            }
            if (gr.fields.length > 0) {
                out.push(gr);
            }
        }
        return out;
    }
    addFilter(f, v) {
        if (v) {
            this.list.filter.toggle(v);
        }
    }
}
BsacModelListFiltersetSelectComponent.ɵfac = function BsacModelListFiltersetSelectComponent_Factory(t) { return new (t || BsacModelListFiltersetSelectComponent)(); };
BsacModelListFiltersetSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListFiltersetSelectComponent, selectors: [["bsac-model-list-filterset-select"]], inputs: { list: "list" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "form-group", 4, "ngIf"], [1, "form-group"], [1, "form-control", 3, "change"], ["crit", ""], ["value", ""], [4, "ngFor", "ngForOf"], [3, "label", 4, "ngIf"], [3, "label"], [3, "value"]], template: function BsacModelListFiltersetSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacModelListFiltersetSelectComponent_div_0_Template, 8, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.fg);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], styles: [""] });
BsacModelListFiltersetSelectComponent.ctorParameters = () => [];
BsacModelListFiltersetSelectComponent.propDecorators = {
    list: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFiltersetSelectComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-filterset-select",
                template: "<!DOCTYPE html><div class=\"form-group\" *ngIf=\"fg\"><label>Ajouter un filtre</label><select class=\"form-control\" #crit (change)=\"addFilter($event, crit.value)\"><option value=\"\">S\u00E9lectionnez un filtre</option><ng-container *ngFor=\"let g of fg\"><optgroup [label]=\"g.title\" *ngIf=\"g.fields.length &gt; 0\"><ng-container *ngFor=\"let f of g.fields\"><option [value]=\"f.name\">{{f.description}}</option></ng-container></optgroup></ng-container></select></div>",
                styles: [""]
            }]
    }], function () { return []; }, { list: [{
            type: Input
        }] }); })();

class BsacFilterSetGroupDirective {
    constructor(viewContainerRef, templateRef, filterSet) {
        this.viewContainerRef = viewContainerRef;
        this.templateRef = templateRef;
        this.filterSet = filterSet;
    }
    set bsacFilterSetGroup(value) {
        this._value = value;
    }
    set bsacFilterSetGroupDesc(value) {
        this._desc = value;
    }
    ngOnInit() {
        this.filterSet.registerGroup(this._value, this._desc, this.viewContainerRef, this.templateRef);
    }
}
BsacFilterSetGroupDirective.ɵfac = function BsacFilterSetGroupDirective_Factory(t) { return new (t || BsacFilterSetGroupDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(BsacFilterSetService)); };
BsacFilterSetGroupDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BsacFilterSetGroupDirective, selectors: [["", "bsacFilterSetGroup", ""]], inputs: { bsacFilterSetGroup: "bsacFilterSetGroup", bsacFilterSetGroupDesc: "bsacFilterSetGroupDesc" } });
BsacFilterSetGroupDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: BsacFilterSetService }
];
BsacFilterSetGroupDirective.propDecorators = {
    bsacFilterSetGroup: [{ type: Input }],
    bsacFilterSetGroupDesc: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacFilterSetGroupDirective, [{
        type: Directive,
        args: [{
                selector: "[bsacFilterSetGroup]"
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: BsacFilterSetService }]; }, { bsacFilterSetGroup: [{
            type: Input
        }], bsacFilterSetGroupDesc: [{
            type: Input
        }] }); })();

class BsacModelListFiltersetModule {
}
BsacModelListFiltersetModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListFiltersetModule });
BsacModelListFiltersetModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListFiltersetModule_Factory(t) { return new (t || BsacModelListFiltersetModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListFiltersetModule, { declarations: function () { return [BsacFilterSetComponent, BsacFilterSetItemDirective, BsacModelListFiltersetSelectComponent, BsacFilterSetGroupDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacFilterSetComponent, BsacFilterSetItemDirective, BsacModelListFiltersetSelectComponent, BsacFilterSetGroupDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListFiltersetModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BsacFilterSetComponent,
                    BsacFilterSetItemDirective,
                    BsacModelListFiltersetSelectComponent,
                    BsacFilterSetGroupDirective
                ], exports: [
                    BsacFilterSetComponent,
                    BsacFilterSetItemDirective,
                    BsacModelListFiltersetSelectComponent,
                    BsacFilterSetGroupDirective
                ]
            }]
    }], null, null); })();

class BsacModelListPersistenceSaveComponent {
    constructor(_modal) {
        this._modal = _modal;
        this.btnClasses = [];
        this.saved = [];
        this.fileName = "";
    }
    open(content) {
        this.list.saved().subscribe((saved) => {
            this.saved = saved;
        });
        this._modal.open(content).result.then((result) => {
            this.list.save(this.fileName).subscribe(() => {
            });
        }, (reason) => {
        });
    }
}
BsacModelListPersistenceSaveComponent.ɵfac = function BsacModelListPersistenceSaveComponent_Factory(t) { return new (t || BsacModelListPersistenceSaveComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal)); };
BsacModelListPersistenceSaveComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListPersistenceSaveComponent, selectors: [["bsac-model-list-persistence-save"]], inputs: { btnClasses: "btnClasses", list: "list" }, ngContentSelectors: _c4, decls: 4, vars: 1, consts: [["content", ""], [3, "ngClass", "click"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], ["placeholder", "Nom pour l'enregistrement", 1, "form-control", 3, "ngModel", "ngModelChange", "keyup.enter"], [1, "text-danger"], [1, "list-group"], ["class", "list-group-item list-group-item-action pointer", 3, "click", 4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-outline-dark", 3, "click"], [1, "list-group-item", "list-group-item-action", "pointer", 3, "click"]], template: function BsacModelListPersistenceSaveComponent_Template(rf, ctx) { if (rf & 1) {
        const _r14 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BsacModelListPersistenceSaveComponent_ng_template_0_Template, 16, 2, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceSaveComponent_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); const _r0 = ɵngcc0.ɵɵreference(1); return ctx.open(_r0); });
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.btnClasses);
    } }, directives: [ɵngcc1.NgClass, ɵngcc5.DefaultValueAccessor, ɵngcc5.NgControlStatus, ɵngcc5.NgModel, ɵngcc1.NgForOf], styles: [""] });
BsacModelListPersistenceSaveComponent.ctorParameters = () => [
    { type: NgbModal }
];
BsacModelListPersistenceSaveComponent.propDecorators = {
    list: [{ type: Input }],
    btnClasses: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListPersistenceSaveComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-persistence-save",
                template: "<!DOCTYPE html><ng-template #content let-c=\"close\" let-d=\"dismiss\"><div class=\"modal-header\"><h4 class=\"modal-title\">Enregistrer un jeu de filtres</h4><button class=\"close\" type=\"button\" aria-label=\"close\" (click)=\"d('cross')\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body\"><input class=\"form-control\" [(ngModel)]=\"fileName\" placeholder=\"Nom pour l'enregistrement\" (keyup.enter)=\"c('enter')\"><hr><p class=\"text-danger\">Overwrite existing ?</p><ul class=\"list-group\"><li class=\"list-group-item list-group-item-action pointer\" *ngFor=\"let s of saved\" (click)=\"fileName=s.key; c('select')\">{{s.key}}</li></ul></div><div class=\"modal-footer\"><button class=\"btn btn-outline-dark\" (click)=\"c('close')\" type=\"button\">Enregistrer</button></div></ng-template><div (click)=\"open(content)\" [ngClass]=\"btnClasses\"><ng-content></ng-content></div>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc4.NgbModal }]; }, { btnClasses: [{
            type: Input
        }], list: [{
            type: Input
        }] }); })();

class BsacModelListPersistenceLoadComponent {
    constructor(_modal) {
        this._modal = _modal;
        this.btnClasses = [];
        this.saved = [];
        this.fileName = "";
    }
    open(content) {
        this.list.saved().subscribe((saved) => {
            this.saved = saved;
        });
        this._modal.open(content).result.then((result) => {
            this.list.load(this.fileName).subscribe(() => {
            });
        }, (reason) => {
        });
    }
}
BsacModelListPersistenceLoadComponent.ɵfac = function BsacModelListPersistenceLoadComponent_Factory(t) { return new (t || BsacModelListPersistenceLoadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgbModal)); };
BsacModelListPersistenceLoadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListPersistenceLoadComponent, selectors: [["bsac-model-list-persistence-load"]], inputs: { btnClasses: "btnClasses", list: "list" }, ngContentSelectors: _c4, decls: 4, vars: 1, consts: [["content", ""], [3, "ngClass", "click"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "aria-label", "close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "text-danger"], [1, "list-group"], ["class", "list-group-item list-group-item-action pointer", 3, "click", 4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-outline-primary", 3, "click"], ["type", "button", 1, "btn", "btn-outline-dark", 3, "click"], [1, "list-group-item", "list-group-item-action", "pointer", 3, "click"]], template: function BsacModelListPersistenceLoadComponent_Template(rf, ctx) { if (rf & 1) {
        const _r12 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, BsacModelListPersistenceLoadComponent_ng_template_0_Template, 16, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵlistener("click", function BsacModelListPersistenceLoadComponent_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r12); const _r0 = ɵngcc0.ɵɵreference(1); return ctx.open(_r0); });
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.btnClasses);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgForOf], styles: [""] });
BsacModelListPersistenceLoadComponent.ctorParameters = () => [
    { type: NgbModal }
];
BsacModelListPersistenceLoadComponent.propDecorators = {
    list: [{ type: Input }],
    btnClasses: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListPersistenceLoadComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-persistence-load",
                template: "<!DOCTYPE html><ng-template #content let-c=\"close\" let-d=\"dismiss\"><div class=\"modal-header\"><h4 class=\"modal-title\">Charger un jeu de filtres</h4><button class=\"close\" type=\"button\" aria-label=\"close\" (click)=\"d('cross')\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body\"><p class=\"text-danger\">Jeux de filtres \u00E0 charger</p><ul class=\"list-group\"><li class=\"list-group-item list-group-item-action pointer\" *ngFor=\"let s of saved\" (click)=\"fileName=s.key; c('select')\">{{s.key}}</li></ul></div><div class=\"modal-footer\"><button class=\"btn btn-outline-primary\" (click)=\"c('close')\" type=\"button\">Charger</button><button class=\"btn btn-outline-dark\" (click)=\"d('cancel')\" type=\"button\">Annuler</button></div></ng-template><div (click)=\"open(content)\" [ngClass]=\"btnClasses\"><ng-content></ng-content></div>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc4.NgbModal }]; }, { btnClasses: [{
            type: Input
        }], list: [{
            type: Input
        }] }); })();

class BsacModelListPersistenceModule {
}
BsacModelListPersistenceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListPersistenceModule });
BsacModelListPersistenceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListPersistenceModule_Factory(t) { return new (t || BsacModelListPersistenceModule)(); }, imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListPersistenceModule, { declarations: function () { return [BsacModelListPersistenceSaveComponent, BsacModelListPersistenceLoadComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [BsacModelListPersistenceSaveComponent, BsacModelListPersistenceLoadComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListPersistenceModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    BsacModelListPersistenceSaveComponent,
                    BsacModelListPersistenceLoadComponent
                ],
                exports: [
                    BsacModelListPersistenceSaveComponent,
                    BsacModelListPersistenceLoadComponent
                ]
            }]
    }], null, null); })();

class BsacModelListDisplayComponent {
    constructor() {
        this.mode = "vertical";
        this.collapse1 = true;
    }
    ngOnInit() {
    }
}
BsacModelListDisplayComponent.ɵfac = function BsacModelListDisplayComponent_Factory(t) { return new (t || BsacModelListDisplayComponent)(); };
BsacModelListDisplayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListDisplayComponent, selectors: [["bsac-modellist-display"]], inputs: { mode: "mode" }, ngContentSelectors: _c10, decls: 16, vars: 4, consts: [["listCurrentFilters", ""], ["listSelectFilters", ""], ["listSelectColumns", ""], ["listPersistence", ""], ["listResults", ""], ["listPagination", ""], ["class", "row modellist-vertical", 4, "ngIf"], ["class", "row modellist-horizontal", 4, "ngIf"], ["class", "row modellist-light", 4, "ngIf"], ["class", "row modellist-xlight", 4, "ngIf"], [1, "row", "modellist-vertical"], [1, "col-3", "left-filters"], [4, "ngTemplateOutlet"], [1, "col-9"], [1, "row"], [1, "col-sm-6"], [1, "col-12"], [1, "row", "modellist-horizontal"], [1, "row", "filter-management"], [1, "col-4"], [1, "row", "modellist-light"], [1, "col-11"], [1, "col-1", "collapser"], [1, "btn", "btn-block", "btn-text", 3, "click"], [1, "fa", "fa-caret-down", "fa-2x"], [1, "col-12", 3, "ngbCollapse"], [1, "row", "modellist-xlight"], [1, "col-12", "collapser", 3, "click"]], template: function BsacModelListDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c9);
        ɵngcc0.ɵɵtemplate(0, BsacModelListDisplayComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, BsacModelListDisplayComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, BsacModelListDisplayComponent_ng_template_4_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, BsacModelListDisplayComponent_ng_template_6_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, BsacModelListDisplayComponent_ng_template_8_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, BsacModelListDisplayComponent_ng_template_10_Template, 1, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, BsacModelListDisplayComponent_div_12_Template, 14, 6, "div", 6);
        ɵngcc0.ɵɵtemplate(13, BsacModelListDisplayComponent_div_13_Template, 15, 6, "div", 7);
        ɵngcc0.ɵɵtemplate(14, BsacModelListDisplayComponent_div_14_Template, 18, 7, "div", 8);
        ɵngcc0.ɵɵtemplate(15, BsacModelListDisplayComponent_div_15_Template, 16, 8, "div", 9);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(12);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "vertical");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "horizontal");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "light");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "xlight");
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc4.NgbCollapse], styles: [""] });
BsacModelListDisplayComponent.ctorParameters = () => [];
BsacModelListDisplayComponent.propDecorators = {
    mode: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListDisplayComponent, [{
        type: Component,
        args: [{
                selector: "bsac-modellist-display",
                template: "<!DOCTYPE html><ng-template #listCurrentFilters><ng-content select=\".list-current-filters\"></ng-content></ng-template><ng-template #listSelectFilters><ng-content select=\".list-select-filters\"></ng-content></ng-template><ng-template #listSelectColumns><ng-content select=\".list-select-columns\"></ng-content></ng-template><ng-template #listPersistence><ng-content select=\".list-persistence\"></ng-content></ng-template><ng-template #listResults><ng-content select=\".list-results\"></ng-content></ng-template><ng-template #listPagination><ng-content select=\".list-pagination\"></ng-content></ng-template><div class=\"row modellist-vertical\" *ngIf=\"mode=='vertical'\"><div class=\"col-3 left-filters\"><ng-container *ngTemplateOutlet=\"listCurrentFilters\"></ng-container><ng-container *ngTemplateOutlet=\"listSelectFilters\"></ng-container></div><div class=\"col-9\"><div class=\"row\"><div class=\"col-sm-6\"><ng-container *ngTemplateOutlet=\"listSelectColumns\"></ng-container></div><div class=\"col-sm-6\"><ng-container *ngTemplateOutlet=\"listPersistence\"></ng-container></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listResults\"></ng-container></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listPagination\"></ng-container></div></div></div></div><div class=\"row modellist-horizontal\" *ngIf=\"mode=='horizontal'\"><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listCurrentFilters\"></ng-container></div><div class=\"col-12\"><div class=\"row filter-management\"><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listSelectFilters\"></ng-container></div><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listSelectColumns\"></ng-container></div><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listPersistence\"></ng-container></div></div></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listResults\"></ng-container></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listPagination\"></ng-container></div></div><div class=\"row modellist-light\" *ngIf=\"mode=='light'\"><div class=\"col-11\"><ng-container *ngTemplateOutlet=\"listCurrentFilters\"></ng-container></div><div class=\"col-1 collapser\"><button class=\"btn btn-block btn-text\" (click)=\"collapse1=!collapse1\"><i class=\"fa fa-caret-down fa-2x\"></i></button></div><div class=\"col-12\" [ngbCollapse]=\"collapse1\"><div class=\"row filter-management\"><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listSelectFilters\"></ng-container></div><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listSelectColumns\"></ng-container></div><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listPersistence\"></ng-container></div></div></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listResults\"></ng-container></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listPagination\"></ng-container></div></div><div class=\"row modellist-xlight\" *ngIf=\"mode=='xlight'\"><div class=\"col-12 collapser\" (click)=\"collapse1=!collapse1\"></div><div class=\"col-12\" [ngbCollapse]=\"collapse1\"><ng-container *ngTemplateOutlet=\"listCurrentFilters\"></ng-container></div><div class=\"col-12\" [ngbCollapse]=\"collapse1\"><div class=\"row filter-management\"><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listSelectFilters\"></ng-container></div><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listSelectColumns\"></ng-container></div><div class=\"col-4\"><ng-container *ngTemplateOutlet=\"listPersistence\"></ng-container></div></div></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listResults\"></ng-container></div><div class=\"col-12\"><ng-container *ngTemplateOutlet=\"listPagination\"></ng-container></div></div>",
                styles: [""]
            }]
    }], function () { return []; }, { mode: [{
            type: Input
        }] }); })();

class BsacModelListSettingsEditorComponent {
    constructor() {
        this.settings = {
            key: "",
            opt: "",
            type: "modellistsettings",
            registered_fields: [],
            default_fields: [],
            allowed_fields: [],
            excluded_fields: [],
            registered_filters: [],
            default_filters: [],
            allowed_filters: [],
            excluded_filters: []
        };
    }
    ngOnInit() {
        this.settings.key = this.list.name;
        this.settings.opt = this.mode;
        // Fields
        this.settings.registered_fields = [];
        for (const f of this.list.fields.registered) {
            this.settings.registered_fields.push({ name: f.name, description: f.description });
        }
        this.settings.allowed_fields = this.list.fields.allowed_fields;
        this.settings.default_fields = this.list.fields.default_fields;
        this.settings.excluded_fields = this.list.fields.excluded_fields;
        // Filters
        this.settings.registered_filters = this.list.filter.registeredFields;
        this.settings.default_filters = this.list.filter.default_filters;
        this.settings.allowed_filters = this.list.filter.allowed_filters;
        this.settings.excluded_filters = this.list.filter.excluded_filters;
        this.fields = [];
        this.filters = [];
        for (const f of this.list.fields.registered) {
            const fs = { name: f.name, description: f.description, allowed: false, default: false, order: 0 };
            if (this.list.fields.default_fields.indexOf(f.name) !== -1) {
                fs.default = true;
                fs.allowed = true;
                fs.order = this.list.fields.default_fields.indexOf(f.name);
            }
            else if (this.list.fields.allowed_fields.indexOf(f.name) !== -1) {
                fs.allowed = true;
                fs.order = this.list.fields.allowed_fields.indexOf(f.name) + 1000;
            }
            else {
                fs.order = this.fields.length + 2000;
            }
            this.fields.push(fs);
        }
        this.fields = sortBy(this.fields, ["order"]);
        for (const f of this.list.filter.registeredFields) {
            const fs = { name: f.name, description: f.description, allowed: false, default: false, order: 0 };
            if (this.list.filter.default_filters.indexOf(f.name) !== -1) {
                fs.default = true;
                fs.allowed = true;
                fs.order = this.list.filter.default_filters.indexOf(f.name);
            }
            else if (this.list.filter.allowed_filters.indexOf(f.name) !== -1) {
                fs.allowed = true;
                fs.order = this.list.filter.allowed_filters.indexOf(f.name) + 1000;
            }
            else {
                fs.order = this.filters.length + 2000;
            }
            this.filters.push(fs);
        }
        this.filters = sortBy(this.filters, ["order"]);
    }
    upField(i) {
        const fs = this.fields[i];
        const fsn = this.fields[i - 1];
        if (fsn) {
            const o = fs.order;
            if (Math.round(fs.order / 1000) === Math.round(fsn.order / 1000)) {
                fs.order = fsn.order;
                fsn.order = o;
            }
        }
        this.fields = sortBy(this.fields, ["order"]);
    }
    downField(i) {
        const fs = this.fields[i];
        const fsn = this.fields[i + 1];
        if (fsn) {
            const o = fs.order;
            if (Math.round(fs.order / 1000) === Math.round(fsn.order / 1000)) {
                fs.order = fsn.order;
                fsn.order = o;
            }
        }
        this.fields = sortBy(this.fields, ["order"]);
    }
    defaultField(i) {
        const fs = this.fields[i];
        if (fs.default) {
            fs.default = false;
            fs.allowed = true;
            for (const f of this.fields) {
                if (f.order < 2000 && f.order > 1000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order < 1000) {
                fs.order = 1000;
            }
        }
        else {
            fs.default = true;
            fs.allowed = true;
            for (const f of this.fields) {
                if (f.order < 1000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order > 1000) {
                fs.order = 1;
            }
        }
        this.fields = sortBy(this.fields, ["order"]);
    }
    allowedField(i) {
        const fs = this.fields[i];
        if (fs.allowed) {
            fs.default = false;
            fs.allowed = false;
            for (const f of this.fields) {
                if (f.order > 2000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order < 2000) {
                fs.order = 2000;
            }
        }
        else {
            fs.default = false;
            fs.allowed = true;
            for (const f of this.fields) {
                if (f.order < 2000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order < 1000) {
                fs.order = 1000;
            }
        }
        this.fields = sortBy(this.fields, ["order"]);
    }
    upFilter(i) {
        const fs = this.filters[i];
        const fsn = this.filters[i - 1];
        if (fsn) {
            const o = fs.order;
            if (Math.round(fs.order / 1000) === Math.round(fsn.order / 1000)) {
                fs.order = fsn.order;
                fsn.order = o;
            }
        }
        this.filters = sortBy(this.filters, ["order"]);
    }
    downFilter(i) {
        const fs = this.filters[i];
        const fsn = this.filters[i + 1];
        if (fsn) {
            const o = fs.order;
            if (Math.round(fs.order / 1000) === Math.round(fsn.order / 1000)) {
                fs.order = fsn.order;
                fsn.order = o;
            }
        }
        this.filters = sortBy(this.filters, ["order"]);
    }
    defaultFilter(i) {
        const fs = this.filters[i];
        if (fs.default) {
            fs.default = false;
            fs.allowed = true;
            for (const f of this.filters) {
                if (f.order < 2000 && f.order > 1000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order < 1000) {
                fs.order = 1000;
            }
        }
        else {
            fs.default = true;
            fs.allowed = true;
            for (const f of this.filters) {
                if (f.order < 1000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order > 1000) {
                fs.order = 1;
            }
        }
        this.filters = sortBy(this.filters, ["order"]);
    }
    allowedFilter(i) {
        const fs = this.filters[i];
        if (fs.allowed) {
            fs.default = false;
            fs.allowed = false;
            for (const f of this.filters) {
                if (f.order > 2000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order < 2000) {
                fs.order = 2000;
            }
        }
        else {
            fs.default = false;
            fs.allowed = true;
            for (const f of this.filters) {
                if (f.order < 2000) {
                    fs.order = f.order + 1;
                }
            }
            if (fs.order < 1000) {
                fs.order = 1000;
            }
        }
        this.filters = sortBy(this.filters, ["order"]);
    }
    export() {
        const settings = {
            key: this.list.name,
            opt: this.mode,
            type: "modellistsettings",
            default_fields: [],
            allowed_fields: [],
            default_filters: [],
            allowed_filters: []
        };
        for (const f of this.fields) {
            if (f.default) {
                settings.default_fields.push(f.name);
                settings.allowed_fields.push(f.name);
            }
            else if (f.allowed) {
                settings.allowed_fields.push(f.name);
            }
        }
        for (const f of this.filters) {
            if (f.default) {
                settings.default_filters.push(f.name);
                settings.allowed_filters.push(f.name);
            }
            else if (f.allowed) {
                settings.allowed_filters.push(f.name);
            }
        }
        // Copy to clipboard
        const el = document.createElement("textarea");
        el.value = JSON.stringify(settings);
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        return settings;
    }
}
BsacModelListSettingsEditorComponent.ɵfac = function BsacModelListSettingsEditorComponent_Factory(t) { return new (t || BsacModelListSettingsEditorComponent)(); };
BsacModelListSettingsEditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacModelListSettingsEditorComponent, selectors: [["bsac-model-list-settings-editor"]], inputs: { list: "list", mode: "mode" }, decls: 52, vars: 4, consts: [[1, "row"], [1, "col-12"], [1, "col-sm-6"], [1, "table", "table-condensed", "table-bordered", "table-hover"], [3, "table-success", "table-primary", 4, "ngFor", "ngForOf"], [1, "btn", "btn-primary", "btn-block", 3, "click"], [1, "fa", "fa-save", "mr-2"], [1, "pointer", 3, "click"], ["class", "fa fa-check", 4, "ngIf"], [1, "fa", "fa-caret-up"], [1, "fa", "fa-caret-down"], [1, "fa", "fa-check"]], template: function BsacModelListSettingsEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h2");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "h3");
        ɵngcc0.ɵɵtext(6, "Fields");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "table", 3);
        ɵngcc0.ɵɵelementStart(8, "thead");
        ɵngcc0.ɵɵelementStart(9, "tr");
        ɵngcc0.ɵɵelementStart(10, "th");
        ɵngcc0.ɵɵtext(11, "Field");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "th");
        ɵngcc0.ɵɵtext(13, "Desc.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "th");
        ɵngcc0.ɵɵtext(15, "Default");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "th");
        ɵngcc0.ɵɵtext(17, "Allowed");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "th");
        ɵngcc0.ɵɵtext(19, "Order");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "th");
        ɵngcc0.ɵɵtext(21, "Up");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "th");
        ɵngcc0.ɵɵtext(23, "Down");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "tbody");
        ɵngcc0.ɵɵtemplate(25, BsacModelListSettingsEditorComponent_tr_25_Template, 16, 9, "tr", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 2);
        ɵngcc0.ɵɵelementStart(27, "h3");
        ɵngcc0.ɵɵtext(28, "Filters");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "table", 3);
        ɵngcc0.ɵɵelementStart(30, "thead");
        ɵngcc0.ɵɵelementStart(31, "tr");
        ɵngcc0.ɵɵelementStart(32, "th");
        ɵngcc0.ɵɵtext(33, "Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "th");
        ɵngcc0.ɵɵtext(35, "Desc.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "th");
        ɵngcc0.ɵɵtext(37, "Default");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "th");
        ɵngcc0.ɵɵtext(39, "Allowed");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "th");
        ɵngcc0.ɵɵtext(41, "Order");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "th");
        ɵngcc0.ɵɵtext(43, "Up");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "th");
        ɵngcc0.ɵɵtext(45, "Down");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "tbody");
        ɵngcc0.ɵɵtemplate(47, BsacModelListSettingsEditorComponent_tr_47_Template, 16, 9, "tr", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "div", 1);
        ɵngcc0.ɵɵelementStart(49, "button", 5);
        ɵngcc0.ɵɵlistener("click", function BsacModelListSettingsEditorComponent_Template_button_click_49_listener() { return ctx.export(); });
        ɵngcc0.ɵɵelement(50, "i", 6);
        ɵngcc0.ɵɵtext(51, "Save");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.list.name, "@", ctx.mode, "");
        ɵngcc0.ɵɵadvance(22);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fields);
        ɵngcc0.ɵɵadvance(22);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filters);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf], styles: [".allowed[_ngcontent-%COMP%]{color:#00f}.default[_ngcontent-%COMP%]{color:green}"] });
BsacModelListSettingsEditorComponent.ctorParameters = () => [];
BsacModelListSettingsEditorComponent.propDecorators = {
    list: [{ type: Input }],
    mode: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSettingsEditorComponent, [{
        type: Component,
        args: [{
                selector: "bsac-model-list-settings-editor",
                template: "<div class=\"row\"><div class=\"col-12\"><h2>{{list.name}}@{{mode}}</h2></div><div class=\"col-sm-6\"><h3>Fields</h3><table class=\"table table-condensed table-bordered table-hover\"><thead><tr><th>Field</th><th>Desc.</th><th>Default</th><th>Allowed</th><th>Order</th><th>Up</th><th>Down</th></tr></thead><tbody><tr *ngFor=\"let f of fields; let i = index\" [class.table-success]=\"f.default\" [class.table-primary]=\"!f.default &amp;&amp; f.allowed\"><td> <code>{{f.name}}</code></td><td>{{f.description}}</td><td class=\"pointer\" (click)=\"defaultField(i)\"><i class=\"fa fa-check\" *ngIf=\"f.default\"></i></td><td class=\"pointer\" (click)=\"allowedField(i)\"><i class=\"fa fa-check\" *ngIf=\"f.allowed\"></i></td><td>{{f.order}}</td><td class=\"pointer\" (click)=\"upField(i)\"><i class=\"fa fa-caret-up\"></i></td><td class=\"pointer\" (click)=\"downField(i)\"><i class=\"fa fa-caret-down\"></i></td></tr></tbody></table></div><div class=\"col-sm-6\"><h3>Filters</h3><table class=\"table table-condensed table-bordered table-hover\"><thead><tr><th>Filter</th><th>Desc.</th><th>Default</th><th>Allowed</th><th>Order</th><th>Up</th><th>Down</th></tr></thead><tbody><tr *ngFor=\"let f of filters; let i = index\" [class.table-success]=\"f.default\" [class.table-primary]=\"!f.default &amp;&amp; f.allowed\"><td> <code>{{f.name}}</code></td><td>{{f.description}}</td><td class=\"pointer\" (click)=\"defaultFilter(i)\"><i class=\"fa fa-check\" *ngIf=\"f.default\"></i></td><td class=\"pointer\" (click)=\"allowedFilter(i)\"><i class=\"fa fa-check\" *ngIf=\"f.allowed\"></i></td><td>{{f.order}}</td><td class=\"pointer\" (click)=\"upFilter(i)\"><i class=\"fa fa-caret-up\"></i></td><td class=\"pointer\" (click)=\"downFilter(i)\"><i class=\"fa fa-caret-down\"></i></td></tr></tbody></table></div><div class=\"col-12\"><button class=\"btn btn-primary btn-block\" (click)=\"export()\"><i class=\"fa fa-save mr-2\"></i>Save</button></div></div>",
                styles: [".allowed{color:#00f}.default{color:green}"]
            }]
    }], function () { return []; }, { list: [{
            type: Input
        }], mode: [{
            type: Input
        }] }); })();

class BsacModelListSettingsModule {
}
BsacModelListSettingsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListSettingsModule });
BsacModelListSettingsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListSettingsModule_Factory(t) { return new (t || BsacModelListSettingsModule)(); }, providers: [BsacModelListSettingsService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListSettingsModule, { declarations: function () { return [BsacModelListSettingsEditorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BsacModelListSettingsEditorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListSettingsModule, [{
        type: NgModule,
        args: [{
                declarations: [BsacModelListSettingsEditorComponent],
                exports: [BsacModelListSettingsEditorComponent],
                providers: [BsacModelListSettingsService],
                imports: [
                    CommonModule
                ]
            }]
    }], null, null); })();

class BsacModelListModule {
}
BsacModelListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacModelListModule });
BsacModelListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacModelListModule_Factory(t) { return new (t || BsacModelListModule)(); }, providers: [
        BsacModelListProvider,
        BsacModelListFieldsService,
        NgbPaginationConfig,
    ], imports: [[
            CommonModule,
            NgbModalModule,
            NgbCollapseModule,
            DragDropModule,
            BsacApiConstantsModule,
            BsacMessageModule,
            BsacModelListSettingsModule,
            BsacModelListFilterModule,
            BsacModelListSorterModule,
            BsacModelListPaginatorModule,
            BsacModelListFieldsModule,
            BsacModelListFiltersetModule,
            BsacModelListPersistenceModule
        ], BsacModelListSettingsModule, BsacModelListFilterModule, BsacModelListSorterModule, BsacModelListPaginatorModule, BsacModelListFieldsModule, BsacModelListFiltersetModule, BsacModelListPersistenceModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacModelListModule, { declarations: function () { return [BsacModelListDisplayComponent]; }, imports: function () { return [CommonModule,
        NgbModalModule,
        NgbCollapseModule,
        DragDropModule, BsacApiConstantsModule, BsacMessageModule, BsacModelListSettingsModule, BsacModelListFilterModule, BsacModelListSorterModule, BsacModelListPaginatorModule, BsacModelListFieldsModule, BsacModelListFiltersetModule, BsacModelListPersistenceModule]; }, exports: function () { return [BsacModelListSettingsModule, BsacModelListFilterModule, BsacModelListSorterModule, BsacModelListPaginatorModule, BsacModelListFieldsModule, BsacModelListFiltersetModule, BsacModelListPersistenceModule, BsacModelListDisplayComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacModelListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgbModalModule,
                    NgbCollapseModule,
                    DragDropModule,
                    BsacApiConstantsModule,
                    BsacMessageModule,
                    BsacModelListSettingsModule,
                    BsacModelListFilterModule,
                    BsacModelListSorterModule,
                    BsacModelListPaginatorModule,
                    BsacModelListFieldsModule,
                    BsacModelListFiltersetModule,
                    BsacModelListPersistenceModule
                ],
                providers: [
                    BsacModelListProvider,
                    BsacModelListFieldsService,
                    NgbPaginationConfig,
                ],
                declarations: [
                    BsacModelListDisplayComponent
                ],
                exports: [
                    BsacModelListSettingsModule,
                    BsacModelListFilterModule,
                    BsacModelListSorterModule,
                    BsacModelListPaginatorModule,
                    BsacModelListFieldsModule,
                    BsacModelListFiltersetModule,
                    BsacModelListPersistenceModule,
                    BsacModelListDisplayComponent
                ]
            }]
    }], null, null); })();

const BSAC_MAPS_BAN_PATH = new InjectionToken("bsac.geo.maps.ban.path");
class BsacGeolocBanService {
    constructor(_http, banPath) {
        this._http = _http;
        this.banPath = banPath;
    }
    geocodeAddress(location, region = "fr") {
        const params = {
            q: location,
            limit: "1",
            autocomplete: "0"
        };
        return this._http.get(this.banPath, { params }).pipe(map((res) => {
            if (res.features && res.features.length > 0) {
                return res.features[0];
            }
            else {
                return null;
            }
        }), catchError((_err) => of(null)));
    }
}
BsacGeolocBanService.ɵfac = function BsacGeolocBanService_Factory(t) { return new (t || BsacGeolocBanService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(BSAC_MAPS_BAN_PATH)); };
BsacGeolocBanService.ɵprov = ɵɵdefineInjectable({ factory: function BsacGeolocBanService_Factory() { return new BsacGeolocBanService(ɵɵinject(HttpClient), ɵɵinject(BSAC_MAPS_BAN_PATH)); }, token: BsacGeolocBanService, providedIn: "root" });
BsacGeolocBanService.ctorParameters = () => [
    { type: HttpClient },
    { type: String, decorators: [{ type: Inject, args: [BSAC_MAPS_BAN_PATH,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacGeolocBanService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: String, decorators: [{
                type: Inject,
                args: [BSAC_MAPS_BAN_PATH]
            }] }]; }, null); })();

// TODO: document and fix
/**
 * Live message structure.
 * This should be emitted by live server.
 */
class BsacLiveMessage {
    constructor(data) {
        assign(this, data);
    }
}
class BsacLiveSubscription {
    constructor(identifier, passthrough = false) {
        this.identifier = identifier;
        this.passthrough = passthrough;
        this.emitter = new ReplaySubject(1);
    }
}
const BSAC_SOCKET_IO_CLIENT = new InjectionToken("bsac.live.ioclient");
const BSAC_SOCKET_IO_CONFIG = new InjectionToken("bsac.live.ioconfig");
/**
 * Messages subscriptions / dispatching.
 */
class BsacLiveService {
    constructor(io, _ioconfig, _msg) {
        this.io = io;
        this._ioconfig = _ioconfig;
        this._msg = _msg;
        this._subscriptions = {};
    }
    socket() {
        if (!this._socket) {
            this._socket = this.io(this._ioconfig.url, { path: this._ioconfig.path });
            const cname = this._ioconfig.appId ? this._ioconfig.appId : "clientId";
            this.clientId = sessionStorage.getItem(cname);
            if (!this.clientId) {
                this.clientId = (Math.random() * 100000000).toString();
                sessionStorage.setItem(cname, this.clientId);
            }
            this._socket.emit("clientId", this.clientId);
            this._socket.on("response", (data) => {
                const message = new BsacLiveMessage(JSON.parse(data));
                if (this.processMessage(message)) {
                    this._messages.next(message);
                }
            });
        }
        return this._socket;
    }
    sendMessage(message) {
        // Simple example...
        this._socket.emit("add-message", message);
    }
    processMessage(msg) {
        if (msg.broadcast) {
            this._msg.info(msg.title);
            this._msg.play("notify");
            return false;
        }
        if (this._subscriptions[msg.channel]) {
            this._subscriptions[msg.channel].emitter.next(msg);
            return this._subscriptions[msg.channel].passthrough;
        }
        return msg.public;
    }
    messages$() {
        if (!this._messages) {
            this._messages = new ReplaySubject(1);
            this.socket();
        }
        return this._messages.asObservable();
    }
    close() {
        for (const sub of Object.keys(this._subscriptions)) {
            this._subscriptions[sub].emitter.complete();
        }
        this._subscriptions = {};
        this._messages.complete();
        this.socket().disconnect();
    }
    subscribe(identifier, passthrough = false) {
        if (!this._subscriptions[identifier]) {
            this._subscriptions[identifier] = new BsacLiveSubscription(identifier, passthrough);
            this.socket().emit("subscribe", { clientId: this.clientId, channelId: identifier });
        }
        return this._subscriptions[identifier].emitter.asObservable();
    }
    unsubscribe(identifier, distant = false) {
        if (distant) {
            this.socket().emit("unsubscribe", { clientId: this.clientId, channelId: identifier });
        }
        delete this._subscriptions[identifier];
    }
}
BsacLiveService.ɵfac = function BsacLiveService_Factory(t) { return new (t || BsacLiveService)(ɵngcc0.ɵɵinject(BSAC_SOCKET_IO_CLIENT), ɵngcc0.ɵɵinject(BSAC_SOCKET_IO_CONFIG), ɵngcc0.ɵɵinject(BsacMessageService)); };
BsacLiveService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BsacLiveService, factory: BsacLiveService.ɵfac });
BsacLiveService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [BSAC_SOCKET_IO_CLIENT,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [BSAC_SOCKET_IO_CONFIG,] }] },
    { type: BsacMessageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacLiveService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [BSAC_SOCKET_IO_CLIENT]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [BSAC_SOCKET_IO_CONFIG]
            }] }, { type: BsacMessageService }]; }, null); })();

class BsacMessageDisplay {
    constructor(message) {
        this.hidden = false;
        this.muted = false;
        this.closed = false;
        this.channel = message.channel;
        this.message = message;
    }
    close() {
        this.closed = true;
    }
}
class BsacLiveZoneComponent {
    constructor(live, msg) {
        this.live = live;
        this.msg = msg;
        this._messages = {};
        this.cnx = this.live.messages$().subscribe((message) => {
            if (!this._messages[message.channel]) {
                this._messages[message.channel] = new BsacMessageDisplay(message);
            }
            this._messages[message.channel].message = message;
        });
    }
    get todisplay() {
        const out = [];
        for (const chan of Object.keys(this._messages)) {
            const msg = this._messages[chan];
            // TODO: add messages visibility
            if (!msg.closed) {
                out.push(this._messages[chan]);
            }
        }
        return out;
    }
    ngOnDestroy() {
        this.cnx.unsubscribe();
    }
}
BsacLiveZoneComponent.ɵfac = function BsacLiveZoneComponent_Factory(t) { return new (t || BsacLiveZoneComponent)(ɵngcc0.ɵɵdirectiveInject(BsacLiveService), ɵngcc0.ɵɵdirectiveInject(BsacMessageService)); };
BsacLiveZoneComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BsacLiveZoneComponent, selectors: [["bsac-live-zone"]], decls: 1, vars: 1, consts: [["class", "messagezone", 4, "ngIf"], [1, "messagezone"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "fa", "fa-close", "fa-s", "pointer", 3, "click"], ["type", "info", 3, "value", "max"], [1, "pretrace"]], template: function BsacLiveZoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BsacLiveZoneComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.todisplay.length > 0);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc4.NgbProgressbar], pipes: [ɵngcc1.JsonPipe], styles: [""] });
BsacLiveZoneComponent.ctorParameters = () => [
    { type: BsacLiveService },
    { type: BsacMessageService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacLiveZoneComponent, [{
        type: Component,
        args: [{
                selector: "bsac-live-zone",
                template: "<div class=\"messagezone\" *ngIf=\"todisplay.length &gt; 0\"><div *ngFor=\"let md of todisplay\"><div *ngIf=\"md.message.type=='progress'\"><div><i class=\"fa fa-close fa-s pointer\" (click)=\"md.close()\"></i>{{md.message.title}}<ngb-progressbar type=\"info\" [value]=\"md.message.data.done\" [max]=\"md.message.data.total\"></ngb-progressbar></div></div><div *ngIf=\"md.message.type != 'progress'\"><i class=\"fa fa-close fa-s pointer\" (click)=\"md.close()\"></i>{{md.message.title}}<div class=\"pretrace\">{{md.message.data|json}}</div></div></div></div>",
                styles: [""]
            }]
    }], function () { return [{ type: BsacLiveService }, { type: BsacMessageService }]; }, null); })();

class BsacLiveModule {
}
BsacLiveModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BsacLiveModule });
BsacLiveModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BsacLiveModule_Factory(t) { return new (t || BsacLiveModule)(); }, providers: [BsacLiveService], imports: [[
            CommonModule,
            NgbModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BsacLiveModule, { declarations: function () { return [BsacLiveZoneComponent]; }, imports: function () { return [CommonModule,
        NgbModule]; }, exports: function () { return [BsacLiveZoneComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BsacLiveModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NgbModule
                ],
                providers: [BsacLiveService],
                declarations: [BsacLiveZoneComponent],
                exports: [BsacLiveZoneComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of bsadmincomponents
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BSAC_API_CONSTANTS_HEADERS, BSAC_API_CONSTANTS_TRANSFORM, BSAC_API_CONSTANTS_URL, BSAC_DATETIME_NATIVE, BSAC_I18N_DEFAULT_LANGUAGE, BSAC_I18N_INVALID_TRANSLATION_STATUSES, BSAC_I18N_LANGUAGES, BSAC_I18N_TRANSLATION_STATUSES, BSAC_I18N_VALID_TRANSLATION_STATUSES, BSAC_I18N_WARNING_TRANSLATION_STATUSES, BSAC_ISSUE_CONFIG, BSAC_MAPS_BAN_PATH, BSAC_MAPS_GMAPS_API_KEY, BSAC_MAPS_GMAPS_API_LOADER, BSAC_MESSAGE_SOUNDS, BSAC_MODEL_LIST_PERSISTENCE, BSAC_SETTINGS_SERVICE, BSAC_SOCKET_IO_CLIENT, BSAC_SOCKET_IO_CONFIG, BsacApiConstantsModule, BsacApiConstantsService, BsacDevModule, BsacFilterSetService, BsacFormatModule, BsacFormsModule, BsacGeoModule, BsacGeolocBanService, BsacGeolocGmapsService, BsacGeolocService, BsacI18nModule, BsacI18nService, BsacLiveMessage, BsacLiveModule, BsacLiveService, BsacLiveSubscription, BsacMessageModule, BsacMessageService, BsacModelField, BsacModelList, BsacModelListFields, BsacModelListFieldsService, BsacModelListFilterService, BsacModelListLocalStoragePersistenceService, BsacModelListModule, BsacModelListPaginatorService, BsacModelListPersistence, BsacModelListProvider, BsacModelListSettingsService, BsacModelListSorterService, BsacUtilsModule, DEFAULT_TIMEOUTS, FilterData, FilterValue, Message, PaginationData, STATUS, SorterData, bsacApplyMixins, BsacIssueComponent as ɵa, BsacVersionComponent as ɵb, BsacModelListFilterModule as ɵba, BsacGeoStaticGmapComponent as ɵbb, BsacModelListAutocompleteFilterComponent as ɵbc, BsacModelListMetaFilterComponent as ɵbd, BsacModelListSelectFilterComponent as ɵbe, BsacModelListTextFilterComponent as ɵbf, BsacModelListValueFilterComponent as ɵbg, BsacModelListFlagsFilterComponent as ɵbh, BsacModelListGeodistanceFilterComponent as ɵbi, BsacModelListMultiselectFilterComponent as ɵbj, BsacModelListMultiautocompleteFilterComponent as ɵbk, BsacModelListDatetimeFilterComponent as ɵbl, BsacModelListDatetimerangeFilterComponent as ɵbm, BsacModelListSorterModule as ɵbn, BsacModelListSorterComponent as ɵbo, BsacModelListPaginatorModule as ɵbp, BsacModelListPaginatorComponent as ɵbq, BsacModelListFieldsModule as ɵbr, ModelListFieldsSelectComponent as ɵbs, BsacModelListFiltersetModule as ɵbt, BsacFilterSetComponent as ɵbu, BsacFilterSetItemDirective as ɵbv, BsacModelListFiltersetSelectComponent as ɵbw, BsacFilterSetGroupDirective as ɵbx, BsacModelListPersistenceModule as ɵby, BsacModelListPersistenceSaveComponent as ɵbz, BsacNativeInvokeService as ɵc, BsacModelListPersistenceLoadComponent as ɵca, BsacModelListDisplayComponent as ɵcb, BsacLiveZoneComponent as ɵcc, BsacAutoFocusDirective as ɵd, BsacBreadcrumbComponent as ɵe, BsacFormatTrimPipe as ɵf, BsacFormatPricePipe as ɵg, BsacFormatIPricePipe as ɵh, BsacFormatNotePipe as ɵi, BsacFormatIdPipe as ɵj, BsacFormatRefPipe as ɵk, BsacMessagesZoneComponent as ɵl, BsacApiConstantPipe as ɵm, BsacApiConstantSinglePipe as ɵn, BsacI18nComponent as ɵo, BsacI18nEditorComponent as ɵp, BsacDdFieldComponent as ɵq, BsacFlagsFieldComponent as ɵr, BsacM2mFieldComponent as ɵs, BsacDatetimeInputComponent as ɵt, FrenchDateFormatter as ɵu, BsacFieldControlComponent as ɵv, BsacSelectRelatedComponent as ɵw, BsacDecimalInputComponent as ɵx, BsacModelListSettingsModule as ɵy, BsacModelListSettingsEditorComponent as ɵz };

//# sourceMappingURL=solidev-bsadmincomponents.js.map